// en
export const locale = {
  lang: 'en-US',
  data: {
    privateNumberShahkar: {
      title: 'Shahkar information',
      realTitle: 'Real person information',
      legalTitle: 'Legal organization and representative information',
      requiredDescription: 'Register your Shahkar information before continuing with your first number purchase.',
      optionalDescription: 'You can edit your Shahkar information or continue without changes.',
      loading: 'Loading information…',
      loadFailed: 'Information could not be loaded. Please try again.',
      retry: 'Retry',
      invalidField: 'Enter a valid value.',
      saveAndContinue: 'Save and continue',
      skip: 'Continue without changes',
      cancel: 'Cancel purchase',
      legends: {
        representativeInformation: 'Organization representative information',
        companyInformation: 'Company information',
        contactInformation: 'Contact information and address',
      },
      fields: {
        firstName: 'First name',
        lastName: 'Last name',
        fatherName: 'Father’s name',
        identificationType: 'Identification type',
        identificationNo: 'Identification number',
        mobile: 'Mobile number',
        birthCertNo: 'Birth certificate number',
        birthDate: 'Date of birth',
        birthPlace: 'Place of birth',
        gender: 'Gender',
        economicNo: 'Economic code',
        corporateNo: 'Company national ID',
        companyName: 'Company name',
        companyType: 'Company type',
        companyRegDate: 'Company registration date',
        address: 'Address',
        provinceCode: 'Province code',
        provinceName: 'Province',
        cityName: 'City',
        street: 'Street',
        houseNumber: 'House number',
        phone: 'Phone number',
        email: 'Email',
        zipCode: 'Postal code',
        universalNo: 'Universal number',
      },
      options: {
        nationalCode: 'National code',
        passport: 'Passport',
        refugeeCard: 'Refugee card',
        amayeshCard: 'Amayesh card',
        identityCard: 'Identity profile',
        male: 'Male',
        female: 'Female',
        PublicStock: 'Public joint stock',
        PrivateEquity: 'Private joint stock',
        LimitedLiability: 'Limited liability',
        Collaborative: 'Partnership',
        NonJointStockMix: 'Mixed non-stock',
        JointStockMix: 'Mixed stock',
        Relative: 'Proportional partnership',
        Cooperative: 'Cooperative',
        Governmental: 'Governmental',
        Ministry: 'Ministry',
        Embassy: 'Embassy',
        Mosque: 'Mosque',
        School: 'School',
        Ngo: 'Non-governmental organization',
      },
    },
    proformaInvoice: {
      title: 'Proforma invoice',
      documentKicker: 'Official payment document',
      number: 'Proforma number',
      invoiceDate: 'Invoice date',
      status: 'Status',
      awaitingPayment: 'Awaiting payment',
      seller: 'Seller details',
      customer: 'Customer details',
      personName: 'Name of natural/legal person',
      economicNumber: 'Economic number',
      registrationOrNationalNumber: 'Registration / national number',
      province: 'Province',
      county: 'County',
      postalCode: 'Postal code',
      city: 'City',
      address: 'Address',
      phone: 'Phone',
      itemsCaption: 'Goods and services',
      row: 'Row',
      description: 'Description',
      count: 'Quantity',
      unitPrice: 'Unit price',
      discount: 'Discount',
      tax: 'Tax',
      total: 'Total',
      grandTotalInWords: 'Grand total in Persian words',
      grandTotal: 'Grand total',
      noItems: 'No line items are available.',
      gateway: 'Payment gateway',
      bank: 'Bank',
      accountNumber: 'Account number',
      subtotal: 'Subtotal',
      totalAfterDiscount: 'Total after discount',
      payableAmount: 'Payable amount',
      rial: 'Rial',
      sellerStamp: 'Seller stamp and signature',
      customerStamp: 'Customer stamp and signature',
      legalNote:
        'This document is a proforma invoice and has no independent tax or accounting value.',
      allAmountsInRials: 'All amounts are in rials.',
      validityNote: 'The proforma invoice is valid for 48 hours.',
      createAndReview: 'Create and review proforma',
      createdTitle: 'Your proforma invoice is ready',
      existingTitle: 'Your active proforma invoice',
      onlyOneActive:
        'Only one active proforma invoice can be held at a time. Review it before continuing to payment.',
      view: 'View document',
      print: 'Print',
      downloadPdf: 'Download PDF',
      payNow: 'Proceed to payment',
      cancelProforma: 'Cancel proforma',
      loading: 'Loading proforma invoice',
      loadFailedTitle: 'The proforma could not be loaded',
      loadFailed:
        'Your proforma number is preserved. Try loading its details again without creating a new one.',
      createFailed: 'The proforma invoice could not be created.',
      cancelFailed: 'The proforma invoice could not be canceled.',
      cancelSucceed: 'The proforma invoice was canceled successfully.',
      paymentFailed: 'The payment could not be started.',
      paymentDataUnavailable:
        'The saved payment details are missing or invalid. Contact support before retrying.',
      pdfFailed: 'The PDF file could not be created.',
      cancelConfirmTitle: 'Cancel proforma invoice',
      cancelConfirmMessage:
        'Are you sure you want to cancel this proforma invoice?',
      popupBlocked:
        'Your browser blocked the new tab. Allow pop-ups and try again.',
      invalidIdTitle: 'Invalid proforma link',
      invalidId: 'The proforma number in this link is not valid.',
      backToPanel: 'Back to panel',
      walletAlt: 'Wallet',
    },
    appName: 'App name',
    layout: {
      footer: {
        aboutUs: 'About us',
        contactUs: 'Contact us',
        support: 'Support',
      },
      asideMenu: {
        Dashboard: 'Dashboard',
        Infrastructure: 'Infrastructure',
        SystemManagement: 'System management',
        SendingSystem: 'Sending system',
        Configuration: 'Configuration',
        SmsReports: 'SMS reports',
        Facility: 'Facility',
        Financial: 'Financial',
        Phonebook: 'Phonebook',
        Setting: 'Setting',
        Services: 'Services',
        whiteMessages: 'White messages',
      },
    },
    pages: {
      buyNumber: {
        title: 'Buy a private number',
      },
      privateNumberBuy: {
        checkout: {
          title: 'Private number checkout',
          remaining: 'Reservation time remaining',
          expired: 'This reservation has expired.',
          selectedNumber: 'Selected number',
          identifier: 'Number ID',
          rondRules: 'Number patterns',
        },
        featuresTitle: 'Number features',
        rondStatusTitle: 'Rond status',
        title: 'Buy a private number',
        storeTitle: 'Number store',
        loadingMore: 'Loading more numbers...',
        loadMoreError: 'More numbers could not be loaded.',
        loadError: 'Private numbers could not be loaded.',
        retry: 'Try again',
        numberLabel: 'Number',
        showFullNumber: 'Show full number',
        subtitle: 'Find and choose the right number for your business.',
        search: 'Search phone number',
        clearFilters: 'Clear filters',
        all: 'All numbers',
        available: 'Available to buy',
        compare: 'Compare',
        backToNumbers: 'Back to numbers',
        confirmComparison: 'Compare the two selected numbers now?',
        selected: 'Selected number',
        clear: 'Clear selection',
        price: 'Purchase price',
        renewal: 'Annual renewal',
        maintenance: 'Maintenance cost',
        pattern: 'Number pattern',
        digits: 'Digits',
        digitsValue: '{{count}}-digit',
        digitUnit: 'digits',
        linkSending: 'Link sending',
        enabled: 'Enabled',
        disabled: 'Disabled',
        sendTypesLabel: 'Send methods',
        none: 'None',
        headline: 'Headline',
        sendTypes: {
          single: 'Single',
          phonebook: 'Phonebook',
          bulk: 'Bulk',
          dynamic: 'Dynamic',
          p2p: 'P2P',
          smart: 'Smart',
          apiSingle: 'Single API',
          apiP2P: 'P2P API',
          otp: 'OTP',
          club: 'Club',
          bulk2: 'Bulk',
          occasionPhonebook: 'Occasion phonebook',
          smartP2P: 'Smart P2P',
          device: 'Device',
          p2pOtp: 'P2P OTP',
        },
        action: 'Reserve for 15 minutes',
        requestPrice: 'Request a quote',
        unavailablePrice: 'Price on request',
        noResults: 'No numbers match your search.',
        compareHint: 'Select up to 3 numbers to compare.',
        compareCount: 'of 3 selected',
        compareTitle: 'Compare selected numbers',
        compareDescription: 'Review features and costs side by side.',
        selectAnother: 'Select another number to start comparing.',
        currencyUnit: 'Rial',
        noCost: 'No fee',
        bestPrice: 'Best price',
        numberIndex: 'Option {{index}}',
        removeFromCompare: 'Remove from comparison',
        threeYearCost: 'Maintenance (3 years)',
        limitReached: 'You can compare up to 3 numbers.',
        badges: {
          lucky: 'Premium',
          semiRound: 'Semi-round',
          link: 'Link',
          receive: 'Inbound',
          golden: 'Golden',
          nonLucky: 'Not rond',
          ordinary: 'Regular',
        },
      },
      imagePicker: {
        title: 'Select image',
        uploadImage: 'Upload image',
        backToGallery: 'Back to gallery',
        availableImages: 'Available images',
        imageCount: '{{count}} images in gallery',
        searchPlaceholder: 'Search images ...',
        imageTitle: 'Image title',
        uploadGuide:
          'Enter an image title, then select a JPG, PNG, or WEBP file up to 10 MB.',
        titleRequired: 'Image title is required.',
        titleMaxLength: 'Image title cannot exceed 32 characters.',
        loadError: 'Images could not be loaded.',
        retry: 'Try again',
        empty: 'No images found.',
        dropTitle: 'Drag and drop your files here',
        dropDescription: 'Or use the button below to choose a file',
        chooseFiles: 'Choose file',
        allowedFormats: 'Allowed formats: JPG, PNG, WEBP',
        maxSize: 'Maximum file size: 10 MB',
        invalidType: 'Only JPG, PNG, and WEBP files are allowed.',
        fileTooLarge: 'The file size must not exceed 10 MB.',
        uploadFailed: 'The image could not be uploaded. Try again.',
        selectImage: 'Select image',
        previous: 'Previous',
        next: 'Next',
      },
      fileAttachments: {
        title: 'Image library',
        searchPlaceholder: 'Search images ...',
        fromDate: 'From date',
        toDate: 'To date',
        gridView: 'Grid view',
        listView: 'List view',
        emptyTitle: 'No images found',
        emptyDescription: 'Try searching for another file or phrase.',
        clearFilters: 'Clear filters',
        loadError: 'Images could not be loaded.',
        retry: 'Try again',
        loadingMore: 'Loading more images...',
        loadMoreError: 'More images could not be loaded.',
        scrollForMore: 'Scroll down to view more images',
        showing: 'Showing {{from}} to {{to}} of {{total}} items',
        itemsPerPage: 'Items per page',
        previous: 'Previous',
        next: 'Next',
        imageAlt: '{{name}} image',
        editTitle: 'Edit image title',
        imageTitle: 'Image title',
        titleRequired: 'Image title is required.',
        titleMaxLength: 'Image title cannot exceed 32 characters.',
        copyLink: 'Copy link',
        linkCopied: 'Image link copied.',
        viewImage: 'View image',
        addImage: 'Add image',
      },
      authorizationUpgrade: {
        title: 'Authorization level upgrade',
        eyebrow: 'Identity and account verification',
        currentLevel: 'Current level',
        currentLevelStatement: 'Your current authorization level is',
        indicatorLabel: 'Authorization level indicator',
        levelWizardTitle: 'Authorization level path',
        nextStepTitle: 'What does the next level enable?',
        upgradeAction: 'Upgrade level',
        upgradeActions: {
          0: 'Upgrade to Nexus',
          1: 'Upgrade to Keyhan',
          2: 'Request Enterprise — support will contact you',
        },
        actions: {
          continue: 'Continue',
          previous: 'Previous',
          tryAgain: 'Try again',
          remove: 'Remove',
        },
        progressLabel: 'Authorization level progress',
        mobileProgress: { current: 'Current', next: 'Next' },
        levels: {
          0: 'Alpha',
          1: 'Nexus',
          2: 'Keyhan',
          3: 'Enterprise',
        },
        levelHints: {
          0: 'Complete your personal or legal information to reach Nexus.',
          1: 'Upload the required identity documents to reach Keyhan.',
          2: 'Submit an enterprise request for contractual and financial review.',
          3: 'Your account has reached the highest authorization level.',
        },
        profileHints: {
          0: 'Complete your information to unlock plans and more services.',
          1: 'Upload your identity documents for the next level.',
          2: 'Enterprise verification is available for your account.',
          3: 'All authorization capabilities are available.',
        },
        profileBenefits: {
          0: 'Completing identity information enables plan purchase and access to more panel services.',
          1: 'Document verification strengthens your account identity and unlocks Keyhan-level capabilities.',
          2: 'Submit the request and support will contact you to coordinate contracts, guarantees, and financial requirements.',
        },
        steps: {
          organizationType: 'Account type',
          additionalInformation: 'Additional information',
        },
        organizationType: {
          title: 'Choose your account type',
          description:
            'This choice determines the required information and cannot be changed after verification.',
          real: 'Individual',
          realHint: 'For personal activity under your own identity.',
          legal: 'Legal organization',
          legalHint: 'For companies and registered organizations.',
          selected: 'Selected account type',
        },
        information: {
          title: 'Complete required information',
          description:
            'Enter the information carefully; it will be used during identity verification.',
          manager: 'Manager information',
          organization: 'Organization information',
        },
        fields: {
          gender: 'Gender',
          identificationType: 'Identification type',
          identityNumber: 'Identification number',
          isForeigner: 'I am a foreign national',
          organizationForeigner: 'The organization is foreign',
          economicCode: 'Economic code',
          ceoName: 'CEO name',
          ceoMobile: 'CEO mobile',
          ceoNationalCode: 'CEO national code',
        },
        gender: { man: 'Male', woman: 'Female' },
        identification: {
          nationalCode: 'National code',
          passport: 'Passport',
          asylumCard: 'Asylum card',
          amayeshCard: 'Amayesh card',
          identityProfile: 'Identity profile',
        },
        submitInformation: 'Submit information',
        loadError:
          'The required information could not be loaded. Please try again.',
        digitalContract: {
          title: 'Sign the service usage contract',
          subtitle:
            'To submit the verification request, first read the terms of service and sign the contract digitally.',
          steps: {
            terms: 'Read the terms',
            sign: 'Sign the contract',
          },
          acceptTerms: 'Accept terms and continue',
          otpTitle: 'Contract signature verification code',
          otpDescription:
            'A verification code for signing the contract has been sent to {{mobile}}. Please enter it.',
          otpHint:
            'By entering the 6-digit code, the contract will be digitally signed and your signature will be recorded in the system.',
          resend: 'Resend code',
          signContract: 'Sign and submit contract',
          backToTerms: 'Back to terms',
          submitBeforeSign: 'Sign contract & submit',
        },
        documents: {
          title: 'Upload verification documents',
          description:
            'Upload clear, readable files. Images are reviewed automatically when the verification service is available.',
          required: 'required documents',
          empty: 'There are no documents waiting to be uploaded.',
          defaultHint: 'Upload a clear image showing all document details.',
          choose: 'Choose or drop a file',
          noFile: 'No file selected',
          selectFile: 'Select file for',
          formats: 'JPG or PNG · Maximum 5 MB',
          preview: 'Preview file',
          remaining: '{{count}} required document(s) still need a file.',
          remainingReupload: '{{count}} document(s) must be uploaded again.',
          remainingBoth:
            '{{count}} required document(s) still need a file and {{reuploadCount}} document(s) must be uploaded again.',
          submit: 'Submit documents',
          userGroupTitle: 'User identity documents',
          userGroupDescription:
            'Evidence related to the account holder and personal identity.',
          organizationGroupTitle: 'Organization documents',
          organizationGroupDescription:
            'Legal and registration evidence related to the organization.',
          groupCount: 'documents',
          errors: {
            type: 'Only JPG and PNG files are supported.',
            size: 'The file must be no larger than 5 MB.',
          },
          user: {
            1: 'National card',
            2: 'Birth certificate',
            3: 'Business license',
          },
          organization: {
            1: 'Business license',
            2: 'Company establishment notice',
            3: 'Latest company changes notice',
            4: "CEO's national card",
            5: "CEO's birth certificate",
          },
        },
        documentStatus: {
          pending: 'Pending review',
          accepted: 'Accepted',
          rejected: 'Rejected — retry',
          nothingUploaded: 'Not uploaded',
        },
        enterprise: {
          title: 'Request Enterprise authorization',
          description:
            'After submitting, our support team will contact you to coordinate contracts, guarantees, and financial requirements.',
          steps: {
            1: 'Submit your request',
            2: 'Support and legal review',
            3: 'Contract approval and upgrade',
          },
          submit: 'Submit enterprise request',
          confirmTitle: 'Request Enterprise authorization',
          confirmContent:
            'Are you sure you want to upgrade your account to the Enterprise level? After submitting the request, our support team will contact you to coordinate contracts and financial matters.',
          pendingTitle: 'Your request was submitted',
          pendingDescription:
            'The support team will review it and contact you. A duplicate request is not needed.',
          requestSubmittedTitle: 'Your request was submitted successfully',
          requestSubmittedMessage:
            'Once your information is approved and your level is upgraded, you will need to purchase a suitable plan to continue using the panel.',
        },
        completed: {
          title: 'Enterprise authorization is active',
          description:
            'You have reached the highest authorization level and no further upgrade is required.',
        },
        planGuard: {
          title: 'Authorization upgrade required',
          description:
            'Purchasing or upgrading a plan requires at least level 2 (Nexus). Upgrade your authorization level first.',
        },
      },
      authorizationReview: {
        action: 'Review authorization request',
        informationTitle: 'Review user information',
        documentsTitle: 'Review user documents',
        eyebrow: 'Authorization verification dossier',
        informationHeading: 'Additional information review',
        documentsHeading: 'Uploaded evidence review',
        informationDescription:
          'Compare the submitted identity and organization information before confirming the next authorization level.',
        documentsDescription:
          'Review the user and organization documents separately before approving the next level. If a document is not approved, simply change its status so the issue is communicated to the user once saved.',
        userId: 'User ID',
        userName: 'Username',
        personalInformation: 'Personal information',
        personalInformationHint:
          'Identity and contact details submitted by the user.',
        organizationInformation: 'Organization information',
        organizationInformationHint:
          'Registration and contact details submitted for the legal organization.',
        userDocuments: 'User documents',
        userDocumentsHint: 'Identity evidence belonging to the account holder.',
        organizationDocuments: 'Organization documents',
        organizationDocumentsHint:
          'Registration and legal evidence belonging to the organization.',
        emptyInformation:
          'No submitted additional information was returned for this user.',
        emptyDocuments: 'No uploaded documents were returned for this user.',
        loadError: 'The authorization request could not be loaded.',
        confirmHint:
          'Confirm only after checking all submitted details and evidence.',
        confirmDocumentsHint:
          'Save each document status with its own card button. Once every document is approved, authenticate the user.',
        statusSelect: 'Document status',
        documentDescription: 'Description',
        documentDescriptionPlaceholder:
          'Note or reason related to this document...',
        openPdf: 'Open PDF file',
        fields: { gender: 'Gender' },
        values: { yes: 'Yes', no: 'No' },
        actions: {
          confirm: 'Confirm and upgrade user',
          saveStatus: 'Save status',
          confirmAndUpgrade: 'Confirm documents & upgrade level',
          view: 'View document',
        },
        confirmDialog: {
          title: 'Confirm authorization request',
          information:
            'Are you sure the submitted user information is valid and should be confirmed?',
          documents:
            'Are you sure the uploaded documents are valid and should be confirmed?',
          confirmDocuments:
            'Are you sure you want to authenticate and upgrade this user level?',
          verifyDocuments:
            'Are you sure all of the user documents are approved? Once submitted, the user will be authenticated.',
        },
      },
      enterpriseRequests: {
        title: 'Enterprise Requests',
        confirm: 'Confirm enterprise request',
        reject: 'Reject enterprise request',
        fields: {
          organizationId: 'Organization ID',
          status: 'Status',
          confirmedByUserName: 'Confirmed by',
          confirmTime: 'Confirmation time',
          rejectedUserName: 'Rejected by',
          rejectTime: 'Rejection time',
          rejectionReason: 'Rejection reason',
        },
      },
      dashboard: {
        dailyCountChart: {
          dailySentMessageStatistics: 'Daily sent message statistics',
          lastTenDaysSentMessagesCount: 'Last ten days sent messages count',
          allCount: 'All count',
          sentCount: 'Sent count',
        },
        dailyTypeChart: {
          dailySentMessageWithTypeStatistics:
            'Daily SMS sending statistics by SMS type',
          lastTenDaysSentMessagesCountByType:
            'The number of messages sent in the last ten days by message type',
        },
        latestInformations: {
          latestNews: 'Latest news',
        },
        percentChart: {
          sentMessages: 'Sent messages',
          sentMessagesWithPercent:
            'The chart below shows the percentage of SMS sent based on the type of sending',
          SentMessagesPercent: 'Sent messages percent',
          sent: 'Sent',
          notSent: 'Not sent',
          all: 'All',
          sendType: 'Send Type',
          sentPercent: 'Sent percentage',
        },
        systemStatistics: {
          organizationInformations: 'Organ info',
          balance: 'Balance',
          lastloginTime: 'Last login time',
          lastloginIP: 'Last login ip',
        },
        todayStatistics: {
          sentSmsStatisticsWithType:
            'The statistics below show the number of last ten days text messages sent based on the type of sending.',
          sentMessages: 'Last ten days sent messages',
        },
      },
      shared: {
        helpPage: {
          menuGuide: 'Menu guide',
        },
        editSendReceiversDeliveryStatus: {
          clickHereToGetASampleFile:
            'To get the sample file <a class="font-bold cursor-pointer text-blue-500 dark:text-blue-400" href="/assets/media/sample/sample.xlsx" download="sampleMobiles. xlsx " id="linkIdSampleMobiles">click here</a>.',
        },
        outboxMessagesDetail: {},
        outboxMessagesSendBulkDetail: {},
      },
      infrastructure: {
        setting: {
          settingForm: {
            ifNumberIsNotServiceSmsWillNotBeSentToBlackList:
              'If the selected line is not a service, <br /> SMS will not be sent to phone numbers that are in the black list.',
          },
        },
        privateNumbers: {
          privateNumbersForm: {
            oneOfTheNumbers1To9: 'One of the numbers 1 to 9',
            twoTo11Times0To9: '2 to 11 times 0 to 9',
            threeTo11Times0To9: '3 to 11 times 0 to 9',
            maximum9Times: 'Maximum 9 times?',
          },
        },
        menus: {
          menusForm: {
            downloadVideo:
              '<a target="_blank" href="{{fileUrl}}">Download video</a>',
            downloadPDF:
              '<a target="_blank" href="{{fileUrl}}">Download PDF</a>',
            downloadFile:
              '<a target="_blank" href="{{fileUrl}}">Download File</a>',
          },
        },
      },
      facility: {
        phonebook: {
          fromIndex:
            '"From index" should not be more than "number of contacts"',
          count: '"Number" should not be more than "Number of contacts"',
          both: 'Indexing is wrong',
        },
      },
      sendingSystem: {
        fastSendSmsPatternByPhonebook: {
          youAreOnlyAbleToSelectTheSMSTemplateAndYouCannotChangeTheTextOfTheMessage:
            'Note that you can only choose the SMS template and you cannot change the text of the message manually.',
          toSetTheSMSTextClickOnTheSMSTemplateButtonThenChooseYourSMStemplate:
            'To set SMS text on <b class="text-primary"> SMS template key </b><i class="mdi mdi-text-box-plus-outline text-primary mx-1 mdi-20px">< Click /i> then select your SMS template <b class="!text-violet-600 font-semibold"> </b>',
        },
        sendBulkSms: {
          chooseAreaAndSetFilters:
            'At first, you should choose which areas you want to send SMS to and with which filters in the <b class="text-foreground font-black"> sending range </b> section. Note that you must specify at least one province and the type of SIM cards to which the SMS is to be sent',
          calculateNumbers:
            'After setting the filters you need from the section <b class="text-foreground font-black"> send details </b> once click on the button <b class="app-badge app-badge-success rounded-[3px]"> calculate total count <i class="mdi mdi-calculator mdi-18px text-white"></i> </b>',
          chooseNumbersCount:
            'Then, in the section <b class="text-foreground font-black"> send details </b> specify how many numbers you want to send from the second row',
          addAreaToList:
            'In the last step, the area and filters you want will be added to the final list by clicking the button <b class="app-badge app-badge-navyBlue rounded-[3px]"> Add <i class="mdi mdi-plus-thick mdi-18px"></i> </b>. You can do this for multiple regions',
          clickOnNext:
            'Finally, by clicking the <b class="text-foreground font-black"> next step </b> button, you will be transferred to SMS settings and how to send it.',
          models: {},
        },
        sendP2PSms: {
          createExcel:
            'With this service, you will be able to personalize the sent text for each mobile number. For this, it is enough to create an excel file and include the columns containing the information in it. It should be noted that the Excel file can contain different columns and you can adjust the SMS text according to the text columns. Please note that the first line of the Excel file is not read, so you can use it to insert the title.',
          tipsForExcelTable:
            'The title of the columns must be of text type, with English letters and no spaces.',
          sendWithDuplicateNumbersMsg:
            'The name of the table where the numbers are located must be Sheet1 and the column titles must be Text type, with English letters and no spaces',
        },
        sendSmartSmsConfirmRequest: {},
        sendBalkSms: {
          yourSendingIsInUpdateStatus:
            'Dear user, please note that your submission has been stopped and is in<b class="text-red-500 dark:text-red-400">updating</b> status. In order to continue the submission process, editing is required.',
        },
        base: {
          baseSendSMS: {
            message:
              'Dear user, please note that your submission has been stopped and is in<b class="text-red-500 dark:text-red-400">Updating</b> status. In order to continue the sending process, editing is required',
          },
        },
        sendSmartSmsCreateRequest: {
          sendSmartSmsAdvanceSearch: {
            searchInPeronalPlaces: 'Search in peronal places',
            personal: 'Personal',
            category: 'Category',
            publicSearch: 'Public search',
            public: 'Public',
            selectedListPublic: 'Selected public places',
            selectedListPersonal: 'Selected personal places',
          },
        },
      },
      systemManagement: {
        organizations: {
          organizationDeleteConfirmDialog:
            'All users of the organization that is deleted will also be deleted',
          justDeleteOrgan: 'Just delete the organization',
          deleteOrganAndSubsets:
            'Delete the organization and all subcategories',
          organizationsAuthenticationForm: {
            maxSizeIs200kb:
              'The maximum size of each file should not exceed 200 KB',
          },
        },
        users: {
          userForm: {
            changeNumber: 'Change number',
            changeNumberAndAuthenticate: 'Change number and authenticate',
            confirmed: 'Confirmed',
            notConfirmed: 'Not confirmed',
            userAuthMobile: {
              enterVerificationCode:
                'Enter the verification code sent to the mobile number<b class="text-blue-500 dark:text-blue-400">{{mobile}}</b>',
            },
          },
          userPersonalInfo: {
            userPersonalInfoForm: {
              editPersonalInfo: 'Edit personal information',
              submitPersonalInfo: 'Registration of personal information',
            },
          },
        },
      },
      register: {
        form: {
          fields: {
            isRealPerson: 'Is real person?',
            name: 'Name',
            organName: 'Organ name',
            nationalId: 'National id',
            economicCode: 'Economic code',
            ceoName: 'Ceo name',
            ceoMobile: 'Ceo mobile',
            ceoNationalCode: 'Ceo national code',
            isForeigner: 'Is foreigner',
          },
          legends: {
            organizationInfo: '{{type}} Organization info',
            UserInfo: 'User info',
          },
          messages: {
            organizationDescription:
              'Dear user, to complete the registration process, it is necessary to enter the details of your {{type}} organization in the form below',
            userDescription:
              'Dear user, in order to finalize the registration process, it is necessary to enter your user details in the form below',
          },
        },
      },
      blackList: {
        title: 'Blacklist',
        form: {
          addTitle: 'Add to blacklist',
        },
      },
      sensitiveWords: {
        title: 'Sensitive words',
        form: {
          addTitle: 'Add sensitive word',
          editTitle: 'Edit sensitive word',
        },
      },
      organizationNotificationSettingKeyManagements: {
        title: 'Organization notification setting key managements',
      },
      userNotificationSettingKeyManagements: {
        title: 'User notification setting key managements',
      },
      customerDomains: {
        title: 'Customer domains',
        domainConfigurations: 'Domain configurations',
        form: {
          addTitle: 'Add domain',
          editTitle: 'Edit domain',
          detailTitle: 'Domain detail',
          domainInfo: 'Domain info',
          templateAndTheme: 'Template and theme',
          fields: {
            desktop: 'Desktop',
            loginTheme: 'Login theme',
            resellerDomain: 'Reseller domain',
            resellerIdentityDomain: 'Reseller identity domain',
            agentLogo: 'Agent logo',
            agentLogoDark: 'Agent logo (Dark mode)',
            lastModified: 'Last modified',
            resellerLink: 'Link',
            dashboardMode: 'Dashboard mode',
            loginPageMode: 'Login page mode',
            primaryColor: 'Primary color',
            secondaryColor: 'Secondary color',
            enamad: 'eNamad',
            dashboardSettings: 'Dashboard settings',
            card: 'Card',
            cardDisplay: 'Card display',
            imagePath: 'Image path',
            redirectLink: 'Redirect link',
            videoPath: 'Video path',
          },
        },
        detailForm: {
          legend: 'Detail form',
        },
      },
      smsSenderAgents: {
        title: 'SMS sender agents',
        form: {
          addTitle: 'Add SMS sender agent',
          editTitle: 'Edit SMS sender agent',
          fields: {
            defaultNumber: 'Default number',
            type: 'Type',
            smsSenderAgentReference: 'SMS sender agent reference',
            startTime: 'Start time',
            endTime: 'End time',
            sendSmsAlert: 'Send SMS alert',
            isSendActive: 'Is send active',
            isReceiveActive: 'Is receive active',
            isSendBulkActive: 'Is send bulk active',
            sendBulkIsAutomatic: 'Send bulk is automatic',
            checkMessageId: 'Check message id',
            isSendSmartActive: 'Is send smart active',
            isActiveAllTime: 'Not considering the start and end time',
            sendLink: 'Send link',
            receiveLink: 'ReceiveLink',
            deliveryLink: 'Delivery link',
            domain: 'Domain',
            internalCredit: 'Internal credit',
            externalCredit: 'External credit',
            queueLength: 'Queue length',
            routeActive: 'Route active',
            isP2p: 'Is p2p',
            isSmpp: 'Is smpp',
            isBts: 'Is bts',
            udhLen: 'Udhlen',
            receiveInboxType: 'Receive inbox type',
          },
          legends: {
            accessInformation: 'Access information',
            generalInformation: 'General information',
            socialMediaSmartDetailsMci: 'Social media smart details mci',
            socialMediaSmartDetailsMtn: 'Social media smart details mtn',
            socialMediaSmartDetailsRightel:
              'Social media smart details rightel',
          },
        },
      },
      privateNumbers: {
        title: 'Private numbers',
        addBtns: {
          addSingle: 'Add single',
          createByRange: 'Create by range',
        },
        form: {
          addTitle: 'Add private number',
          editTitle: 'Edit private number',
          fields: {
            id: 'Id',
            priority: 'Priority',
            sendToBlackList: 'Send to blacklist',
            deliveryBase: 'Delivery base',
            checkFilter: 'Check filter',
            deliveryLevel1: 'Cost deduction based on level 1 delivery',
            deliveryLevel2: 'Cost deduction based on level 2 delivery',
            isAutomaticBulk: 'Is automatic bulk',
            confirmP2pAndDynamic: 'ConfirmP2pAndDynamicSend',
            isAutomaticGroup: 'Is automatic group',
            isSendBulk: 'Is send bulk (update number)',
            isSendGender: 'Is send gender',
            isSendGroup: 'Is send group',
            isSendPhonebook: 'Is send phonebook',
            isSendBulk2: 'Is send bulk',
            isSendApiP2P: 'Is Send Api P2P',
            isSendDynamic: 'Is Send Dynamic',
            isSendOtp: 'Is Send Otp',
            isSendP2P: 'Is Send P2P',
            isSendClub: 'Is Send Club',
            isPublic: 'Is Public',
            isSendApiSingle: 'Is Send Api Single',
            isGeneralBlackList: 'Is general blacklist',
            isSendSingle: 'Is send single',
            hasSla: 'HasSla',
            smsSenderAgentId: 'SMS sender agent id',
            smsSenderAgentName: 'SMS sender agent name',
            useForm: 'Use form',
            mask: 'Mask',
            range: 'Range',
            tryCount: 'Try count',
            expireTime: 'Expire time',
            isSendDevice: 'Is send device',
            isSendSmart: 'Is send smart',
            isNeedToSendConfirmationMessage:
              'Is need to send confirmation message',
            isSendPrivateNumberExpirationMessage:
              'Is send private number expiration message',
            isSendAlertForCreateOnlinePayment:
              'Is send alert for create online payment',
            isSendAlertForCreatePayment: 'Is send alert for create payment',
            isPostpaid: 'Is post paid',
            refundDeliveryStatusId: 'Refund delivery status',
            isCanSendFlashSms: 'Is can send flash sms',
            tag: 'Tag',
            isCanSendSmartWithoutConfirmation:
              'is can send smart without confirmation?',
            isSendOccasionPhonebook: 'Is send occasion phonebook?',
            numberStartOfRange: 'Number start of range',
            numberEndOfRange: 'Number end of range',
          },
          legends: {
            generalSettings: 'General settings',
            messageSenderInformation: 'Message sender information',
            bulkSend: 'Bulk Send',
            webServiceSend: 'Web Service Send',
            toNumberSend: 'Number to send',
          },
        },
      },
      bulkNumberInformation: {
        name: 'List of bulk numbers (update number)',
        name2: 'List of bulk numbers',
        title: 'List of bulk numbers (update number)',
        title2: 'List of bulk numbers',
        importfromfile: {
          title: 'Import from file',
          fields: {
            selectfile: 'Select file',
            empty: 'Empty',
            cellPhone: 'Cell phone',
            zipCode: 'Zip code',
            areaName: 'Area name',
            cityName: 'City name',
            stateName: 'State name',
            genderType: 'Gender type',
            guildName: 'Guild name',
            subGuildName: 'SubGuild name',
            isBlackList: 'Is blacklist',
            isBlackListLocal: 'Is blacklist local',
            mobileOperator: 'Mobile operator',
            simType: 'Sim type',
          },
        },
        deleteFromFile: {
          title: 'Delete from file',
          fields: {
            selectfile: 'Select file',
            empty: 'Empty',
            cellPhone: 'Cell phone',
          },
        },
        deleteBtns: {
          deleteMultiple: 'Delete multiple',
          deleteFromFile: 'Delete from file',
        },
        addBtns: {
          addSingle: 'Add single',
          addFromFile: 'Add from excel file',
        },
        form: {
          addTitle: 'Add number',
          legend: 'Add number',
          fields: {
            id: 'Id',
            genderType: 'Gender type',
            areaName: 'Area name',
            cityName: 'City name',
            isBlackList: 'Is blacklist',
            isBlackListLocal: 'Is blacklist local',
            mobile12: 'Mobile 12',
            mobileOperator: 'Mobile operator',
            stateName: 'State name',
            guildName: 'Guild name',
            subGuildName: 'SubGuild name',
            simType: 'Sim type',
            zipCode: 'Zip code',
          },
          legends: {
            generalSettings: 'Bulk numbers list',
            generalSettings2: 'Bulk numbers list 2',
          },
        },
      },
      chatBotHistories: {
        title: 'Chat bot histories',
      },
      organizations: {
        title: 'Organizations',
        authenticatedMobile: 'Authenticated mobile',
        organizationsExcel: 'Download organizations excel',
        form: {
          addTitle: 'Add organization',
          editTitle: 'Edit organization',
          fields: {
            isRealPerson: 'Is real person',
            name: 'Name',
            workplaceTitle: 'Workplace Title',
            workplacePhone: 'Workplace Phone',
            workplaceZipCode: 'Workplace Postal Code',
            workplaceAddress: 'Workplace Address',
            organName: 'Organ name',
            nationalId: 'National id',
            economicCode: 'Economic code',
            ceoFullName: 'Ceo name',
            ceoMobile: 'Ceo mobile',
            ceoNationalCode: 'Ceo national code',
            maximumUser: 'Maximum user',
            maxOrganization: 'Max organization',
            maxCustomFiled: 'Max custom filed',
            maxPhonebook: 'Max phonebook',
            parentId: 'Parentid',
            adminUserId: 'Admin user id',
            resellerId: 'Reseller id',
            panelPrice: 'Panel price',
            groupPriceTitle: 'Group price',
            blackSenderPrivateNumberId: 'Blacklist sender',
            maximumPhoneNumber: 'Maximum phone number',
            domainId: 'DomainId',
            sendStartTime: 'Send start time',
            sendEndTime: 'Send end time',
            expireTime: 'Expire time',
            isShowGeneralNumbers: 'Display public number for users',
            isForeigner: 'Is foreigner',
            isActiveSend: 'Is active send',
            isConfirmMessage: 'Is confirm message',
            isActiveAllTime:
              'Not considering the start and end time of sending',
            isAllowLink: 'Is allowLink',
            isTax: 'Is tax',
            isAuthenticated: 'Is authenticated',
            isShowGeneralAccount: 'Display public portal for users',
            organizationDocuments: 'Organization document type',
            defineNewUser: 'Add new user',
            isCanSeePublicParentPhonebook: 'Is can see public parent phonebook',
            isSendAlertToOrganizationAdmin:
              'Is send alert to organization admin',
            isSendAlertForCreateSmartSmsRequest:
              'Is send alert for create smart sms request',
            isSendOrganizationExpirationAlertMessage:
              'Is send organization expiration alert message',
            isCanSendExtraReceivers: 'Is can send extra receivers',
            isCanSetMultipleMobileForUser:
              'Is can set multiple mobile for user?',
            enableSystemDefaultTag: 'Enable system default tag',
            enableMessageWaitForOrganizationConfirmation:
              'Enable message wait for organization confirmation',
            enableSmartSmsFailureAlert: 'Enable smart sms failure alert',
          },
          legends: {
            generalInformation: 'General information',
            systemInformation: 'System information',
            organizationAdminUser: 'Organization Admin',
          },
        },
        organizationAuthentication: {
          title: 'Organization authentication',
          form: {
            addTitle: 'Authentication form',
            legend: 'Authentication',
            fields: {
              organizationDocuments: 'Organization documents',
              documentStatus: 'Document status',
              image: 'Image',
              description: 'Description',
              BusinessLicense: 'Business license',
              FoundedAnnounce: 'Founded announce',
              LatestChangesAnnounce: 'Latest changes announce',
              CeoNationalCard: 'Ceo national card',
              CeoBirthCertificate: 'Ceo birth certificate',
              OptionalField1: 'Optional field 1',
              OptionalField2: 'Optional field 2',
            },
          },
        },
        organizationDocumentation: {
          title: 'Organization documents',
          form: {
            addTitle: 'Authentication confirmation',
            legend: 'Authentication confirmation form',
            fields: {
              isAuthenticated: 'Is authenticated',
              organizationDocuments: 'Organization documents',
              description: 'Description',
              status: 'Status',
              documentStatus: 'Document status',
              organizationDocument: 'Organization document',
            },
          },
        },
        organizationResellers: {
          title: 'Organization Resellers',
        },
        deleteOrganization: 'Delete organization',
        deleteOrganizationWihDescendantList:
          'Delete organization with descendant list',
      },
      organizationCustomFields: {
        title: 'Organization custom fields',
        form: {
          addTitle: 'Add field',
          editTitle: 'Edit field',
          legend: 'Field Information',
          fields: {
            CustomFieldTypes: 'Custom field types',
            nameEn: 'English name',
            nameFa: 'Persian name',
          },
        },
      },
      users: {
        name: 'Name',
        title: 'Users',
        increaseUserCreditTitle: 'Increase user credit',
        decreaseUserCreditTitle: 'Decrease user credit',
        usersExcel: 'Download excel file',
        addBtns: {
          addSingle: 'Add single',
          addFromFile: 'Add from excel file',
        },
        importfromfile: {
          title: 'Add from file',
          downloadSample: 'Download Sample',
          uploadAddDescription:
            '<p class="mt-3 mb-1">⁃Files with the extension <b>{{fileType}}</b> are allowed to be uploaded.</p><p class="my-1"> ⁃ Please note that the first line of the Excel file is not read, so you should use it to insert the title. -pointer text-blue-500 dark:text-blue-400" href="/assets/media/sample/importUsers.xlsx" download="sampleUsers.xlsx" id="linkIdSampleUsers"> Click here </a>.</p><p class= "mt-3 mb-1">⁃If an organization is not selected, the current organization will be considered as the user organization.</p> <p class="my-1 font-medium">⁃Pay attention to the file Excel, for the user in the <b class="text-red-500 dark:text-red-400"> first line</b>, fill in the information of the optional fields with the required information or a hyphen (-).</p>',
          fields: {
            selectfile: 'Select file',
            empty: 'Empty',
            userName: 'Username',
            nationalCode: 'National code',
            identityNumber: 'Identity number',
            firstName: 'First Name',
            lastName: 'Last name',
            fatherName: 'Father name',
            email: 'Email',
            password: 'Password',
            isForeigner: 'Is foreigner?',
            zipCode: 'Zip code',
            phone: 'Phone',
            mobile: 'Mobile',
            faxNumber: 'Fax number',
            address: 'Address',
            zoneId: 'City',
            birthDate: 'Birth date',
            expireDate: 'Expire date',
            isActiveSend: 'Is active send?',
            descriptions: 'Descriptions',
            isDefault: 'Is default?',
            roleTemplateId: 'Role format',
            isActive: 'Is Active',
            isCanSendSmartWithoutConfirmation:
              'is can send smart without confirmation?',
          },
        },
        form: {
          addTitle: 'Add user',
          editTitle: 'Edit user',
          fields: {
            foreignerCode: 'Foreigner code',
            zoneId: 'Zone id',
            password: 'Password',
            secondPassword: 'Second password',
            isAdmin: 'Is admin',
            isAuthenticatedMobile: 'Is authenticated mobile',
            isNeedAuthorizationCheck: 'Authorization check',
            roleTemplateId: 'Role template',
            nationalCode: 'National Code/Foreigner code',
            isSendSmsDescriptionRequired: 'Is send sms description required?',
            isCanSeeContactsOfPrivatePhonebooks:
              'Is can see contacts of private phonebooks',
            isCanSeeContactsOfPublicPhonebooks:
              'Is can see contacts of public phonebooks',
            mobileCount: 'Mobile count',
          },
          legends: {
            personalInformation: 'Personal information',
            systemInformation: 'System information',
            authentication: 'Authentication',
            roleInformation: 'Roles',
          },
        },
        userInfo: {
          title: 'User authentication',
          userAuthentication: {
            title: 'User authentication',
            form: {
              addTitle: 'User authentication form',
              legend: 'User authentication form',
              fields: {
                BirthCertificate: 'Birth certificate',
                NationalCard: 'National card',
                OptionalField1: 'Optional field 1',
                OptionalField2: 'Optional field 2',
                documentStatus: 'Document status',
                description: 'Description',
              },
            },
          },
          userDocumentation: {
            title: 'User documents',
            form: {
              addTitle: 'Authentication confirmation',
              legend: 'Authentication confirmation form',
              fields: {
                isAuthenticated: 'Is authenticated',
                userDocuments: 'User documents',
                description: 'Description',
                status: 'Status',
                documentStatus: 'Document status',
              },
            },
          },
        },
        personalInfo: {
          name: 'Personal info',
          title: 'Personal info',
          editTitle: 'Edit personal information',
          organizationalInfo: 'Organization info',
          personalInfo: 'Personal info',
          foreigner: 'Foreigner',
          isForeigner: 'Is foreigner',
          foreignerCode: 'Foreigner code',
          firstAlert:
            'Dear user, in order to continue the process, it is necessary to complete your personal information',
          secondAlert:
            'Your information has been successfully registered. You will be notified of the final result within the next 48 hours',
        },
      },
      activeSessions: {
        title: 'Active sessions',
      },
      chatBot: {
        title: 'Smart API assistant',
      },
      formBuilderResponses: {
        responsesExcel: 'Responses excel',
      },
      userImpersonated: {
        title: 'User impersonated',
        form: {
          fields: {
            impersonatorUserName: 'Impersonator User name',
            impersonatorOrganizationName: 'Impersonator Organization Name',
            impersonatedUserName: 'Impersonated User Name',
            impersonatedOrganizationName: 'Impersonated Organization Name',
          },
        },
      },
      valueOfPurchases: {
        title: ' RFM',
        resellerTitle: 'Reseller RFM',
        form: {
          fields: {
            totalPoint: 'Total points',
            points: 'points',
            totalUsedCredit: 'Total used credit',
            realUsedCredit: 'Real used credit',
            totalSentCount: 'Total sent count',
            realSentCount: 'Real sent count',
            totalSentParts: 'Total sent parts',
            realSentParts: 'Real sent parts',
            sendSmsFrequency: 'Send sms frequency',
            isRecentSendSmsDifferenceTillNowMoreThanFrequency:
              'Is recent send sms difference till now more than frequency',
            recentSendSms: 'Recent send sms',
            recentSendDifferenceWithFrequencyStatus:
              'Recent send difference with frequency status',
            usedCreditPerEachFrequency: 'Used credit per each frequency',
          },
        },
      },
      userValueOfPurchasePoints: {
        title: 'User value of purchase points',
        form: {
          legend: 'Point',
          addTitle: 'New point',
          editTitle: 'Edit point',
          fields: {
            point: 'Point',
            valueEndRange: 'Value end range',
            valueStartRange: 'Value start range',
            index: 'index',
          },
        },
      },
      userValueOfPurchaseStrategies: {
        title: ' RFM strategies',
        form: {
          legend: 'Strategy',
          addTitle: 'New strategy',
          fields: {
            point: 'امتیاز',
            valueEndRange: 'مقدار پایان بازه',
            valueStartRange: 'مقدار شروع بازه',
            index: 'شاخص',
            range: 'بازه',
          },
        },
      },
      userPoints: {
        title: 'User points',
        form: {
          fields: {
            totalPoint: 'Total points',
            points: 'points',
          },
        },
      },
      financial: {
        newPayment: {
          invoice: {
            sellerSpecifications: 'Seller Specifications',
            customerSpecifications: 'Customer Specifications',
            finalPayment: 'Final Payment',
            totalAmountRial: 'Total amount (rial)',
            realLegalPersonName: 'Real / Legal Person Name',
            valueAddedTaxRial: 'Value added tax (rial)',
            invoiceIssuance:
              'This proforma invoice is valid for one day from the date of issue',
            noLegalValue:
              'It lacks legal value and credibility to be announced and included in the websites of tax affairs, finance, insurance, etc',
            parliamentTax: 'Parliament tax (rial)',
          },
        },
      },
      userPasswordHistory: {
        title: 'User password history',
        form: {
          fields: {
            createdUserName: 'Editor',
          },
        },
      },
      userLogins: {
        title: 'User logins',
      },
      smartDetail: {
        title: 'Smart details',
      },
      assignNumbers: {
        title: 'Assign numbers',
        assignPrivateNumbers: {
          title: 'Assign private number',
        },
        publicReceiveKeywords: {
          title: 'Public numbers assignment',
          form: {
            editTitle: 'Edit public number assignment',
            addTitle: 'Add public number assignment',
            legend: 'Public numbers assignment',
          },
        },
        privateReceiveKeywords: {
          title: 'Numbers assignment with keyword',
          form: {
            editTitle: 'Edit public number assignment',
            addTitle: 'Public number assignment',
            legend: 'Numbers assignment with keyword',
          },
        },
        privateNumberSendLimit: {
          title: 'Assign line to user',
          form: {
            editTitle: 'Edit assigning a line to a user',
            addTitle: 'Assign a new line to the user',
            legends: {
              general: 'User line assignment information',
              sendTypesList: 'Send Types List',
              users: 'Users',
              privateNumbers: 'Numbers',
            },
            fields: {
              canSeeReceivedSms: 'Ability to view received messages',
              notShowToAdmin: 'Not show to admin',
            },
          },
        },
      },
      transferPrivateNumbers: {
        title: 'Private number assignment',
        form: {
          editTitle: 'Change ownership',
          addTitle: 'Change ownership',
          legend: 'Private number assignment',
          fields: {
            numberType: 'Number type',
            newOwner: 'New owner',
            preOwner: 'Pre owner',
            privateNumber: 'Private number',
            TransferDateTime: 'Transfer date time',
          },
        },
      },
      inboxGroups: {
        title: 'Inbox groups',
        form: {
          editTitle: 'Edit inbox group',
          addTitle: 'Add inbox group',
          legend: 'Inbox group',
          fields: {
            inboxGroupName: 'Inbox group name',
          },
        },
      },
      inboxes: {
        title: 'Inbox',
        organizationInboxesTitle: 'Organization Inboxes',
        usersInboxesTitle: 'Users Inboxes',
        addToInboxGroup: 'Add To Inbox Group',
        inboxesExcel: 'Inboxes Excel',
        form: {
          editTitle: 'Edit inbox',
          addTitle: 'Add inbox',
          legend: 'Inbox',
          changeStatusTitle: 'Change status',
          fields: {
            inboxGroupName: 'Inbox group name',
            organizationName: 'Organization name',
            receiverNumber: 'Receiver number',
            senderMobile: 'Sender mobile',
            Encoding: 'Encoding',
            smsParts: 'SMS parts',
            smsText: 'SMS text',
            isRead: 'Is read',
            dateTimeReceive: 'Date time receive',
          },
        },
      },
      customPlace: {
        title: 'Custom places',
        form: {
          editTitle: 'Edit custom place',
          addTitle: 'Add custom place',
          legend: 'Custom places',
          customPlaceCreated: 'Custom place created',
          dialogs: {
            polygonAtLeaseMostHave3Point: 'Polygon at least most have 3 points',
          },
          fields: {
            deletedAt: 'Delete dat',
            coordinates: 'Coordinates',
            deletedBy: 'Delete d by',
            isActive: 'Is active',
            parentName: 'Parent name',
            geometryType: 'Geometry type',
            cityName: 'City name',
            provinceName: 'Province name',
          },
        },
      },
      groupPrice: {
        title: 'Group prices',
        titleWithCategoryName: 'List of {{categoryName}} group price ranges',
        groupPriceCategories: {
          title: 'Group price categories',
          categoryName: 'Category name',
          groupPriceCount: 'Group price count',
          form: {
            addTitle: 'Add group price category',
            editTitle: 'Edit group price category',
          },
        },
        form: {
          legend: 'Group price categories',
          editTitle: 'Edit group price',
          addTitle: 'Add group price',
          currencyNote: 'All amounts entered on this page are in Rial (IRR).',
          legends: {
            international: 'International benefit',
          },
          fields: {
            mtnSmartPercent: 'Location-based send tariff percent',
            rightelSmartPercent: 'Location-based send tariff percent',
            mciSmartPercent: 'Location-based send tariff percent',
            irancellSmartBasePrice: 'Smart send base price (Persian)',
            irancellEnglishSmartBasePrice: 'Smart send base price (English)',
            mciSmartBasePrice: 'Smart send base price (Persian)',
            mciEnglishSmartBasePrice: 'Smart send base price (English)',
            rightelSmartBasePrice: 'Smart send base price (Persian)',
            rightelEnglishSmartBasePrice: 'Smart send base price (English)',
            copyGroupPrice: 'Copy Group price',
            internationalBenefitType: 'International benefit type',
            internationalBenefitValuePercent:
              'International benefit value percent',
            internationalBenefitValue: 'International benefit value',
          },
        },
        list: {
          columns: {
            mciSmartPercent: 'MCI location-based tariff percent',
            mtnSmartPercent: 'Irancell location-based tariff percent',
            rightelSmartPercent: 'Rightel location-based tariff percent',
          },
        },
        detailForm: {
          title: 'Detail form',
          legend: 'Detail form',
          editTitle: 'Edit detail form',
          addTitle: 'Add detail form',
        },
      },
      myGroupPriceDetails: {
        title: 'My group price',
      },
      sendSmsFromMap: {
        title: 'Send SMS from the map (update number)',
        title2: 'Send SMS from the map',
        fields: {
          selectCity: 'Select city',
          selectPostalCode: 'Select postal code',
          selectMessageSettings: 'Select message settings',
          regionSettings: 'Region settings',
          detailOfSendingRegions: 'Detail of sending regions',
          Irancell: 'Send to Irancell',
          total: 'Total',
          count: 'Count',
          startFrom: 'Start from',
          simpleCount: 'Simple count',
          simpleStartFrom: 'Simple start from',
          hamrahAval: 'Hamrah aval',
          totalSendCount: 'Total send count',
          acceptAndNext: 'Accept and next',
        },
      },
      baseSendSms: {
        legends: {
          messageInformation: 'Message information',
          sendDateTimeType: 'Send settings',
        },
        fields: {
          receivers: 'Receivers',
          sendDay: 'Send day',
          sendHour: 'Send hour',
          startDay: 'Start day',
          endDay: 'End day',
          startHour: 'Start hour',
          endHour: 'End hour',
          sendDirect: 'Send direct',
          typeSend: 'Type send',
          sendPeriod: 'Send period',
          sendGradual: 'Send gradual',
          periodText: 'Period text',
          everyFewMinutes: 'EveryFewMinutes',
          numberOfSubmissions: 'Number of submissions',
        },
        justSendToWhiteList: 'Just send to white list',
        gradualAlert:
          'The minimum number of recipients should be 1000 numbers.',
        fastSend: 'Fast send',
        sendSms: 'Send SMS',
        editSendSms: 'Edit send SMS',
        warningMessageBeforeClosingEditPage:
          'Warning message before closing edit page',
      },
      sendSMS: {
        title: 'Send SMS',
        editTitle: 'Edit sending SMS',
        fields: {
          receivers: 'Receivers',
        },
        legends: {
          receivers: 'Receivers',
          phonebook: 'Phonebook',
          sendDateTime: 'Send date and time',
        },
        sendSms: 'Send SMS',
        addReceivers: 'Add receivers',
        removeReceivers: 'Remove receivers',
        missive: 'Missive',
      },
      sendSMSWithPhonebook: {
        title: 'Send SMS with phonebook',
        editTitle: 'Edit send SMS with phonebook',
        legends: {
          phonebook: 'Phonebook',
        },
      },
      sendBalkSms: {
        title: 'Bulk send (update number)',
        title2: 'Bulk send',
        editTitle: 'Edit sending bulk SMS',
        titlePostalCode: 'Send zone postal code',
        fields: {
          state: 'State',
          city: 'City',
          region: 'Region',
          businessGroup: 'Business group',
          businessSubGroup: 'Business subgroup',
          sendToRegionDetails: 'Send to region details',
          totalMobileNumber: 'Total mobile number',
          totalSmsSendOnStep: 'Total SMS send on step',
          startFromOnStep: 'Start from on step',
          mobilePrefixOnStep: 'Mobile prefix on step',
          mobileType: 'Mobile type',
          permanentNumber: 'Permanent number',
          creditNumber: 'Credit number',
          id: 'Id',
          operatorType: 'Operator type',
          hamrahAval: 'Hamrah aval',
          irancell: 'Irancell',
          postalCode: 'Postal code',
          zonePostalCode: 'Zone postal codes',
          gender: 'Gender',
          male: 'Male',
          female: 'Female',
          none: 'None',
          calculateTotalCount: 'Calculate total count',
          addToQueries: 'Add to queries',
          selectBalkQueries: 'Select balk queries',
          selectMessageSettings: 'Select message settings',
          senderNumberId: 'Sender number id',
          sendDateTime: 'Send date and time',
          smsBody: 'SMS body',
          smsBodyWithSignature: 'SMS body with signature',
          receivers: 'Receivers',
          sendHour: 'Send hour',
          sendDay: 'Send day',
          startDay: 'Start day',
          endDay: 'End day',
          startHour: 'Start hour',
          endHour: 'End hour',
          sendPeriod: 'Send period',
          sendGradual: 'Send gradual',
          typeSend: 'Type send',
          periodText: 'Period text',
          sendingRegion: 'Sending region',
          asIfStartWith: 'As if start with',
          postalCodeContains: 'Postal Code contains',
          acceptAndNext: 'Accept and next',
          totalCountOfSendingSms: 'Total count of sending SMS',
        },
        errors: {
          emptyRegion: 'Empty region',
          smsCountBiggerThanTotal: 'SMS count bigger than total',
          pleaseEnterValidDateForSend: 'Please enter valid date for send',
          firstSelectWhereToSendSms: 'First select where to send SMS',
          mostSelectAtLeastState: 'Most select at least state',
          mostSelectAtLeastSimType: 'Most select at least sim type',
        },
      },
      campaigns: {
        title: 'Campaigns',
        form: {
          addTitle: 'Add campaign',
        },
      },
      campaignsSendSms: {
        title: 'Send Sms Campaigns',
      },
      sendQueue: {
        title: 'Organization sending queue',
        usersTitle: 'Users sending queue',
        userTitle: 'User sending queue',
        resellerTitle: 'Reseller sending queue',
        fields: {
          id: 'Id',
          smsText: 'SMS text',
          failureCode: 'Failure code',
          sendType: 'Send type',
          sendSubType: 'Send subtype',
          senderNumber: 'Sender number',
          recipientCount: 'Recipient count',
          mciCount: 'Mci count',
          mtnCount: 'Mtn count',
          rightelCount: 'Rightel count',
          otherCount: 'Other count',
          campaign: 'Campaign',
          sendPrice: 'Total Send price',
          resolutionOfParliamentPrice: 'Resolution of parliament price',
          resolutionPrice: 'Resolution price',
          pageSize: 'Page size',
          pageIndex: 'Page index',
          fromIndex: 'From index',
          zipCode: 'Zip code',
          periodType: 'Period type',
          period: 'Period',
          dateTimeStart: 'Datetime start',
          dateTimeEnd: 'Datetime end',
          dateTimeNext: 'Datetime next',
          dateTimeSend: 'Datetime send',
          smsCount: 'SMS count',
          smsParts: 'SMS parts',
          operatorNumberCount: 'Operator number dount',
          blackListCount: 'Black list count',
          wrongNumberCount: 'Wrong number count',
          socialMediaApplication: 'Social media application',
          socialMediaMessage: 'Social media message',
          isFlashSms: 'Is flash message send?',
          internationalCount: 'International',
          processTextResults: 'Process text results',
          p2PIsSendDuplicateNumber: 'P2p is send duplicate number',
        },
        detail: {
          title: 'SMS sending details',
        },
        receivers: {
          title: 'Receivers',
          toNumber: 'To number',
          deliveryStatus: 'Delivery status',
          sendStatus: 'Send status',
          statusDateTime: 'Status date and time',
          receiversExcel: 'Download excel',
          sendDateTime: 'Send date time',
        },
        shortLinkReceiversList: {
          title: 'Short link receivers list',
        },
        sendBulkDetails: {},
      },
      createSmartSmsRequest: {
        title: 'Create smart SMS request',
        legends: {
          requestProperties: 'Request properties',
          publicProperties: 'Public properties',
          requestPublicPlace: 'Request public place',
        },
        errors: {
          forceToEnterDatePeriod: 'For ceto enter date period',
          mustSelectOperator: 'Please select operator',
          titleIsRequired: 'Title is required',
        },
        messages: {
          hint: '',
        },
        dialogs: {
          polygonAtLeaseMostHave3Point: 'Polygon at least most have 3 point',
        },

        horizontalAccordion: {
          workplace: 'Place of work (day stay)',
          home: 'Home (night stay)',
          bankProfile:
            'Bank profile (based on SMS numbers received from banks)',
          jobProfile: 'Job profile',
          travelProfile: 'Travel profile (domestic/foreign)',
          customerClub: 'Customer club',
          profile:
            'Profile of the most incoming/outgoing calls and SMS from one or more specific numbers',
          hobbies: 'Hobbies (sports, shopping, travel, ...)',
        },
        filters: {
          title: 'Filters',
          gender: 'Gender',
          age: 'Age',
          deviceType: 'Device type',
          deviceBrand: 'Device brand',
          eghamatgah: 'Residence',
          gardeshgari: 'Tourism',
          bankProfile: 'Bank profile',
          jobs: 'Job profile',
          favorites: 'Favorites',
          ertebatat: 'Communications on the telecommunications platform',
          artisticCulture: 'Artistic culture',
          artists: 'Artists',
          writers: 'Writers',
          reporters: 'Reporters',
          actors: 'Actors',
          publishers: 'Publisher',
          notImplemented: 'Currently this filter is disabled',
          mobilePrefix: 'Mobile prefix',
        },
        enterPublicPlaceName: 'Name of the selected area',
        publicPlaceName: 'Public Place Name',
        publicPlaceCreated: 'Public Place Created',
        deviceTypes: 'Device type',
        deviceBrands: 'Device brand',
        requestName: 'Request Title',
        ageFrom: 'From age',
        ageTo: 'To age',
        residenceState: 'Place of residence',
        joberState: 'Place of job activity',
        travelerState: 'Send to travelers',
        travelerProvinces: 'Province of origin of the traveler',
        periodicSmartSms: 'Smart Send Campaign',
        periodicHourDesc: 'The difference should between 11 hours',
        isShowGrayListExpireHour: 'Considering duplicate number',
        timingOfRepetitions: 'Timing of repetitions (hours)',
        grayListExpireHour:
          'For how many hours, a duplicate number will be considered?',
        smartRequestType: 'Smart send request type',
        club: 'Customer club',
        operationType: 'Type of operation',
        cellList: 'Cell list',
        mobilePrefix: 'Mobile prefix',
        deviceModels: 'Device models',
      },
      confirmSmartSmsRequest: {
        title: 'Send Smart SMS',
        legends: {
          smsPart: 'SMS Settings',
          requestData: 'Recipients Details',
          requestPublicPlace: 'Place to send',
          publicMap: 'Selected area',
          yourCampaignFrom: 'Your campaign from date',
          untilDate: 'Until date',
          period: 'Period',
          runAnd: 'Run and',
          person: 'Person',
          ofTheTargetNumbersWillReceiveSMS:
            'They receive SMS from the desired numbers',
          every: 'Every',
        },
        errors: {
          couldNotEditRequest:
            'Your request is not in a state where you can confirm or reject its information.',
          pleaseWaitUntilTheRequestStateChanged:
            'Please wait until the status of the request changes.',
          mustSelectOperator: 'Please select an operator.',
        },
        dialogs: {},
        fields: {
          sendDay: 'Send date',
          sendHour: 'Send hour',
          sentDelayType: 'Send type',
          sentDelayValue: 'Time after receiving',
          percentageToSend: 'Send percentage',
          countToSend: 'Number of Sends',
          sendCountType: 'Send count calculation type',
          percentage: 'Percentage',
          count: 'Number',
          maxSendCount: 'Maximum number of smart campaign sends',
          maxDailySendCount: 'Maximum daily send count',
          socialMediaApplicationName: 'Social media application name',
          socialMediaFileTitle: 'Social media file title',
        },
        filter: {
          yourMessageSendTo:
            'Your message will be sent to people with the following characteristics in the selected ranges:',
          sent: 'Will be sent in selected ranges',
        },
        periodTypeValue: 'Time unit',
        periodText: 'Repeat every :',
        UsePercentage: 'Use percentage',
        count: 'Amount',
        createCampain: 'Create and run a campaign',
        editCampaign: 'Edit campaign',
      },
      smsTemplate: {
        title: 'SMS template',
        form: {
          addTitle: 'Add SMS template',
          editTitle: 'Edit SMS template',
        },
      },
      smsTemplateGroup: {
        title: 'SMS template group',
        form: {
          editTitle: 'Edit SMS template group',
          addTitle: 'Add SMS template group',
        },
      },
      accountInformation: {
        title: 'Bank account numbers',
        form: {
          editTitle: 'Edit bank account number',
          addTitle: 'Add bank account number',
          legend: 'Bank account numbers',
          fields: {
            accountNo: 'Account no',
            branch: 'Branch',
            cardNo: 'Card no',
            iban: 'Iban',
            owner: 'Owner',
          },
        },
      },
      bankOnlineGateways: {
        title: 'Bank online gateways',
        form: {
          bankOnlineGatewaysForm: 'Bank online gateways informations',
          editTitle: 'Edit bank online gateway',
          addTitle: 'Add bank online gateway',
          fields: {
            accountInformationId: 'Account Information id',
            accountInformationOwner: 'Account information owner',
            typeIPG: 'Type ipg',
            configJson: 'Config json',
            isGeneralUse: 'Is general use',
            isFactorUse: 'Is factor use',
          },
        },
      },
      zones: {
        title: 'Zones',
        form: {
          editTitle: 'Edit zone',
          addTitle: 'Add zone',
          legends: {
            generalSettings: 'General settings',
            mapSetting: 'Map setting',
          },
        },
        newCountry: 'New country',
        newState: 'New state',
        newCity: 'New city',
        newArea: 'New area',
        editCountry: 'Edit country',
        editState: 'Edit state',
        editCity: 'Edit city',
      },
      roles: {
        title: 'Roles',
        cloneRole: 'Clone Role',
        form: {
          editTitle: 'Edit role',
          addTitle: 'Add role',
          cloneTitle: 'Clone role',
          legend: 'Roles',
          editRoleConfirmation: {
            inRole: 'In role ',
            theFollowingChangesWillBeApplied:
              'The following changes will be applied',
            accessIsRemoved: 'Access is removed',
            theOrganizationIsDeleted: 'The organization is deleted',
            listOfOrganizationsToBeDeleted:
              'List of organizations to be deleted',
            description1:
              'By removing these items, it will be applied to all related sub-Groups and stored data',
            enterTheNumberBelowToConfirmTheChanges:
              'Enter the number below to confirm the changes',
          },
        },
        userRoles: {
          title: 'User roles',
        },
      },
      roleTemplates: {
        title: 'Role templates',
        form: {
          editTitle: 'Edit role template',
          addTitle: 'Add role template',
          legend: 'Role templates',
          secondStep: {
            title:
              'If you activate the button below, the roles created for this role format will change',
            isChangeRoles: 'Do the roles change?',
          },
        },
        organizationRoles: {
          title: 'Assignment of role templates to organizations',
        },
      },
      guilds: {
        title: 'Guilds',
        form: {
          editTitle: 'Edit guild',
          addTitle: 'Add guild',
          legend: 'Guilds',
        },
      },
      kibanaDashboards: {
        title: 'Kibana dashboards',
        form: {
          editTitle: 'Edit dashboard',
          addTitle: 'Add dashboard',
          legend: 'Dashboard information',
        },
      },
      refundDeliveryStatus: {
        title: 'Refund delivery status',
        form: {
          editTitle: 'Edit refund delivery status',
          addTitle: 'Add refund delivery status',
          legend: 'Refund delivery status information',
          fields: {
            deliveryStatuses: 'Delivery status ',
          },
        },
      },
      resellers: {
        title: 'Resellers',
        form: {
          editTitle: 'Edit reseller',
          addTitle: 'Add reseller',
          legend: 'Reseller Informations',
          fields: {
            reseller: 'Reseller',
            pricePerSms: 'Price per SMS',
            panelPercent: 'Panel percent',
            target: 'Target',
          },
        },
        resellers: {
          title: 'Resellers',
        },
        resellerOrganizations: {
          title: 'Reseller organizations',
        },
      },
      resellerTarget: {
        title: 'Resellers target',
        form: {
          editTitle: 'Edit resellers target',
          addTitle: 'Add resellers target',
          legend: 'Resellers target',
          fields: {
            times: 'Times',
            targetValue: 'Target value',
            credit: 'Credit',
          },
        },
      },
      systemSetting: {
        title: 'System setting',
        form: {
          editTitle: 'Edit system setting',
          addTitle: 'Add system setting',
          legend: 'System setting',
          description:
            'You can set the settings for different parts of your panel in this form',
        },
      },
      panelSetting: {
        title: 'Panel setting',
        form: {
          editTitle: 'Edit panel setting',
          addTitle: 'Add panel setting',
          legend: 'Setting',
          description:
            'You can set the settings for different parts of your panel in this form',
        },
      },
      creditNotification: {
        title: 'Credit notification',
        form: {
          editTitle: 'Edit user credit',
          addTitle: 'Add user credit',
          legend: 'Credit notification',
          fields: {
            lastSendDateTime: 'Last send date and time',
            isSend: 'Is send',
            scheduledMessageId: 'Scheduled message id',
          },
        },
      },
      otp: {
        title: 'Authentication SMS format',
        form: {
          editTitle: 'Edit authentication SMS',
          addTitle: 'Add authentication SMS',
          changeStatusTitle: 'Change status title',
          code: '123',
          name: 'Ali',
          code2: 'Code {0}',
          name2: 'Dear {1} ,',
          description: 'Welcome to SmsPanel',
          code3: 'Code 123',
          name3: 'Dear Ali ,',
          legends: {
            specifications: 'SMS format',
            help: 'Help',
          },
          messages: {
            description1:
              'Enter the variable parameters in the message text as {#}',
            description2:
              'The # type in the above case is numeric and starts from 0 and increases in order {0}, {1}, {2},...',
            description3:
              'When sending an authentication message, the number of variable parameters defined in the message must be sent',
            description4: 'To send { یا } in SMS format, use {{ یا }}',
            sampleOtp: 'Sample Otp',
            sampleParameters: 'Example of sent parameters for the SMS above',
            finalMessage: 'SMS sent to the user',
          },
          fields: {
            priority: 'Priority',
            smsText: 'SMS Text',
            lastModified: 'Last Modified',
            OtpStatus: 'Otp Status',
          },
        },
      },
      menus: {
        name: 'Name',
        title: 'Menus',
        form: {
          editTitle: 'Edit menu',
          addTitle: 'Add menu',
          legends: {
            generalMenu: 'General menu',
            helpMenu: 'Help menu',
          },
          fields: {
            route: 'Route',
            order: 'Order',
            claim: 'Claim',
            class: 'Class',
            claims: 'Claims',
            helpText: 'Help text',
            imageHelp: 'Image help',
            videoHelp: 'Video help',
            pdfHelp: 'Pdf help',
            fileHelp: 'File help',
          },
        },
        uploadFileForm: {
          editTitle: 'Edit guide',
          addTitle: 'Add guide',
          legend: 'Upload file form',
          fields: {
            helpFileType: 'Help file type',
            file: 'File',
          },
        },
      },
      help: {
        title: 'Help',
        helpDetail: 'Help detail',
      },
      organizationTransactions: {
        title: 'Organization transactions',
        resellerTransactionTitle: 'Reseller transaction title',
        outboxTransactionsTitle: 'Outbox transactions title',
        transactionsDetailTitle: 'Transaction detail title',
        resellerTransactionsDetailTitle: 'Reseller transactions detail title',
        transactionsExcel: 'Download transactions excel file',
        resellerTransactionsExcel: 'Download reseller transactions excel file',
        form: {
          editTitle: 'Edit title',
          addTitle: 'Add title',
          fields: {
            packageId: 'Package id',
            packageTitle: 'Package title',
            outboxId: 'Outbox id',
            paymentId: 'Payment id',
            isIncrement: 'Is increment',
            typeTransaction: 'Type transaction',
            typeCreditChange: 'Type credit change',
            currentCredit: 'Current credit',
            createdByUserName: 'Created by user name',
          },
          legend: 'Transaction informations',
        },
      },
      sendLimits: {
        title: 'Send limits',
        form: {
          editTitle: 'Edit limit',
          addTitle: 'Add limit',
          legend: 'Limit informations',
          fields: {
            privateNumberNumber: 'Number',
            dailySendLimit: 'Daily send limit',
            monthlySendLimit: 'Monthly send limit',
          },
        },
      },
      allPrivateNumberSendLimit: {
        title: 'Users list numbers',
        form: {
          fields: {
            sendTypesList: 'Send Types List ',
            privateNumber: 'Private number ',
            canSeeReceivedSms: 'Can see received sms',
          },
        },
      },
      automaticResend: {
        title: 'Automatic resend',
        form: {
          editTitle: 'Edit automatic resend',
          addTitle: 'Add automatic resend',
          fields: {
            privateNumber: 'Private number',
            deliveryStatus: 'Delivery status',
            targetPrivateNumbers: 'Target private numbers',
          },
          legend: 'Automatic resend',
        },
      },
      payments: {
        title: 'Payments',
        resellerTitle: 'List of seller payments',
        detail: 'Detail',
        confirmPayment: 'Confirm payment',
        rejectPayment: 'Reject payment',
        paymentsExcel: 'Download payments excel',
        fields: {
          accountInformationId: 'Account Information id',
          accountInformationOwner: 'Account information owner',
          accountInformationAccountNo: 'Account information account no',
          accountInformationCardNo: 'Account information cardNo',
          accountInformationBank: 'Account information bank',
          paymentDate: 'Payment date',
          typePayment: 'Type payment',
          typeStatus: 'Type status',
          billNumber: 'Bill number',
          isOnlineGeneral: 'Is online general',
          createdBy: 'Created by',
          orderId: 'Order id',
          adminResellerCode: 'Admin reseller code',
          resellerCode: 'Reseller code',
          userFirstLastName: 'User first last name',
          chequeImageAddress: 'Cheque image address',
          receiverOrganizationName: 'Receiving organization',
          userName: 'Paying user',
          payerOrganizationName: 'Paying organization',
          isHaveImage: 'Is have image',
          smsCountPerPriceDescription: 'sms count per price description',
          smsCount: 'Sms count',
          resolutionOfParliament: 'Resolution of parliament',
          groupPriceDetailPrice: 'Group price detail price',
          interOrganizationalOrganizationName:
            'Inter organizational organization name',
          interOrganizationalUserName: 'Inter organizational user name',
          typeTransaction: 'Type transaction',
        },
      },
      resellerPayments: {
        title: 'Payments',
        resellerTitle: 'List of seller payments',
        detail: 'Detail',
        confirmPayment: 'Confirm payment',
        rejectPayment: 'Reject payment',
        paymentsExcel: 'Download payments excel',
        fields: {
          accountInformationId: 'Account Information id',
          accountInformationOwner: 'Account information owner',
          accountInformationAccountNo: 'Account information account no',
          accountInformationCardNo: 'Account information cardNo',
          accountInformationBank: 'Account information bank',
          paymentDate: 'Payment date',
          typePayment: 'Type payment',
          typeStatus: 'Type status',
          billNumber: 'Bill number',
          isOnlineGeneral: 'Is online general',
          createdBy: 'Created by',
          orderId: 'Order id',
          adminResellerCode: 'Admin reseller code',
          resellerCode: 'Reseller code',
          userFirstLastName: 'User first last name',
          chequeImageAddress: 'Cheque image address',
          receiverOrganizationName: 'Receiving organization',
          userName: 'Paying user',
          payerOrganizationName: 'Paying organization',
          isHaveImage: 'Is have image',
          smsCountPerPriceDescription: 'sms count per price description',
          smsCount: 'Sms count',
          resolutionOfParliament: 'Resolution of parliament',
          groupPriceDetailPrice: 'Group price detail price',
          interOrganizationalOrganizationName:
            'Inter organizational organization name',
          interOrganizationalUserName: 'Inter organizational user name',
          typeTransaction: 'Type transaction',
        },
      },
      paymentsForConfirm: {
        title: 'Payments for confirm',
        resellerTitle: 'List of payments for seller approval',
        confirmPayment: 'Confirm payment',
        rejectPayment: 'Reject payment',
      },
      paymentStatusChangeHistories: {
        title: 'Payment approve or reject history',
        fields: {
          type: 'Status change type',
          reservedCreditForGuarantee: 'Reserved credit for guarantee',
          isCreditOfGuaranteeLiquidated: 'Guarantee credit liquidated',
          liquidationTime: 'Liquidation time',
        },
      },
      newPayment: {
        title: 'Increase credit',
        legend: 'New payment',
        publicPaymentGateway: 'Choose public payment',
        selectCardNumber: 'Choose card number',
        selectAccountNumber: 'Choose account number',
        fields: {
          accountInformationId: 'Account Information id',
          billNumber: 'Bill number',
          billNumberPlaceholder: 'Transaction number',
          billNumberHint:
            'Enter the number you received from the bank or gateway (document, transaction, tracking, or reference number)',
          branchCode: 'Branch code',
          chequeAccountNumber: 'Cheque account number',
          chequeImage: 'Cheque image',
          chequeAmount: 'Cheque amount',
          chequeImageAddress: 'Cheque image address',
          dueDate: 'Due date',
          holderName: 'Holder name',
          isOnlineGeneral: 'Is online general',
          serialNumber: 'Serial number',
          sayadNumber: 'Sayad number',
          seriesNumber: 'Series number',
          nationalCode: 'National code',
          orderId: 'Order id',
          referenceId: 'Reference id',
          typePayment: 'Type payment',
          paymentDate: 'Payment date',
          paymentTime: 'Payment hours',
        },
        invoice: {
          title: 'Invoice',
        },
      },
      proformaInvoices: {
        title: 'Proforma invoices list',
        customerTitle: 'Current organization proforma invoices',
        sellerTitle: 'Proforma invoices issued for current organization',
        cancelProformaInvoice: 'Cancel proforma invoice',
        fields: {
          paymentType: 'Payment type',
          status: 'Status',
          customerOrganizationName: 'Customer organization',
          sellerOrganizationName: 'Seller organization',
        },
      },
      customerProformaInvoices: {
        title: 'Current organization proforma invoices',
        cancelProformaInvoice: 'Cancel proforma invoice',
        fields: {
          paymentType: 'Payment type',
          status: 'Status',
          customerOrganizationName: 'Customer organization',
          sellerOrganizationName: 'Seller organization',
        },
      },
      sellerProformaInvoices: {
        title: 'Proforma invoices issued for current organization',
        cancelProformaInvoice: 'Cancel proforma invoice',
        fields: {
          paymentType: 'Payment type',
          status: 'Status',
          customerOrganizationName: 'Customer organization',
          sellerOrganizationName: 'Seller organization',
        },
      },
      chequePayments: {
        title: 'Cheques list',
        resellerTitle: 'Sellers check list',
        detail: 'Detail',
        fields: {
          branchCode: 'Branch code',
          chequeAccountNumber: 'Cheque account number',
          chequeAmount: 'Cheque amount',
          chequeImageAddress: 'Cheque image address',
          dueDate: 'Due date',
          holderName: 'Holder name',
          isPassed: 'Is passed',
          nationalCode: 'National code',
          paymentId: 'Payment id',
          sayadNumber: 'Sayad number',
          serialNumber: 'Serial number',
          seriesNumber: 'Series number',
          typeBank: 'Type bank',
          payerOrganizationName: 'Paying organization',
          receiverOrganizationName: 'Receiving organization',
        },
      },
      informations: {
        name: 'Informations',
        title: 'Informations',
        form: {
          addTitle: 'Add information',
          editTitle: 'Edit information',
          fields: {
            id: 'Id',
            displayForAllSubOrganizations: 'Display for all sub organizations',
            customerDomainName: 'Customer domain name',
            startDate: 'Start date',
            endDate: 'End date',
            isRequiredToSeen: 'Is required to seen',
            showOnlyToCurrentDomainOrganizations:
              'Show only to current domain organizations',
            displayOnlyForChildrenOrganizations:
              'Display only for children organizations',
          },
          legend: 'Informations',
        },
      },
      panelDocumentations: {
        title: 'Panel Documentations',
        webServiceSendHelp: 'Help for sending with web service',
        downloadDocumentations: 'Download documentations',
        smartDocumentations: 'Smart send documentations',
      },
      audits: {
        title: 'Audits',
        auditList: 'Audits list',
        auditDetail: 'Audits details',
        fields: {
          referenceId: 'ReferenceId',
          remoteIpAddress: 'Remote ip address',
          localIpAddress: 'Local ip address',
          osInfo: 'Os info',
          browserName: 'Browser name',
          operationType: 'Operation type',
          operationCount: 'Number of operations',
          old: 'Old',
          new: 'New',
          comments: 'Comments',
          timezone: 'Timezone',
          ip: 'Ip',
          applicationName: 'Application name',
          lat: 'Lat',
          lon: 'Lon',
          country_iso_code: 'Country iso code',
          country_name: 'Country name',
          continent_code: 'Continent code',
          userAgent: 'User agent',
          className: 'Class name',
          os: {
            full: 'Os full name',
            version: 'Os version',
            name: 'Os name',
          },
          device: {
            name: 'Device name',
          },
          clientUserAgent: {
            name: 'Client user agent name',
            version: 'Client user agent version',
          },
        },
      },
      superAdminAudits: {
        title: 'Super admin audits',
        legends: {
          environmentInfo: 'Environment info',
          document: 'Audit informations',
        },
        fields: {
          startDate: 'Start date',
          endDate: 'End date',
          logCode: 'Log code',
          logText: 'Log text',
          logLocation: 'Log location',
          userInfo: {
            userAgent: 'User agent',
            applicationName: 'Application name',
            remoteIpAddress: 'Remote ip address',
            userId: 'User id',
            localIpAddress: 'Local ip address',
            userName: 'Username',
            remoteIpAddressGeo: {
              geo: {
                timezone: 'Timezone',
                continent_code: 'Continent code',
                country_name: 'Country name',
                country_iso_code: 'Country iso code',
                location: {
                  lat: 'Lat',
                  lon: 'Lon',
                },
              },
              ip: 'Ip',
            },
            clientUserAgent: {
              name: 'Client user agent name',
              version: 'Client user agent version',
              os: {
                full: 'Os full name',
                version: 'Os version',
                name: 'Os name',
              },
              device: {
                name: 'Device name',
              },
            },
          },
          environment: {
            userName: 'Environment username',
            machineName: 'Machine name',
            domainName: 'Domain name',
            culture: 'Culture',
          },
        },
      },
      shortLinkLandingPage: {
        title: 'Short link landing page',
      },
      apiAudits: {
        title: 'Api audits',
        legends: {
          environmentInfo: 'Environment info',
          userInfo: 'User info',
          document: 'Document',
        },
        fields: {
          startDate: 'Start date',
          endDate: 'End date',
          logCode: 'Log code',
          logText: 'Log text',
          logLocation: 'Log location',
          userId: 'User id',
          organizationId: 'Organization id',
          token: 'Token',
          tokenIp: 'Token ip',
          tokenId: 'Token id',
          requestMethod: 'Request method',
          requestPath: 'Request path',
          scheduledMessageId: 'Scheduled message id',
          status: 'Status',
          requestBody: 'Request body',
          userInfo: {
            userAgent: 'User agent',
            applicationName: 'Application name',
            remoteIpAddress: 'Remote ip address',
            userId: 'User id',
            localIpAddress: 'Local ip address',
            userName: 'Username',
            remoteIpAddressGeo: {
              geo: {
                timezone: 'Geo timezone',
                continent_code: 'Continent code',
                country_name: 'Country name',
                country_iso_code: 'Country iso code',
                location: {
                  lat: 'Lat',
                  lon: 'Lon',
                },
              },
              ip: 'Ip',
            },
            clientUserAgent: {
              name: 'Client user agent name',
              version: 'Client user agent version',
              os: {
                full: 'Os full name',
                version: 'Os version',
                name: 'Os name',
              },
              device: {
                name: 'Device name',
              },
            },
          },
          environment: {
            userName: 'Environment Username',
            machineName: 'Environment machine name',
            domainName: 'Environment domain name',
            culture: 'Environment culture',
          },
        },
      },
      loginAudits: {
        title: 'Api audits',
        legends: {
          environmentInfo: 'Environment info',
          userInfo: 'User info',
          document: 'Document',
        },
        fields: {
          logDateTime: 'Log date time',
          startDate: 'Start date',
          endDate: 'End date',
          logCode: 'Log code',
          logText: 'Log text',
          logLocation: 'Log location',
          userId: 'User id',
          organizationId: 'Organization id',
          token: 'Token',
          tokenIp: 'Token ip',
          tokenId: 'Token id',
          requestMethod: 'Request method',
          requestPath: 'Request path',
          scheduledMessageId: 'Scheduled message id',
          status: 'Status',
          requestBody: 'Request body',
          userInfo: {
            userAgent: 'User agent',
            applicationName: 'Application name',
            remoteIpAddress: 'Remote ip address',
            userId: 'User id',
            localIpAddress: 'Local ip address',
            userName: 'Username',
            remoteIpAddressGeo: {
              geo: {
                timezone: 'Geo timezone',
                continent_code: 'Continent code',
                country_name: 'Country name',
                country_iso_code: 'Country iso code',
                location: {
                  lat: 'Lat',
                  lon: 'Lon',
                },
              },
              ip: 'Ip',
            },
            clientUserAgent: {
              name: 'Client user agent name',
              version: 'Client user agent version',
              os: {
                full: 'Os full name',
                version: 'Os version',
                name: 'Os name',
              },
              device: {
                name: 'Device name',
              },
            },
          },
          environment: {
            userName: 'Environment Username',
            machineName: 'Environment machine name',
            domainName: 'Environment domain name',
            culture: 'Environment culture',
          },
        },
      },
      rulesAudits: {
        title: 'Token rules audits',
        legends: {},
        fields: {
          startDate: 'Start date',
          endDate: 'End date',
          logCode: 'Log code',
          logText: 'Log text',
          requestMethod: 'Request method',
          requestPath: 'Request path',
          requestToken: 'Request token',
          status: 'Status',
          userInfo: {
            userAgent: 'User agent',
            applicationName: 'Application name',
            remoteIpAddress: 'Remote ip address',
            userId: 'User id',
            localIpAddress: 'Local ip address',
            userName: 'Username',
            remoteIpAddressGeo: {
              geo: {
                timezone: 'Timezone',
                continent_code: 'Continent code',
                country_name: 'Country name',
                country_iso_code: 'Country iso code',
                location: {
                  lat: 'Lat',
                  lon: 'Lon',
                },
              },
              ip: 'Ip',
            },
            clientUserAgent: {
              name: 'Client user agent name',
              version: 'Client user agent version',
              os: {
                full: 'Os full name',
                version: 'Os version',
                name: 'Os name',
              },
              device: {
                name: 'Device name',
              },
            },
          },
          environment: {
            userName: 'Environment Username',
            machineName: 'Environment machine name',
            domainName: 'Environment domain name',
            culture: 'Environment culture',
          },
        },
      },
      systemNumbers: {
        title: 'System numbers',
        systemNumbersExcel: 'System numbers excel',
        legend: 'System numbers',
        fields: {
          number: 'Number',
          numberType: 'Number type',
          organizationName: 'Organization name',
          smsSenderAgentName: 'Sms sender agent name',
          refundDeliveryStatusesTitle: 'Refund delivery statuses title',
        },
      },
      webhook: {
        title: 'Webhook',
        form: {
          editTitle: 'Edit webhook',
          addTitle: 'Add webhook',
          legend: 'Webhook',
          sender: 'Sender number',
          privateNumber: 'Private number',
          message: 'Message body',
          encoding: 'Encoding',
          messageId: 'Message Id',
          status: 'Message status',
          sampleCode: 'Sample code',
          receivedDate: 'Received date',
          fields: {
            url: 'Url',
            tryCount: 'Try count',
            webhookType: 'Webhook type',
          },
          legends: {
            specifications: 'Specifications',
            address: 'Webhook address',
          },
          messages: {
            description1: 'Refer to the manual for detailed parameters.',
            description3: 'The address must start with http or https.',
            description2:
              'Validation of the entered address is the responsibility of the user.',
            description4: 'Status webhook will send only for web service sends',
          },
        },
      },
      apiToken: {
        title: 'Api token',
        ipRules: 'Ip rules',
        createIpRules: 'Create ip rules',
        clientRules: 'Client rules',
        safeIps: 'Safe ips',
        form: {
          editTitle: 'Edit api token',
          addTitle: 'Add api token',
          changeStatusTitle: 'Api token change status',
          legend: 'Api token',
          fields: {
            ip: 'Ip',
            token: 'Token',
            status: 'Status',
            isCanSend: 'Is can send',
            isCanSendSmart: 'Is can send smart',
            isIgnoreCheckIp: 'Is ignore check ip?',
            canUseSmartClass: 'can use smart class?',
            enableUseHmac: 'Enable use Hmac',
          },
        },
      },
      ipRules: {
        title: 'Ip rules',
        allIpRules: 'All ip rules',
        form: {
          addTitle: 'Create ip rule',
          editTitle: 'Edit ip rule',
          legend: 'Rule details',
          fields: {
            ip: 'Ip',
            limit: 'Limit',
            period: 'Period',
            periodType: 'Period type',
            endpoint: 'End point',
            apiTokenId: 'Api token id',
            ipRulesFromWebService: 'Ip rules from web service',
            ipRulesFromTable: 'Ip rules from table',
          },
        },
      },
      clientRules: {
        title: 'Client rules',
        form: {
          addTitle: 'Create client rule',
          editTitle: 'Edit client rule',
          legend: 'Rule details',
          fields: {
            ip: 'Ip',
            limit: 'Limit',
            period: 'Period',
            endpoint: 'End point',
            apiTokenId: 'Api token id',
            clientId: 'Client id',
            clientRulesFromWebService: 'ClientRulesFromWebService',
            clientRulesFromTable: 'ClientRulesFromTable',
          },
        },
      },
      pollParsersInboxes: {
        title: 'Poll parser inboxes',
        inboxesExcel: 'Download excel file',
      },
      modules: {
        title: 'Modules',
        modules: {
          title: 'Modules',
        },
        modulesOrganizations: {
          title: 'Modules organizations',
          form: {
            editTitle: 'Edit modules organization',
            addTitle: 'Add modules organization',
            legend: 'Modules organizations',
            fields: {
              moduleId: 'Module id',
              organizationId: 'Organization id',
            },
          },
        },
      },
      filterWords: {
        title: 'Filtered words',
        form: {
          editTitle: 'Edit filtered word',
          addTitle: 'Add filtered word',
          fields: {
            userFirstName: 'User first name',
            userLastName: 'User last name',
          },
        },
      },
      organizationsBlackListExceptions: {
        title: 'Organizations black list exceptions',
        form: {
          addTitle: 'Add exceptions',
        },
      },
      phonebook: {
        title: 'Phonebook',
        form: {
          addTitle: 'Add phonebook',
          editTitle: 'Edit phonebook',
          fields: {
            title: 'Title',
            isPublic: 'Is public',
            isShowNumber: 'Is show number',
            canSeeContacts: 'Can see contacts',
            contactsCount: 'Contacts count',
            whiteMessageId: 'Customers club id',
            deviceConnectionPort: 'Customer club device port',
            isSendMessageAfterAddFromDevice:
              'Is send message after add from device',
          },
          legends: {
            phonebookInformation: 'Phonebook information',
            organizationsWhichCanUse: 'Organizations with access',
          },
          hints: {
            canSeeContacts:
              'Determines whether each organization can view the contacts of this phonebook.',
          },
        },
        customFieldsForm: {
          title: 'Custom fields form',
          searchInCustomFields: 'Search in custom fields',
        },
      },
      contacts: {
        title: 'Contacts',
        deleteContactsFormPhonebooks: {
          title: 'Remove contact from groups',
          message: 'Select the groups you want to remove contacts from',
          selectCurrentGroup: 'Select the current group',
        },
        addBtns: {
          addSingle: 'Add single',
          addListNumber: 'Add list number',
          addFromFile: 'Add from excel file',
        },
        form: {
          addTitle: 'Add contact',
          editTitle: 'Edit contact',
          fields: {
            job: 'Job',
            birthdate: 'Birth date',
            telephone: 'Telephone',
            cellphone: 'Cell phone',
            phonebookGroup: 'Phonebook group',
            createType: 'Create type',
          },
          legends: {
            contactInfo: 'Contact info',
            customFields: 'Custom fields',
          },
        },
        importfromfile: {
          title: 'Import from file',
          legends: {
            importFromFile: 'Import From File',
            previewFile: 'Preview File',
          },
          fields: {
            selectfile: 'Select file',
            firstNameFieldName: 'First name field name',
            lastNameFieldName: 'Last name field name',
            emailFieldName: 'Email field name',
            birthDateFieldName: 'Birth date field name',
            telephoneFieldName: 'Telephone field name',
            jobFieldName: 'Job field name',
            addressFieldName: 'Address field name',
            empty: 'Empty',
            cellPhone: 'Cellphone',
          },
        },
      },
      dynamicTemplate: {
        title: 'Dynamic template',
        form: {
          addTitle: 'Add dynamic template',
          editTitle: 'Edit dynamic template',
          fields: {
            customText: 'Custom text',
            format: 'Format',
          },
          messages: {
            description1:
              'To add fixed fields, click on the field name in the list above',
            description2:
              'You can also add desired text and field from the profile section.',
            note1:
              'Pay attention to the following points when designing a dynamic template :',
            note2:
              'If a desired field or a fixed field is defined in a dynamic format and a value is not registered for it in the contact, its text will be sent empty in the SMS.',
            note3:
              'If a desired field is defined in a dynamic format that does not exist in the contact group (phonebook), its text will be sent empty in the SMS.',
          },
        },
      },
      outboxMessages: {
        title: 'Outbox messages',
        usersTitle: 'Users outbox message',
        userTitle: 'User outbox message',
        resellerTitle: 'Reseller outbox message',
        resellersTitle: 'Resellers outbox message',
        usersOutboxMessages: 'Users outbox messages',
        userOutboxMessages: 'User outbox messages',
        editStatusTitle: 'Edit outbox message status',
        getNewDeliveryStatusTitle: 'Request the latest delivery status',
        outboxExcel: 'Outbox excel',
        advancedSearch: {
          title: 'Advanced Search',
          zipCode: 'Postal code',
          phonebookIds: 'Phonebook group',
          toNumber: 'Receiver',
          guild: 'Guild',
          zone: 'Zone',
          startDate: 'Start Date',
          endDate: 'End Date',
          description: 'Description',
          smsText: 'Sms text',
          sendStartDate: 'Send start date',
          sendEndDate: 'Send end date',
          sendStartHour: 'Send start hour',
          sendEndHour: 'Send end hour',
          sendStatus: 'Send status',
          deliveryStatus: 'Delivery status',
          trackingNumber: 'Tracking number',
        },
        resendDetail: {
          title: 'Resend Detail',
          createdBy: 'Created By',
          scheduledMessageId: 'Previous ID',
          newScheduledMessageId: 'Current ID',
          deliveryStatuses: 'Delivery Status',
        },
        fields: {
          countSendBlackList: 'Count send blacklist',
          blackListCount: 'Blacklist Count',
          countResendOther: 'Count resend other',
          cpType: 'Cp type',
          exportDataStatus: 'Export data status',
          receiverCount: 'Receiver count',
          organizationId: 'Organization id',
          scheduledMessageId: 'Scheduled message id',
          sendingTryCount: 'Sending try count',
          campaign: 'Campaign',
          mciCount: 'Mci',
          mtnCount: 'Mtn',
          otherCount: 'Other',
          rightelCount: 'Rightel',
          smsEncoding: 'SMS encoding',
          smsParts: 'SMS parts',
          smsText: 'SMS text',
          status: 'Status',
          contactsCount: 'Contacts count',
          resellerName: 'Reseller Name',
          sendSubType: 'Send SubType',
          sendType: 'SendType',
          isResend: 'Is Resend',
          senderNumber: 'Sender Number',
          isWhiteMessage: 'Is white message?',
          isFlashSms: 'Is flash message?',
          period: 'period',
          processTextResults: 'Process text results',
          p2PIsSendDuplicateNumber: 'P2p is send duplicate number',
          isP2PWithShortLink: 'Is P2P with short link',
        },
        detail: {
          title: 'SMS sending Details',
          PhonebookRecipientTitle: 'Sending with phonebook details',
        },
        resendByDeliveryStatus: {
          title: 'Resend by delivery status',
          statues: 'Statues',
          isSendFromMyPanel: 'Is Sent From My Panel',
          extraReceivers: 'Extra receivers',
          selectDeliveryStatus: 'Select delivery status',
          messageInformation: 'Message information',
          receiversAndSendDateTime: 'Receivers and send date and time',
          deliveryStatusRequiredMsg: 'Delivery status required msg',
          sendDirect: 'Send direct',
          sendGradual: 'Send gradual',
          isFlashSms: 'Is flash sms',
        },
      },
      dynamicSendSms: {
        title: 'Dynamic send SMS',
        form: {
          addTitle: 'Add dynamic send SMS',
          editTitle: 'Edit dynamic send SMS',
          fields: {
            customText: 'Custom text',
            format: 'Format',
            dynamicTemplates: 'Dynamic templates',
          },
        },
        messages: {
          warningMessageBeforeClosingEditPage:
            'Warning message before closing edit page',
          note1: 'Pay attention to the following points in dynamic sending :',
          note2:
            'If a desired field or a fixed field is defined in a dynamic format and a value is not registered for it in the contact, its text will be sent empty in the SMS.',
          note3:
            'If a desired field is defined in a dynamic format that does not exist in the contact group (phone book), its text will be sent empty in the SMS.',
        },
        legends: {
          messageInformation: 'Message information',
          phonebook: 'Phonebook',
        },
      },
      sendP2pSms: {
        title: 'Send p2p SMS',
        trackingNumberTitle: 'Send p2p with tracking number SMS',
        editTitle: 'Edit send p2p SMS',
        legends: {
          selectFile: 'Select file',
          smsTextSetting: 'SMS text setting',
          smsSetting: 'SMS setting',
        },
        fields: {
          toNumberFieldName: 'To number field name',
          trackingNumberFieldName: 'Tracking number field name',
        },
        messages: {
          description1:
            'To set the SMS text, you can select the desired column by clicking from the list of columns.',
          description2:
            'Also, to move the columns in the blue box, grab and move the column.',
          description3:
            'It should be noted that in order to add the desired text, you can type your desired text in the desired text field and press the add key',
          description4: 'Add your text to the SMS.',
          sendWithDuplicateNumbersMsg:
            'Warning: Selecting this option will not delete duplicate numbers in the selected Excel file. Before using this option, make sure that you are going to send different text for fixed recipients.',
        },
      },
      sendP2pSmartSms: {
        title: 'Send P2P smart sms',
        editTitle: 'Edit send P2P smart sms',
        legends: {
          selectFile: 'Select file',
          smsTextSetting: 'SMS text setting',
          smsSetting: 'SMS setting',
          publicMap: 'Public map',
        },
        fields: {
          toNumberFieldName: 'To number field name',
        },
        messages: {
          description1:
            'To set the SMS text, you can select the desired column by clicking from the list of columns.',
          description2:
            'Also, to move the columns in the blue box, grab and move the column.',
          description3:
            'It should be noted that in order to add the desired text, you can type your desired text in the desired text field and press the add key',
          description4: 'Add your text to the SMS.',
          sendWithDuplicateNumbersMsg:
            'Warning: Selecting this option will not delete duplicate numbers in the selected Excel file. Before using this option, make sure that you are going to send different text for fixed recipients.',
        },
        errors: {
          couldNotEditRequest: 'Could not edit request',
          pleaseWaitUntilTheRequestStateChanged:
            'Please wait until the request state changed',
          mustSelectOperator: 'Please select operator',
        },
      },
      sendSmartSMS: {
        title: 'Send smart SMS',
        detail: 'Details',
        smartSmsDetailExcel: 'Smart sms detail excel',
        smartSmsDetailTableExcel: 'Smart sms detail table excel',
        form: {
          addTitle: 'Add send smart SMS',
          editTitle: 'Edit send smart SMS',
          legend: 'Send smart SMS',
          fields: {
            status: 'Status',
            statusDatetime: 'Status date and time',
            startDatetime: 'Start date and time',
            endDatetime: 'End date and time',
            title: 'Send smart SMS field',
            responseData: 'Response data',
          },
        },
      },
      smartSmsRequests: {
        title: 'Smart SMS requests',
        detail: 'Detail',
        smartSmsRequestExcel: 'Download smart sms request excel',
        form: {
          addTitle: 'Add smart SMS request',
          editTitle: 'Edit smart SMS request',
          legend: 'Smart SMS request',
          fields: {
            status: 'Status',
            statusDatetime: 'Status date and time',
            startDatetime: 'Start date and time',
            endDatetime: 'End date and time',
            title: 'Smart SMS request field',
            responseData: 'Response data',
          },
        },
      },
      resellerSmartSmsRequests: {
        title: 'Reseller smart SMS requests',
        form: {
          fields: {
            status: 'Status',
            statusDatetime: 'Status date and time',
            startDatetime: 'Start date and time',
            endDatetime: 'End date and time',
          },
        },
      },
      fastSendSmsPatternByPhonebook: {
        title: 'Fast send SMS pattern by phonebook',
        manual: 'Manual',
        fast: 'Fast',
        phonebook: 'Phonebook',
      },
      fastSendSmsPatternManual: {
        title: 'Fast send SMS pattern manual',
        fields: {
          receivers: 'Receivers',
        },
      },
      pollParsers: {
        surveyTitle: 'Survey title',
        competitionTitle: 'Competition title',
        options: 'Options',
        selectOption: 'Select option',
        form: {
          pollAddTitle: 'Add survey',
          pollEditTitle: 'Edit survey',
          competitionAddTitle: 'Add competition',
          competitionEditTitle: 'Edit competition',
          legends: {
            surveySpecifications: 'Survey specifications',
            surveyResponse: 'Survey response',
            surveyMatchOptions: 'Survey match options',
            competitionSpecifications: 'Competition specifications',
            competitionResponse: 'Competition response',
            competitionMatchOptions: 'Competition match options',
          },
          fields: {
            privateNumberId: 'Private number id',
            senderPhonebookId: 'Sender phonebook id',
            optionTitle: 'Option title',
            keyword: 'Keyword',
            phonebookName: 'Save in phonebook',
            isCorrect: 'Is correct',
            isJustTrueAnswer: '',
            isMainQuestion: 'Is main question?',
          },
          messages: {
            emptyOption: 'Empty option',
            onlyOneCorrectOption: 'Only one correct option',
            optionTitleRequired: 'Enter the title of the option',
            keywordRequired: 'Enter the keyword',
            uniqueTitle: 'The title of the option cannot be repeated',
            uniquekeyword: 'The keyword cannot be repeated',
          },
        },
        stats: {
          title: 'Statistics',
          correctAnswerCount: 'Correct Answer Count',
          incorrectAnswerCount: 'Incorrect Answer Count',
          surveyStats: 'Survey statistics',
          competitionStats: 'Competition statistics',
          doughnutChartTitle: 'Chart of selected options',
          pieChartTitle: 'Chart of the number of correct and incorrect choices',
        },
      },
      textParsers: {
        title: 'Text parsers',
        form: {
          addTitle: 'Add text parser',
          editTitle: 'Edit text parser',
          fields: {
            isChildrenChange: 'Is Children change',
            title: 'Fields',
            privateNumberId: 'Private number id',
            senderConditionType: 'Sender condition type',
            senderConditionValue: 'Sender condition value',
            senderPhonebookId: 'Sender phonebook id',
            ifConditionType: 'If condition type',
            ifConditionValue: 'If condition value',
            thenConditionType: 'Then condition type',
            thenConditionValue: 'Then condition value',
            senderNumber: 'Sender number',
            mobileNumber: 'Mobile number',
            email: 'Email',
            matchingDynamicTemplateId: 'Match ing dynamic template id',
            noMatchingDynamicTemplateId: 'No match ing dynamic template id',
            ipAndPort: 'Ip and port',
            sentDelayType: 'Send type',
            sentDelayValue: 'Once per {{type}}',
          },
          legends: {
            filterConditions: 'Filter conditions',
            generalInformation: 'General information',
            senderNumber: 'Sender number',
          },
        },
      },
      safeIps: {
        safeIpsTitle: 'Safe ips',
        confirmUserSafeIpsTitle: 'Confirm User Safe Ips',
        confirmUserSafeIps: 'Confirm user safe ips',
        rejectUserSafeIps: 'Reject user safe ips',
        form: {
          addTitle: 'Add safe Ip',
          editTitle: 'Edit safe Ip',
        },
      },
      whiteMessages: {
        title: 'Requests list',
        form: {
          addTitle: 'Request new settings',
          editTitle: 'Edit request status',
          fields: {
            enterSms: 'Re-enter the club SMS',
            exitSms: 'Leaving club SMS',
            returnText: 'Return Text',
            cancelText: 'Cancel Text',
            status: 'Status',
            dailyAddLimit:
              'The maximum number of daily additions to the club book.',
            monthlyAddLimit:
              'The maximum number of monthly additions to the club book',
            isSendCancelText:
              'Send the cancellation text at the end of each SMS',
            rejectComment: 'Reject description',
            repeatTextDay: 'Repeat the text every day',
          },
          legends: {
            requestDetail: 'Request detail',
            defineScenario: 'Define scenario',
          },
        },
      },
      organizationWhiteMessages: {
        title: 'Settings list',
        form: {
          addTitle: 'Add Setting',
          editTitle: 'Edit setting',
          fields: {
            enterSms: 'Enter club SMS',
            exitSms: 'Leaving club SMS',
            returnText: 'Return text',
            cancelText: 'Cancel text',
          },
        },
      },
      sendWhiteMessage: {
        title: 'Send club SMS',
        editTitle: 'Edit Send club SMS',
        legends: {
          phonebook: 'Phonebook',
        },
      },
      aggregators: {
        title: 'Operator number',
        numberAggregator: 'Find number operator',
        isValidNumber: 'Is Valid Number',
        form: {
          addTitle: 'Add regex',
          editTitle: 'Edit regex',
          updateRegexTitle: 'Update Regex Title',
          fields: {
            regex: 'Regex',
            smsAggregator: 'Operator',
          },
        },
      },
      documentsManagement: {
        title: 'Documents management',
        form: {
          addTitle: 'Add document',
          editTitle: 'Edit document',
          fields: {},
        },
      },
      currentOrganizationSentCountStatistics: {
        title: 'Current Organization send Count statistics report',
      },
      currentUserSentCountStatistics: {
        title: 'Current user send Count statistics report',
      },
      sentCountStatistics: {
        title: 'Send Count Statistical report',
      },
      currentOrganizationSendStatusStatistics: {
        title: 'Statistical report of the status of the current organization',
      },
      currentUserSendStatusStatistics: {
        title: 'Statistical report of the status of the current user',
      },
      sendStatusStatistics: {
        title: 'Send Status Statistical report',
      },
      currentOrganizationOperatorStatistics: {
        title: 'Statistical report of current organization operators',
      },
      currentUserOperatorStatistics: {
        title: 'Statistical report of current user operators',
      },
      operatorStatistics: {
        title: 'Operator Statistics report',
      },
      complexStatistics: {
        title: 'Comprehensive statistical report',
      },
      currentOrganizationComplexStatistics: {
        title: 'Comprehensive statistical report of the current organization',
      },
      currentUserComplexStatistics: {
        title: 'Comprehensive statistical report of the current user',
      },
      todayStatistics: {
        title: 'Today Statistics report',
      },
      currentOrganizationTodayStatistics: {
        title: 'Todays statistical report of the current organization',
      },
      currentUserTodayStatistics: {
        title: 'Todays statistical report of the current user',
      },
      currentUserSentStatusSeasonsCompareStatistics: {
        title: 'Current user sent status seasons compare statistics',
      },
      currentUserSentStatusAggregateCompareStatistics: {
        title: 'Current user sent status aggregate compare statistics',
      },
      operatorSeasonsCompareStatistics: {
        title: 'Operator seasons compare statistics',
      },
      operatorAggregateCompareStatistics: {
        title: 'Operator aggregate compare statistics',
      },
      statisticalReports: {
        lineComplexDescription: 'Chart of total messages sent by time',
        doughnutChartDescription: 'Chart of the number of messages sent.',
        barChartDescription: 'Chart of messages sent',
        successful: 'Successful',
        unsuccessful: 'Unsuccessful',
        allCount: 'Total count',
        sendingStatusDoughnutChart: 'Sending status chart',
        sendingStatusBarChart: 'Chart of sending status by status',
        targetCount: 'Target SMS count',
        sentCount: 'Sent SMS count',
        untilTargetCount: 'Remaining count to target',
        lineResellersDescription:
          'The chart of sent SMS count and the target SMS count',
        barChartResellersDescription:
          'The chart of the total SMS sent and target count',
      },
      operatorsTodayStatistics: {
        title: 'Operators Today Statistics',
      },
      currentOrganizationResellersStatistics: {
        title: 'Organization resellers statistics',
      },
      packageSales: {
        title: 'SMS packages',
        form: {
          addTitle: 'Add SMS package',
          editTitle: 'Edit SMS package',
          priceErrorMessage:
            'The amount of charge must be more than the amount paid',
          steps: {
            information: 'Package Information',
            amount: 'Amounts & Ratio',
            salesWindow: 'Sales Window & Caps',
            publish: 'Publish',
          },
          fields: {
            expirationType: 'Expiration Type',
            expiration: 'Validity duration',
            depositPrice: 'Charge amount',
            packageInformations: 'Package informations',
            created: 'Creation time',
            identifier: 'Identifier',
            category: 'Category',
            sendType: 'Send Type',
            cardLabel: 'Card Label',
            validityPeriod: 'Validity Period (Days)',
            nominalCredit: 'Nominal Credit',
            ratio: 'Ratio',
            savings: 'Savings',
            visibleFor: 'Visible For',
            realPerson: 'Real Person',
            legalPerson: 'Legal Person',
            authenticated: 'Authenticated',
            agent: 'Agent',
            saleStartDate: 'Sales Start',
            saleEndDate: 'Sales End',
            totalSalesCap: 'Total Sales Cap',
            organizationPurchaseCap: 'Purchase Cap per Organization',
            unlimited: 'Unlimited',
            allowedCategoryRange: 'Allowed category range',
            approxSmsCountLabel: 'Approximate SMS count',
            approxSmsCount: 'Approx. {{count}} SMS',
          },
          messages: {
            saleWindowErrorMessage:
              'Sales end date cannot be before the sales start date',
            capsErrorMessage:
              'Purchase cap per organization cannot exceed the total sales cap',
            bothAmountsRequired: 'Both amounts must be entered.',
            paymentGreaterThanNominal:
              'The payment amount is greater than the nominal credit.',
            ratioOutsideAllowedRange:
              'The ratio {{ratio}}% is outside the allowed category range.',
            expirationDaysMustBePositive:
              'The validity period must be greater than zero.',
            amountsGuide:
              'Enter both the nominal credit and payment amount. The ratio is calculated as 100 × (payment amount ÷ nominal credit).',
            ratioHint:
              'The ratio field is not typeable: ratio = payment amount ÷ nominal credit.',
          },
          publish: {
            changesSummary: 'Changes Summary',
            versionWarning:
              'Changing the amounts will create a new version of this package and will affect organizations that have already purchased it.',
            changed: 'Changed',
            saveDraft: 'Save Draft',
            publishToCatalog: 'Publish to Catalog',
          },
          preview: {
            title: 'Card Preview',
            noTitle: 'Package Name',
            choosePackage: 'Choose package',
          },
          tags: {
            0: 'No tag',
            1: 'Best selling',
            2: 'New',
            3: 'Limited sale',
            4: 'Maximum saving',
          },
        },
      },
      packages: {
        buySmsPackage: {
          title: 'Buy SMS package',
          filters: {
            all: 'All',
            sendType: 'All send types',
            title: 'Choose the right package',
            resultsCount: '{{count}} packages available',
            sendTypeLabel: 'Send type',
            sort: 'Sort by',
          },
          sorts: {
            mostValuable: 'Biggest savings',
            cheapest: 'Cheapest',
            mostNominalAmount: 'Most nominal credit',
            shortestExpiration: 'Shortest validity',
          },
          card: {
            choosePackage: 'Choose package',
            smsApprox: 'Approx. {{count}} Persian SMS',
            nominalCredit: 'Usable credit',
            priceSummary: 'Package credit and price summary',
            payableAmount: 'Amount payable',
            validity: 'Validity',
            sendType: 'Send type',
            ratio: 'Payment ratio',
            validityDays: 'days validity',
            savings: 'savings',
          },
          buyConfirm: 'Are you sure you want to buy this package?',
          empty: 'No packages to display',
          emptyHint: 'Change the selected filters and try again.',
          noteTitle: 'How the SMS count is calculated',
          note: 'The displayed SMS count is an estimate based on a rate of {{price}} rials per Persian SMS segment plus {{resolutionPrice}} rials for the parliament resolution, sent through Pishgam Rayan head numbers.',
          dialog: {
            title: 'Buy SMS package',
            gateway: 'Payment gateway',
            pay: 'Pay',
          },
          checkout: {
            title: 'Cart and payment',
            back: 'Back to packages',
            selectedPackage: 'Selected package',
            returnedCreditNote:
              'If this package expires before it is fully used, the remaining balance multiplied by the payment ratio will be added to your returned credit and can be used on your next purchase.',
            payment: {
              title: 'Payment method',
              anotherMethodOfPayment: 'Other payment methods',
              otherMethodsNotice:
                'This payment method requires review and approval, so it may take longer to complete than other methods.',
              online: 'Bank gateway',
              onlineDescription: 'Pay securely using available bank gateways',
              credit: 'Credit payment',
              creditDescription: 'Pay using your organization credit',
              deposit: 'Deposit slip, card transfer, or cheque',
              organizational: 'Organizational proforma invoice',
              gateway: 'Bank gateway',
              selectGateway: 'Select a bank gateway',
              account: 'Destination account',
              selectAccount: 'Select a destination account',
            },
            bill: {
              title: 'Invoice',
              packageAmount: 'Package amount',
              vat: 'Value-added tax (10%)',
              returnedCredit: 'Returned credit',
              payable: 'Amount payable',
              availableCredit: 'Available credit',
              insufficientCredit:
                'Your organization credit is insufficient for this package.',
              availableReturnedCredit: 'Available returned credit',
              returnedCreditCap: 'Usage limit: 30% of package amount',
              discount: 'Discount',
            },
            issueProforma: 'Issue proforma invoice',
          },
        },
        salesDashboard: {
          title: 'Package sales dashboard',
          subtitle: 'An overview of sales performance and SMS package status',
          analyticsLabel: 'Package sales analytics',
          filters: {
            label: 'Select date range',
            oneMonth: '1 month',
            threeMonths: '3 months',
            sixMonths: '6 months',
            oneYear: '1 year',
          },
          stats: {
            title: 'Sales summary',
            description: 'Key sales metrics for the selected period',
            sales: 'Sales',
            activePackages: 'Active packages',
            expiringPackages: 'Packages expiring soon',
            averageCoefficient: 'Average coefficient',
          },
          chart: {
            title: 'Package sales trend',
            description: 'Monthly sales comparison by category',
          },
          categories: {
            title: 'Category share of sales',
            description: 'Sales amount distribution across package categories',
            alert:
              'Percentages are calculated from total sales in the selected period.',
          },
          states: {
            statsError: 'Sales statistics could not be loaded.',
            statsEmpty: 'There are no statistics to display.',
            chartError: 'The sales chart could not be loaded.',
            chartEmpty: 'There is no sales chart data to display.',
            categoriesError: 'Category shares could not be loaded.',
            categoriesEmpty: 'There is no category share data to display.',
          },
          months: {
            farvardin: 'Farvardin',
            ordibehesht: 'Ordibehesht',
            khordad: 'Khordad',
            tir: 'Tir',
            mordad: 'Mordad',
            shahrivar: 'Shahrivar',
            mehr: 'Mehr',
            aban: 'Aban',
            azar: 'Azar',
            dey: 'Dey',
            bahman: 'Bahman',
            esfand: 'Esfand',
          },
        },
        mySmsPackages: {
          title: 'My SMS packages',
          activePackages: 'Active packages',
          reservedPackages: 'Reserved packages',
          search: 'Search by package name',
          history: 'Package history',
          financialSummary: 'Package financial summary',
          totalNominalAmount: 'Total nominal value',
          totalRemainingAmount: 'Remaining credit',
          totalRemainingPercent: 'Total remaining credit',
          totalPaymentAmount: 'Total paid',
          totalSavingAmount: 'Total savings',
          loading: 'Loading SMS packages',
          loadError: 'SMS packages could not be loaded.',
          empty: 'There are no SMS packages to display.',
          activePackage: 'Active package',
          otherPackages: 'Other packages',
          smsCount: 'SMS count',
          packageAmount: 'Package amount',
          nominalAmount: 'Nominal amount',
          paymentRatio: 'Payment ratio',
          remainingPercent: 'Package remaining',
          approximateSmsCount: 'Approx. {{count}} SMS',
          daysRemaining: '{{count}} days remaining',
          expiresToday: 'Expires today',
          daysExpired: 'Expired {{count}} days ago',
          remaining: 'Remaining',
          startDate: 'Purchase date',
          endDate: 'End date',
          statuses: {
            active: 'Active',
            expired: 'Expired',
            finished: 'Finished',
            reserved: 'Reserved',
            unknown: 'Unknown',
          },
        },
        mySmsPackagesHistory: {
          title: 'Package history',
          fields: {
            packageName: 'Package name',
            category: 'Category',
            status: 'Status',
            nominalAmount: 'Nominal amount',
            paymentAmount: 'Payment amount',
            remainingAmount: 'Remaining credit',
            assignDateTime: 'Start date',
            expireDate: 'End date',
          },
        },
      },
      organizationsSmsPackages: {
        title: 'Organizations SMS packages',
        fields: {
          organizationName: 'Organization name',
          packageName: 'Package name',
          category: 'Category',
          status: 'Status',
          nominalAmount: 'Nominal amount',
          paymentAmount: 'Payment amount',
          remainingAmount: 'Remaining credit',
          sendType: 'Send type',
          tag: 'Tag',
          assignDateTime: 'Start date',
          expireDate: 'End date',
        },
      },
      smsPackageCategories: {
        title: 'Package categories',
        form: {
          addTitle: 'New package category',
          editTitle: 'Edit package category',
          legends: {
            categoryInformation: 'Category information',
          },
          fields: {
            latinId: 'Latin ID',
            minimumCoefficient: 'Minimum coefficient',
            maximumCoefficient: 'Maximum coefficient',
            order: 'Display order',
            organizationsForFilter: 'Organizations filter',
            smsPackagesCount: 'Packages count',
          },
        },
      },
      smsPackageDiscounts: {
        title: 'Package discount codes',
        form: {
          addTitle: 'New package discount code',
          editTitle: 'Edit package discount code',
          legends: {
            discountInformation: 'Discount information',
            calculationType: 'Discount calculation type',
            percentageSettings: 'Percentage discount settings',
            amountSettings: 'Fixed amount discount settings',
          },
          hints: {
            calculationType:
              'Choose whether the discount is calculated as a percentage or a fixed amount.',
          },
          fields: {
            code: 'Discount code',
            smsPackageCategory: 'Package category',
            smsPackageCategoryTitle: 'Package category',
            isPercentage: 'Percentage discount',
            percentage: 'Percentage',
            percentageDescription: 'Reduce the package price by a percentage',
            amount: 'Amount',
            amountDescription: 'Deduct a fixed amount from the package price',
            discountPercent: 'Discount percent',
            discountAmount: 'Discount amount',
            maximumDiscountAmount: 'Maximum discount amount',
            maximumUseCount: 'Maximum use count',
            maximumUseCountPerOrganization: 'Max use count per organization',
            description: 'Description',
          },
          preview: {
            title: 'Live preview',
            subtitle: 'A live summary of the configured discount',
            noCode: 'Discount code',
            percentUnit: '%',
            allOrganizations: 'All organizations',
            selectedOrganizations: 'Selected organizations',
            percentageBadge: 'Percentage discount',
            amountBadge: 'Fixed amount discount',
            discountWord: 'discount',
            note: 'This is a preview; the discount will be applied to the system once created.',
          },
        },
      },
      packageOrganizations: {
        title: 'SMS packages',
        expirationTypes: {
          0: 'Hour',
          1: 'Day',
          2: 'Week',
          3: 'Month',
        },
        expirationNames: {
          0: 'Hourly',
          1: 'Daily',
          2: 'Weekly',
          3: 'Monthly',
        },
        packageOrganizationsCard: {
          legend: 'Buy SMS package',
          discountCodeForOrganizationPackagePrice: 'Discount code',
          packageOrganizationPrice: 'SMS package price',
          buyPackage: 'Buy package',
          discountCode: 'Discount code',
          discountPercent: 'Discount percent',
          typeName: 'Package type',
          discount: 'Discount',
          expirationType: 'Expiration Type',
          organizationPackagePriceDetailsBought:
            'Specifications of the purchased SMS package',
          expiration: 'Type',
          wrongDiscountCodeMessage: 'The entered discount code is not correct',
          successfulDiscountSubmitation:
            'The discount code has been successfully registered.',
        },
      },
      privateNumbersPrice: {
        title: 'Numbers Prices',
        form: {
          addTitle: 'Add Number Price',
          editTitle: 'Edit Number Price',
          fields: {
            isRound: 'Is Round',
            numberOfDigits: 'Number length',
            reservationPeriod: 'Reservation days',
            reservationPeriodWithoutDay: 'Reservation time',
          },
          legends: {
            privateNumberPriceInformation: 'Buy number details',
          },
          messages: {
            alert1:
              'If you select <b class="font-bold">Rand number</b>, <b class="text-red-500 dark:text-red-400">if the type of rand is specified</b>. (for example: 2-digit rouand)',
            alert2:
              'If you choose zero for the reservation period, the reservation period will not be reserved.',
          },
        },
      },
      privateNumberPricePolicies: {
        title: 'Private Number Price Policies',
        form: {
          addTitle: 'Add Private Number Price Policy',
          editTitle: 'Edit Private Number Price Policy',
          fields: {
            privateNumberHeadline: 'Private number headline',
            percentOfBasePriceForRenew: 'Renewal percentage of base price',
            graceDaysAfterDueDate: 'Grace days after due date',
            digitPricePolicies: 'Digit price policies',
            digitsCount: 'Digits count',
            price: 'Price',
            addDigitPricePolicy: 'Add price policy',
          },
        },
      },
      existPrivateNumbers: {
        title: 'Line inventory',
        form: {
          editTitle: 'Edit line price',
          addTitle: 'Add line',
          fields: {
            id: 'ID',
            number: 'Number',
            privateNumberHeadline: 'Number prefix',
            digitsCount: 'Number of digits',
            price: 'Price',
            created: 'Created at',
            totalScore: 'Total score',
            rondTier: 'Rond tier',
            rondRuleCodes: 'Rond rules',
            enableSendTypes: 'Allowed send types',
            refundDeliveryStatusId: 'Refund delivery status',
            smsSenderAgentId: 'SMS sender agent',
          },
        },
      },
      privateNumberForBuyRanges: {
        title: 'Private number purchase ranges',
        detail: {
          title: 'Purchase range details',
        },
        form: {
          addTitle: 'Add purchase range',
          fields: {
            id: 'ID',
            prefixNumber: 'Prefix number',
            privateNumberHeadline: 'Private number headline',
            fromSuffix: 'From suffix',
            toSuffix: 'To suffix',
            buyByRangeEnable: 'Range purchase enabled',
            buyRangeDiscountPercents: 'Range purchase discounts',
            lowerBound: 'Minimum purchase count',
            discountPercent: 'Discount percent',
            canSendLink: 'Link sending allowed',
            created: 'Created at',
            enableSendTypes: 'Allowed send types',
            organizationMaximumBuyCount: 'Maximum purchases per organization',
            refundDeliveryStatusTitle: 'Refund delivery status',
            refundDeliveryStatusId: 'Refund delivery status',
            removeGoldRondNumbersFromStore:
              'Remove gold rond numbers from store',
            showInStore: 'Show in store',
            singleBuyEnable: 'Single purchase enabled',
            smsSenderAgentName: 'SMS sender agent',
            smsSenderAgentId: 'SMS sender agent',
            temporaryReservationMinutes: 'Temporary reservation (minutes)',
            temporaryReservationMinutesForRange: 'Range reservation (minutes)',
            addDiscountPercent: 'Add discount row',
          },
        },
      },
      privateNumbersPriceForUser: {
        title: 'Buy number for users',
        form: {
          fields: {
            isRound: 'Is round',
            numberOfDigits: 'Number length',
            reservationPeriod: 'Reservation days',
            reservationPeriodWithoutDay: 'Reservation time',
            privateNumberPriceNumber: 'Number',
            numberPrice: 'Number price',
          },
          legend: 'Buy number',
          messages: {
            privateNumberPriceDetailsBought: 'Details of the purchased line',
            privateNumberPriceAuthenticationAfterBuy:
              'Dear user, to send SMS with this number, it is necessary to authenticate the line',
            privateNumberPriceAuthentication:
              'Dear user, after purchasing the line, it is necessary to authenticate the purchased line.',
            privateNumberPriceNumber: 'Enter your desired line number',
            discountCodeForPrivateNumberPrice:
              'If you have a discount code to buy, enter it',
            PrivateNumberPriceWithoutAuthentication:
              'Note that it is not possible to use unauthenticated lines.',
            PrivateNumberPriceDeleteOrCancel:
              '<span class="text-red-500 dark:text-red-400">*</span> <span>The request for registering the selected census <b class="text-red-500 dark:text-red-400">cannot</b> be changed, deleted, or canceled. Therefore, please be careful and considerate regarding this matter.</span>',
            PrivateNumberPriceDeleteOrCancelAfterBuy:
              '<span class="text-red-500 dark:text-red-400">*</span> <span>Thank you for your good choice. Please be informed that the selected census registration request <b class="text-red-500 dark:text-red-400">cannot</b> be changed, deleted, or canceled. Therefore, please be careful and considerate regarding this matter.</span>',
          },
        },
        rules: {
          buyNumberRule1:
            'It does not conflict with the principles and foundations of Islam and the Constitution of the Islamic Republic of Iran.',
          buyNumberRule2: 'Do not cause anxiety in the society.',
          buyNumberRule3: 'Do not disturb the order and peace of the society.',
          buyNumberRule4: 'Do not harm the good morals of the society.',
          buyNumberRule5:
            'It does not conflict with the cultural, social and economic policies of the country.',
          buyNumberRule6:
            'It should not be contrary to the principles of elections and laws governing the society.',
          buyNumberRule7:
            'Not inciting, encouraging, persuading, threatening or inviting corruption and prostitution and committing crimes against chastity or sexual perversions (Computer Crimes Law and Article 639 of the Islamic Penal Code)',
          buyNumberRule8:
            'Non-proliferation of obscenity and obscenities in the society (paragraph 2, article 6 of the press law)',
          buyNumberRule9:
            'Failure to publish, distribute and trade content against public modesty (vulgar and obscene) (paragraph 2, article 6 of the Press Law and article 14 of the Computer Crimes Law) inciting, encouraging, persuading, threatening or enticing people to access obscene and vulgar contents (Article 515 of the Computer Crimes Law)',
          buyNumberRule10:
            'Not insulting Imam Khomeini (RA) and distorting her works (Article 514 of the Islamic Penal Code)',
          buyNumberRule11:
            'Not insulting the Supreme Leader and other imitation authorities (Clause 7, Article 6 of the Press Law)',
          buyNumberRule12:
            'Not publishing content against the principles of the Constitution (paragraph 12, article 6 of the Press Law)',
          buyNumberRule13:
            'Non-disclosure and unauthorized publication of the secrets of the armed forces and maps and military fortifications (Paragraph 6, Article 6 of the Press Law)',
          buyNumberRule14:
            'Not publishing any content with the aim of encouraging people to boycott or reduce participation in the elections (paragraphs 3 and 8 of Article 66 of the Election Law of the Islamic Council and Article 46 of the Executive Regulations)',
          buyNumberRule15:
            'Complying with all content rules of digital publication (rules for presenting digital cultural products)',
          buyNumberRule16:
            'It is prohibited to publish digital content that violates the principles of Islam and public rights as follows:',
          buyNumberRule16_1:
            'Destruction of national identity and mockery of religious beliefs, rituals and languages',
          buyNumberRule16_2:
            'Promoting social anomalies, social phenomena and subcultures that are contrary to Islamic Sharia',
          buyNumberRule16_3:
            'Propagation and promotion of deviant sects, false mysticism and lifestyles that are against Islamic Sharia',
        },
      },
      childrenPrivateNumberBuyRequests: {
        title: 'Number buy requests',
        updateStatusPrivateNumberPriceTitle:
          'Edit line purchase request status',
        form: {
          fields: {
            rejectionDescription: 'Reject description',
            payAmount: 'Pay Amount',
            isAllowedSendLink: 'Send link allow',
            isService: 'Service',
            privateNumberPriceIsRound: 'Round number',
            privateNumberPriceNumberOfDigits: 'Number length',
            privateNumberPriceTitle: 'Number title',
            reservationDate: 'Reservation date',
            assignmentDate: 'Assignment date',
            cancellationDate: 'Cancel date',
          },
        },
      },
      rondRules: {
        title: 'Rond rules and price',
        form: {
          calculateTitle: 'Test number',
          fields: {
            rondTier: 'Rond tier',
            lowerBoundOfScore: 'Minimum score',
            coefficient: 'Coefficient',
            fullNumber: 'Full number',
            isExists: 'Number registration status',
            totalScore: 'Total score',
            price: 'Price',
            digits: 'digits',
          },
          numberRequired: 'Please enter a number to calculate its score and price.',
          scoreValidationInfo:
            'Each rule score must be a whole number from 0 to 20.',
          calculationInfo:
            'The number’s score, rond tier and price are calculated using the saved values in the Rond Rules and Tier Definition tables. Save any changes to these tables, then calculate again to update the result.',
          coefficientValidationInfo:
            'The minimum score must be a whole number from 0 to 100. The coefficient must be from 0 to 100 and may be decimal.',
        },
      },
      privateNumberBuyRequests: {
        title: 'Number Buy Requests',
        form: {
          fields: {
            rejectionDescription: 'Reject Description',
            payAmount: 'Pay Amount',
            isAllowedSendLink: 'Send Link Allow',
            isService: 'Service',
          },
        },
        privateNumberUploadDocuments: {
          title: 'Documents',
          form: {
            title: 'Document',
            addTitle: 'Add Title',
            fields: {
              FoundedAnnounce: 'Founded Announce',
              CertificateAddedValue: 'Certificate Added Value',
              CompanyStatute: 'Company Statute',
              MinutesCompanyChanges: 'Company Changes Minutes',
              NationalCard: 'National Card',
              BirthCertificate: 'Birth Certificate',
              documentStatus: 'Document Status',
              description: 'Description',
            },
          },
        },
        privateNumberDocuments: {
          title: 'Documents',
          form: {
            title: 'Document',
            addTitle: 'Add Document',
            legend: 'Documents',
            fields: {
              FoundedAnnounce: 'Founded Announce',
              CertificateAddedValue: 'Certificate Added Value',
              CompanyStatute: 'Company Statute',
              MinutesCompanyChanges: 'Company Changes Minutes',
              NationalCard: 'NationalCard',
              BirthCertificate: 'Birth Certificate',
              documentStatus: 'Status',
              description: 'Description',
            },
          },
        },
      },
      organizationPackages: {
        title: 'Organization Packages',
        depositPrice: 'Charge amount',
        expirationDate: 'Expire Date',
        purchaseDate: 'Purchase Date',
        cancelPackage: 'Cancel Package',
        remainingCredit: 'Remaining Credit',
      },
      childrenOrganizationsPackages: {
        title: 'Sub Organizations Packages',
        depositPrice: 'Charge amount',
        expirationDate: 'Expire Date',
        purchaseDate: 'Purchase Date',
        created: 'Creation date ',
        remainingCredit: 'Remaining Credit',
      },
      landingPageList: {
        title: 'Landing pages',
        form: {
          fields: {
            shortUrl: 'Short url',
          },
        },
      },
      readyTemplates: {
        title: 'Ready templates',
        form: {
          fields: {
            templatePreview: 'Template preview',
          },
        },
      },
      landingPage: {
        title: 'Landing Page',
        goFullScreen: 'Go Full Screen',
        exitFullScreen: 'Exit Full Screen',
        desginer: 'Desginer',
        cssEditor: 'Css editor',
        jsEditor: 'Javascript editor',
        compileAndInjectScss: 'Compile and inject to the page',
        injectJs: 'Inject JavaScript code into the page',
        previewInDesktop: 'Preview In Desktop',
        previewInTablet: 'Preview In Tablet',
        previewInMobile: 'Preview In Mobile',
        previewMode: 'Preview Mode',
        emptyDesignArea: 'Empty Design Area',
        htmlEditor: 'Html editor',
        selectFromTemplates: 'Select From Templates',
        saveLandingPage: 'Save Landing Page',
        saveAsTemplate: 'Save As Template',
        save: 'Save',
        ok: 'Ok',
        isPublic: 'Is Public',
        templatePreview: 'Template Preview',
        readyTemplateImported: 'Ready Template Imported',
        readyTemplateSaved: 'Ready Template Saved',
        landingPageSaved: 'Landing Page is Saved',
        selectTemplatePreview: 'Select Preview Template',
      },
      voiceMessagesGroup: {
        title: 'Voice messages group',
        form: {
          editTitle: 'Edit voice message group',
          addTitle: 'Add voice message group',
        },
      },
      voiceMessages: {
        title: 'Voice Messages List',
        form: {
          addTitle: 'Add voice Messages',
          editTitle: 'Edit voice Messages',
          fields: {
            voiceFile: 'Voice File',
            voiceText: 'Voice Text',
            sendingMethod: 'Sending ethod',
          },
          legends: {
            voiceInformation: 'Voice Information',
            uploadVoiceFile: 'Upload Voice File',
            voiceReader: 'Voice Reader',
          },
          messages: {
            generalExplanation:
              '<span> ● To create an audio file, first choose a title for your audio file.</span><span class="mt-1"> ● Next, you can upload using one of the sending methods. File</b> or <b>Avakhan (text-to-speech tool) </b>Create your audio file.</span><b class="text-red-500 dark:text-red-400 mt-1"> ● Note that every SMS section is equivalent to 30 seconds.</b>',
            fileUploadGuid:
              '<span> ● In this method, you can upload your audio file.</span><span> ● The allowed format of the audio file is <b>MP3, WAV</b> and the maximum file size<b> is 5 MB. </b>is.</span>',
            textToVoiceGuid:
              '<span> ● To create an audio file, first choose a title for your audio file.</span><span class="mt-1"> ● Next, you can upload using one of the sending methods. File</b> or <b>Avakhan (text-to-speech tool) </b>Create your audio file.</span><b class="text-red-500 dark:text-red-400 mt-1"> ● Note that every SMS section is equivalent to 30 seconds.</b>',
          },
        },
        textToVoiceConvertor: {
          delay: 'تاخیر',
          kasre: 'کسره',
          fathe: 'فتحه',
          zame: 'ضمه',
          tashdid: 'تشدید',
          sokoon: 'سکون',
        },
      },
      medias: {
        title: 'Media List',
        form: {
          addTitle: 'Add media',
          editTitle: 'Edit media',
          fields: {
            fileSizePerKilobyte: 'File size per kilobyte',
            fileTypes: 'Social media file types',
            url: 'Url',
          },
        },
        textToVoiceConvertor: {
          delay: 'تاخیر',
          kasre: 'کسره',
          fathe: 'فتحه',
          zame: 'ضمه',
          tashdid: 'تشدید',
          sokoon: 'سکون',
        },
      },
      resellerUsers: {
        title: 'Reseller Users List',
        form: {
          addTitle: 'Add reseller user',
          editTitle: 'Edit reseller user',
          fields: {
            isActiveSend: 'Is Active Send',
            isAdmin: 'Is Admin',
            isAuthenticated: 'Is Authenticated',
            parentOrganizationName: 'Parent Organization Name',
            roles: 'Roles',
            foreignerCode: 'Foreigner code',
            zoneId: 'Zone',
            password: 'Password',
            secondPassword: 'Second password',
            isAuthenticatedMobile: 'Is authenticated mobile',
            roleTemplateId: 'Role template',
            nationalCode: 'National code',
            isSendSmsDescriptionRequired: 'Is send sms description required?',
          },
          legends: {
            personalInformation: 'Personal information',
            systemInformation: 'System information',
            authentication: 'Authentication',
            roleInformation: 'Roles',
          },
        },
      },
      resellerOrganization: {
        title: 'Reseller Organization',
        organizationsExcel: 'Download resellers organization excel',
        form: {
          fields: {
            isActiveSend: 'Activated Sending',
            isActive: 'IsActive',
            isRealPerson: 'IsRealPerson',
            isAuthenticated: 'Is Authenticated',
            groupPriceCategoryTitle: 'Group Price',
            groupPriceTitle: 'Period',
            domainName: 'Domain name',
            panelPrice: 'Panel price',
            isPostpaid: 'Is post paid',
          },
        },
      },
      discount: {
        title: 'Discount Codes',
        form: {
          addTitle: 'Add discount',
          editTitle: 'Edit discount',
          fields: {
            discountCode: 'Discount code',
            discountType: 'Discount type',
            isPercentage: 'Is percentage',
            discountPercentageValue: 'Discount percentage value',
            discountValue: 'Discount value',
            maximumAmount: 'Maximum amount',
            maximumUse: 'Maximum use',
            discountInformation: 'Discount information',
          },
          legends: {
            discountInformation: 'Discount information',
          },
        },
      },
      excelRequest: {
        title: 'Excel request',
        form: {
          changeStatusTitle: 'Change status',
          fields: {
            path: 'Path',
            type: 'Type',
            isReadyForDownload: 'Is ready for download',
            errors: 'Errors',
          },
        },
      },
      plans: {
        title: 'Plans',
        plansManagementTitle: 'Plans management',
        form: {
          addTitle: 'Create plan',
          editTitle: 'Edit plan',
          legends: {
            planSpecifications: 'Plan specifications',
            modules: 'Modules',
          },
          tabs: {
            planSpecifications: 'Plan specifications',
            menusClaims: 'Menus and claims',
          },
          fields: {
            planType: 'Plan type',
            extentionPrice: 'Extention price',
            subTitle: 'Sub title',
            tag: 'Tag',
            discountValue: 'Discount value',
            availableModules: 'Available modules',
          },
        },
        planListModuleForUser: {
          title: 'Buy plan',
          form: {
            legend: 'Buy plan',
            PlanModuleBought: 'Specifications of the bought plan module',
          },
        },
        planListPackageForUser: {
          title: 'Buy package',
          form: {
            legend: 'Purchase package',
            PlanModuleBought: 'Bought plan specification',
          },
          pricingPlans: {
            emptyPlans: 'There are currently no plans to display.',
            loadError: 'Failed to load plans.',
            tryAgain: 'Try again',
            currentPlan: 'Your current plan',
            free: 'Free',
            currency: 'Toman',
            discount: '% off',
            daysRemaining: 'days until expiration',
            startFree: 'Start for free',
            upgradePlan: 'Upgrade plan',
          },
        },
      },
      zonePostalCodes: {
        title: 'Zone postal codes',
        form: {
          addTitle: 'Create zone postal code',
          editTitle: 'Edit zone postal code',
          legend: 'Zone postal code information',
          fields: {
            otherCount: 'Other count',
            rightelCount: 'Rightel count',
            mtnCount: 'Irancell count',
            mciCount: 'Hamrah aval count',
          },
        },
      },
      informationUsersSeen: {
        title: 'Information users seen',
        fields: {
          seenDateTime: 'Seen datetime',
        },
      },
      sendSmartSmsToResidents: {
        title: 'Smart delivery to the residents of the area',
        createRequest: 'Create Request',
        errors: {
          mostSelectPolygon:
            'To register a request, you must specify at least one area on the map.',
        },
      },
      occasionScheduledMessage: {
        title: 'List of Occasional Sending Requests',
        form: {
          fields: {
            phonebookCustomFieldNameEn: 'Custom field',
            calenderEvent: 'Calendar event',
            toConsiderYear: 'To Consider Year',
            calenderOrganizationEvent: 'Organizational opportunity',
            dynamicTemplateTitle: 'Dynamic template',
            howManyDaysSendItBeforeDueDate:
              'Send SMS before the date of the event (day)',
          },
        },
      },
      shortLinks: {
        title: 'Short links',
        descendantTitle: 'Descendant short links',
        form: {
          addTitle: 'Create short link',
          legend: 'Short link',
          fields: {
            shortUrl: 'Short link',
            mainUrl: 'Main url',
            urlType: 'Url type',
          },
        },
      },
      phonebookFileProgresses: {
        title: 'Create contacts status',
        fields: {
          fileName: 'File name',
          status: 'Status',
          phonebookId: 'Phonebook id',
          phonebookName: 'Phonebook name',
          progressPercent: 'Progress percent',
          totalCount: 'Total count',
        },
      },
      customerClubDevice: {
        title: 'Customer club devices',
        form: {
          addTitle: 'Create customer club device',
          editTitle: 'Edit customer club device',
          detailTitle: 'Customer club device detail',
          legends: {
            generalInformation: 'General information',
            details: 'Answer',
            phonebooksList: 'Phonebooks list',
          },
          fields: {
            deviceId: 'Device id',
            webhookUrl: 'Webhook url',
            phonebookIdList: 'Phonebook list',
            delayType: 'Delay type',
            delayValue: 'Delay value',
            isShowDetail: 'Is show detail?',
          },
        },
      },
      customerClubDeviceNumbers: {
        title: 'Device numbers',
      },
      frontAudits: {
        title: 'Front audits',
      },
      calendarEvent: {
        title: 'Calendar events',
        calendarEvents: 'Calendar events',
        calenderOrganizationEvents: 'Occasions created by the organization',
        form: {
          addTitle: 'Create an occasion',
          editTitle: 'Edit the occasion',
          deleteTitle: 'Delete the occasion',
          detailTitle: 'Detail the occasion ',
          filterTitle: 'Filter the occasion',
          fields: {},
        },
      },

      sendOccasionSms: {
        title: 'Occasional posting ',
        legends: {
          messageInformation: 'Message details',
          phonebook: 'Phonebook',
        },
        fields: {
          howManyDaysSendItBeforeDueDate:
            'Send SMS before the date of the event (day)',
          calendarEvents: 'Calendar event',
          calenderOrganizationEvents: 'Occasion created by the organization',
          toConsiderYear: 'To Consider Year',
        },
      },

      smartSmsCampaigns: {
        title: 'Smart sms campaigns list',
        form: {
          addTitle: 'Add smart sms campaign',
        },
      },
      smartSmsClubs: {
        title: 'Smart sms clubs list',
        form: {
          addTitle: 'Add smart sms club',
          addNumbersTitle: 'Add numbers to club',
        },
      },
      numbersAggregator: {
        title: 'Numbers aggregator',
        numbersAggregatorList: 'Numbers aggregator list',
      },
      numbersBlackLists: {
        title: 'numbers black lists',
        numbersBlackListsList: 'Numbers black lists list',
      },
      contactsByCellPhone: {
        title: 'Contacts list',
        form: {
          editTitle: 'Edit contact',
          legend: 'Contact information',
          fields: {
            contactCreateType: 'Create type',
            job: 'Job',
            phonebookTypes: 'Phonebook types',
          },
          messages: {
            description:
              'Attention: By changing information, old values will replace with new values.',
          },
        },
      },
      fieldsManagement: {
        title: 'Fields management',
        form: {
          addTitle: 'Add field',
          editTitle: 'Edit field',
          legend: 'Field detail',
          fields: {
            fieldType: 'Field type',
            maxValue: 'Max value',
            minValue: 'Min value',
            maxLength: 'Max length',
            minLength: 'Min length',
            regexValidation: 'Regex validation',
            maxFileSizeByMegabyte: 'Max file size by megabyte',
          },
        },
      },
      formsManagement: {
        title: 'ّForms management',
        newFormBuilderVersion: 'New form builder version',
        form: {
          addTitle: 'Add form',
          editTitle: 'Edit form',
          legend: 'form detail',
          fields: {
            fieldType: 'Field type',
            maxValue: 'Max value',
            minValue: 'Min value',
            maxLength: 'Max length',
            minLength: 'Min length',
            regexValidation: 'Regex validation',
            maxFileSizeByMegabyte: 'Max file size by megabyte',
            theme: 'Theme',
            field: 'field',
            order: 'Order',
          },
        },
      },
      smartSmsNumberClasses: {
        title: 'Classes list',
        form: {
          addTitle: 'Add class',
          editTitle: 'Edit class',
          legend: 'Class information',
          fields: {
            operatorClasses: 'Operator classes',
          },
        },
      },
      checkNumberClassResponses: {
        title: 'Requests list',
        form: {
          addTitle: '',
          editTitle: '',
          fields: {
            checkTime: 'Check time',
          },
        },
      },
      onlineSurveyList: {
        title: 'Online surveys list',
      },
      onlineSurveyResponses: {
        title: 'Online surveys responses',
      },
      onlineSurveyStatistics: {
        title: 'Online surveys statistics',
      },
      createSmsInformation: {
        title: 'Send information',
      },
      processTextResults: {
        title: 'Process text results',
      },
      userNotificationSettings: {
        title: 'User notification settings',
      },
      organizationNotificationSettings: {
        title: 'Organization notification settings',
      },
    },
    enums: {
      Desktop: {
        MainDesktop: 'Main desktop',
        OrangeDesktop: 'Orange desktop',
        WindowsDesktop: 'Windows desktop',
        AndroidDesktop: 'Android desktop',
        Default: 'Default',
        Dark: 'Dark',
      },
      LoginTheme: {
        Default: 'Default',
        Dark: 'Dark',
      },
      ComparisonOperator: {
        EqualTo: 'Equal to',
        NotEqualTo: 'Not equal to',
        GreaterThan: 'Greater than',
        GreaterThanOrEqual: 'Greater than or equal',
        LessThan: 'Less than',
        lessThanOrEqual: 'Less than or equal',
        Contains: 'Contains',
        NotContains: 'Not contains',
        StartsWith: 'Starts with',
        EndsWith: 'Ends with',
      },
      SenderAgentType: {
        SMS: 'SMS',
        MMS: 'MMS',
        Email: 'Email',
        Voice: 'Voice',
      },
      SmsCp: {
        Magfa: 'Magfa',
        Asanak: 'Asanak',
        Armaghan: 'Armaghan',
        RahyabRG: 'Rahyabrg',
        RahyabPG: 'Rahyab pg',
        SLS: 'SLS',
        Shreeweb: 'ShreeWeb',
        SocialNetworks: 'Social networks',
        Avanak: 'Avanak',
        Gama: 'Gama',
        PishgamRayan: 'Pishgamrayan',
      },
      TypePrivateNumber: {
        Bulk: 'Bulk',
        InteractiveBulk: 'Inter active bulk',
        SmsMT: 'SmsMt',
        SmsMO: 'SmsMo',
        USSDMT: 'Ussdmt',
        USSDMO: 'Ussdmo',
        OPT: 'Opt',
      },
      SendPriority: {
        Lowest: 'Lowest',
        VeryLow: 'Very low',
        Low: 'Low',
        Normal: 'Normal',
        AboveNormal: 'Above normal',
        High: 'High',
        VeryHigh: 'Very high',
        Highest: 'Highest',
      },
      PrivateNumberUseForm: {
        OneNumber: 'One number',
        Mask: 'Mask',
        RangeNumber: 'Range number',
      },
      ZoneType: {
        Country: 'Country',
        Province: 'Province',
        City: 'City',
        Area: 'Area',
      },
      PeriodTypeValue: {
        Minute: 'Minute',
        Hour: 'Hour',
        Daily: 'Daily',
        Weekly: 'Weekly',
        Monthly: 'Monthly',
        Yearly: 'Yearly',
      },
      SmsSentPeriodType: {
        Minute: 'Minute',
        Hour: 'Hour',
        Daily: 'Daily',
        Weekly: 'Weekly',
        Monthly: 'Monthly',
        Yearly: 'Yearly',
      },
      PeriodType: {
        Minute: 'Minute',
        Hour: 'Hour',
        Daily: 'Daily',
        Second: 'Second',
      },
      SendSubTypes: {
        Direct: 'Direct',
        Gradual: 'Gradual',
        Periodic: 'Periodic',
        GradualPeriodic: 'Gradual periodic',
        Voice: 'Voice',
      },
      TypeBanks: {
        EghtesadNovin: 'Eghtesad novin',
        Pasargad: 'Pasargad',
        Parsian: 'Parsian',
        Tat: 'Tat',
        Tejarat: 'Tejarat',
        Saman: 'Saman',
        Sepah: 'Sepah',
        Shahr: 'Shahr',
        Saderat: 'Saderat',
        Mehr: 'Mehr',
        Keshavarzi: 'Keshavarzi',
        Gardeshgari: 'Gardeshgari',
        Maskan: 'Maskan',
        Mellat: 'Mellat',
        Melli: 'Melli',
      },
      SmartSmsStatus: {
        Done: 'Done',
        Failed: 'Failed',
        InternalError: 'Internal error',
        NotFound: 'Not found',
        Stored: 'Stored',
        Unknown: 'Unknown',
        Waiting: 'Waiting',
      },
      TypeIpGs: {
        Sadad: 'Sadad',
        BehPardakht: 'Behpardakht',
        Aap: 'Aap',
        Top: 'Top',
        Saman: 'Saman',
        Sepehr: 'Sepehr',
        IdPay: 'Idpay',
        IranKish: 'Irankish',
        Melli: 'Melli',
        ParbadVirtual: 'Parbad virtual',
        Parsian: 'Parsian',
        Pasargad: 'Pasargad',
        ZarinPal: 'Zarinpal',
        PayIr: 'Payir',
        Mellat: 'Mellat',
        AsanPardakht: 'Asan pardakht',
      },
      DeliveryStatus: {
        Unknown: 'Unknown',
        SentAndReceivedbyPhone: 'Sent and received by phone',
        HaveNotReceivedToPhone: 'Have not received to phone',
        SentToItc: 'Sent to itc',
        ReceivedByItc: 'Received by itc',
        DidNotReceiveToItc: 'Did not receive to itc',
        NotReceivebyServer: 'Not receive by server',
        ErrorInSending: 'Error in sending',
        WaitingForSend: 'Waiting for send',
        Sent: 'Sent',
        NotSent: 'Not sent',
        Expired: 'Expired',
        IsSending: 'Is sending',
        IsCanceled: 'Is canceled',
        BlackList: 'Blacklist',
        SmsIsFilter: 'SMS is filter',
        IsDeleted: 'Is deleted',
        WatingForConfirmation: 'Wating for confirmation',
        NotEnoughBalance: 'Not enough balance',
        IsPreparing: 'Is preparing',
        IsPreparedForSending: 'Is prepared for sending',
        AccessDenied: 'Access denied',
        TextIsEmpty: 'Text is empty',
        InvalidInputXml: 'Invalid input xml',
        InvalidUserOrPassword: 'Invalid user or password',
        InvalidUsedMethod: 'Invalid used method',
        InvalidSender: 'Invalid sender',
        InvalidMobile: 'Invalid mobile',
        InvalidReciption: 'Invalid reciption',
        Stored: 'Stored',
        BlackListTable: 'Blacklist table',
        GetDeliveryStatus: 'Get delivery status',
        InvalidPrivateNumber: 'Invalid private number',
        NotReceiveByPhone: 'Not receive by phone',
        NotReceivedByItc: 'Not received by Itc',
        DidNotReceivedByItc: 'Did not received by Itc',
        ReceivedByPhone: 'Received by phone',
      },
      SendStatus: {
        Unknown: 'Unknown',
        Sent: 'Sent',
        SentAndGiveBackCredit: 'Sent and give back credit',
        ErrorInSending: 'Error in sending',
        ErrorInGetItc: 'Error In get itc',
        BlackList: 'Blacklist',
        Stored: 'Stored',
      },
      MainSettings: {
        SendSmsAlertMessage: 'Send SMS alert message',
        AppPath: 'App path',
        RemoteQueueIp: 'Remote queue ip',
        DefaultNumber: 'Default number',
        IsRemoteQueue: 'Is remote queue',
        VasRegisterSmsText: 'Vas register SMS text',
        MaximumFailedTryCount: 'Maximum failed try count',
        RetrievePasswordSmsText: 'Retrieve password SMS text',
        RegisterFishMobiles: 'Register fish mobiles',
        OnlinePaymentSmsText: 'Online payment SMS text',
        UserExpireSmsText: 'User expire SMS text',
        RegisterFishSmsText: 'Register fish SMS text',
        ExportFileAddress: 'Export file address',
        Tax: 'Tax',
        AuthenticatedMobileSmsText: 'Authenticated mobile SMS text',
        LowestCreditOfUser: 'Lowest credit of user',
        ResolutionOfParliament: 'Resolution of parliament',
      },
      GenderType: {
        All: 'All',
        Man: 'Man',
        Woman: 'Woman',
      },
      SimType: {
        All: 'All',
        Credits: 'Credits',
        Permanent: 'Permanent',
      },
      FailureCode: {
        None: 'None',
        UserCreditNotEnough: 'User credit not enough',
        AdminCreditNotEnough: 'Admin credit not enough',
        PrivateNumberIsExpired: 'Private number is expired',
        UserIsInactive: 'User is in active',
        AdminIsInactive: 'Admin is in active',
        PrivateNumberNotValid: 'Private number not valid',
        NotDefineSmsRateType: 'Not define SMS rate type',
        SendError: 'Send error',
        UserCancelRequest: 'User cancel request',
        SystemIsOutOfService: 'System is out of service',
        SendTimeNotValid: 'Send time not valid',
        SmsTextIsFilter: 'SMS text is filter',
        UserIsExpired: 'User is expired',
        AdminIsExpired: 'Admin is expired',
        LinkIsNotAllowed: 'Link is not all owed',
        RecipientNotExist: 'Recipient not exist',
        ErrorCalculate: 'Error calculate',
        ErrorSelectNumber: 'Error select number',
        ErrorInSaveJob: 'Error in save job',
        ScheduledMessageNotFound: 'Scheduled message not found',
        OrganizationOrHierarchyIsInactive:
          'Organization or hierarchy is in active',
        GroupPriceIsNull: 'Group price is null',
        OrganizationCreditNotEnough: 'Organization credit not enough',
        OperatorNumberCountIsNull: 'Operator number count is null',
        OrganizationNotFound: 'Organization not found',
        NotSended: 'Not sended',
        OrganizationIsExpired: 'Organization is expired',
        PrivateNumberIsInactive: 'Private number is in active',
        OrganizationIsInactive: 'Organization is in active',
      },
      SendTypes: {
        Bulk: 'Bulk',
        Dynamic: 'Dynamic',
        P2P: 'P2p',
        Single: 'Single',
        PhoneBook: 'Phonebook',
        Api: 'Api',
      },
      QueueStatus: {
        Completed: 'Completed',
        Confirmed: 'Confirmed',
        Extracted: 'Extracted',
        Extracting: 'Extracting',
        Failed: 'Failed',
        FailedExtract: 'Failed extra ct',
        Ready: 'Ready',
        Rejected: 'Rejected',
        Stored: 'Stored',
        Updating: 'Updating',
        WatingForConfirm: 'Wating for confirm',
      },
      SmsAggregator: {
        NotValid: 'Not valid',
        MCI: 'Mci',
        MCI2: 'Mci2',
        Irancell: 'Irancell',
        Rightel: 'Rightel',
        Other: 'Other',
        International: 'International',
        // Taliya: '// taliya',
        // MTCE: '// mtce',
        // KishTCI: '// kish tci',
      },
      SmsLanguage: {
        Farsi: 'Farsi',
        Latin: 'Latin',
      },
      UseTypes: {
        Unknown: 'Unknown',
        Normal: 'Normal',
        WebService: 'Web service',
      },
      NumberType: {
        Public: 'Public',
        Private: 'Private',
        PrivateWithKeyword: 'Private with keyword',
      },
      TypeCreditChanges: {
        Manage: 'Manage',
        BuyPanel: 'Buy panel',
        ExtendedPanel: 'Extended panel',
        Fish: 'Fish',
        OnlinePayment: 'Online payment',
        PriceNumber: 'Price number',
        ActivationService: 'Activation service',
        GiveBackCostOfUnsuccessSent: 'Give back cost of unsuccess sent',
        ActivationGeneralPhoneBook: 'Activation general phonebook',
        SendSms: 'Send SMS',
        DeleteUser: 'Delete user',
        TransferPrivateNumber: 'Transfer private number',
      },
      TypeTransactions: {
        Increase: 'Increase',
        Decrease: 'Decrease',
      },
      UserDocuments: {
        BirthCertificate: 'Birth certificate',
        NationalCard: 'National card',
        OptionalField1: 'Optional field 1',
        OptionalField2: 'Optional field 2',
      },
      OrganizationDocuments: {
        BusinessLicense: 'Business license',
        CeoBirthCertificate: 'Ceo birth certificate',
        CeoNationalCard: 'Ceo national card',
        FoundedAnnounce: 'Founded announce',
        LatestChangesAnnounce: 'Latest changes announce',
        OptionalField1: 'Optional field 1',
        OptionalField2: 'Optional field 2',
      },
      DocumentStatus: {
        NotCheckedYet: 'Not checked yet',
        Accepted: 'Accepted',
        NotAccepted: 'Not accepted',
      },
      CustomFieldTypes: {
        Boolean: 'Boolean',
        Datetime: 'Date time',
        Float: 'Float',
        Integer: 'Integer',
        String: 'String',
      },
      TypePayments: {
        Cash: 'Cash',
        Cheque: 'Cheque',
        Card: 'Card',
        Account: 'Account',
        OnLine: 'Online',
      },
      TypePaymentStatus: {
        Confirmed: 'Confirmed',
        Rejected: 'Rejected',
        Checking: 'Checking',
        Lending: 'Lending',
        WatingForPay: 'Wating for pay',
      },
      OutBoxStatus: {
        Stored: 'Stored',
        WatingForSend: 'Wating for send',
        IsBeingSent: 'Is being sent',
        Sent: 'Sent',
        SentAndGiveBackCredit: 'Sent and give back credit',
        Archived: 'Archived',
        ErrorInSending: 'Error in sending',
        ErrorInGetItc: 'Error in get itc',
        BlackList: 'Blacklist',
        WatingForConfirm: 'Waiting for confirm',
        Archiving: 'Archiving',
      },
      Encoding: {
        English: 'English',
        Persian: 'Persian',
      },
      ExportDataStatus: {
        None: 'None',
        Get: 'Get',
        Complete: 'Complete',
        Refresh: 'Refresh',
      },
    },
    common: {
      timeRangeSelector: {
        label: 'Select date range',
        oneMonth: '1 month',
        threeMonths: '3 months',
        sixMonths: '6 months',
        oneYear: '1 year',
      },
      lang: {
        fa: 'Fa',
        en: 'En',
      },
      icon: 'Icon',
      dateTime: {
        minute: 'Minute',
        hour: 'Hour',
        day: 'Day',
        week: 'Week',
        month: 'Month',
        year: 'Year',
      },
      persianMonth: {
        Farvardin: 'Farvardin',
        Ordibehesht: 'Ordibehesht',
        Khordad: 'Khordad',
        Tir: 'Tir',
        Mordad: 'Mordad',
        Shahrivar: 'Shahrivar',
        Mehr: 'Mehr',
        Aban: 'Aban',
        Azar: 'Azar',
        Dey: 'Dey',
        Bahman: 'Bahman',
        Esfand: 'Esfand',
      },
      daysOfTheWeek: {
        saturday: 'Saturday',
        sunday: 'Sunday',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
      },
      calenderDate: {
        solar: 'Solar',
        ad: 'Ad',
        lunar: 'Lunar',
      },
      color: {
        red: 'Red',
        blue: 'Blue',
        purple: 'Purple',
        gray: 'Gray',
        white: 'White',
        green: 'Green',
        navyBlue: 'Navy Blue',
        yellow: 'Yellow',
        pink: 'Pink',
      },
      files: 'Files',
      replace: 'Replace',
      manual: 'Manual',
      noDataFound: 'No data found!',
      rial: 'Rial',
      allCount: 'All count',
      sendedCount: 'Sent count',
      row: 'Row',
      mobileNumbersCount: 'Mobile numbers count',
      changeMobileNumber: 'Change mobile number',
      name: 'Name',
      newName: 'New name',
      firstName: 'First name',
      lastName: 'Last name',
      fatherName: 'Father name',
      fullName: 'Full name',
      nationalCode: 'National code',
      messageCancelText: 'Message cancel text',
      level: 'level',
      nationalId: 'National id',
      showCalender: 'Show calender',
      selectedDaysCount: 'Selected days count',
      chooseSendDays: 'Choose send days',
      email: 'Email',
      street: 'Street',
      dehestan: 'Dehestan',
      neighbourhood: 'Neighbourhood',
      highway: 'Highway',
      freeway: 'Freeway',
      tunnel: 'Tunnel',
      square: 'Square',
      boulevard: 'Boulevard',
      university: 'University',
      county: 'County',
      park: 'Park',
      captcha: 'Captcha',
      chosen: 'Selected',
      retry: 'Retry',
      assignDate: 'Assign date',
      PrivateNumberCreated: 'Private number Created',
      historyCreated: 'History created date',
      typePayment: 'Payment type',
      paymentStatus: 'Payment status',
      noResultFound: 'No result found',
      plansHistory: 'Plans History',
      planName: 'Plan name',
      activationTime: 'Activation date',
      deactivationTime: 'Deactivation date',
      searchByPlanName: 'Search by plan name',
      inactive: 'Inactive',
      payerCustomerHistory: 'Payer Customer History',
      latestPayments: 'Latest Payments',
      latestOutboxMessages: 'Latest Outbox Messages',
      lastMonthTotalOutboxMessagesCount:
        'Last Month Total Outbox Messages Count',
      lastMonthTotalReceiversCount: 'Last Month Total Receivers Count',
      SMSSignatureIsEnabled: 'SMS signature is enabled',
      faxNumber: 'Fax number',
      phone: 'Phone',
      referenceId: 'Reference id',
      occasionScheduledMessageId: 'Occasion scheduled message id',
      identityNumber: 'Identity number',
      birthDate: 'Birth date',
      gender: 'Gender',
      title: 'Title',
      group: 'Group',
      claimGroup: 'Claim group',
      active: 'Active',
      count: 'Count',
      file: 'File',
      activeSend: 'Active send',
      sendWithDuplicateNumbers: 'Send with duplicate numbers',
      credit: 'Credit',
      mobile: 'Mobile',
      select: 'Select',
      public: 'Public',
      private: 'Private',
      parentPublic: 'Parent public',
      year: 'Year',
      firstYear: 'First year',
      secondYear: 'Second year',
      month: 'Month',
      day: 'Day',
      text: 'Text',
      downloadLink: 'Download link',
      voiceFileDownloadLink: 'Voice file download link',
      voiceFile: 'Voice file',
      voiceMessage: 'Voice message',
      socialMediaApplication: 'Social media application',
      socialMediaMessage: 'Social media file',
      patch: 'Patch',
      receipt: 'Receipt',
      sender: 'Sender',
      farsi: 'Persian',
      latin: 'Latin',
      nonFarsi: 'Not Persian',
      data: 'Data',
      sms: 'SMS',
      part: 'Part',
      binary: 'Binary',
      userName: 'User name',
      password: 'Password',
      activePlan: {
        title: 'Current Plan',
        noActivePlan: 'No active plan',
        noActivePlanDescription: 'Choose a plan to access the features.',
        free: 'Free',
        freePlan: 'Basic plan with limited features',
        baseFeatures: 'Basic plan with limited features',
        validUntil: 'Valid until',
        expiringSoon: 'Expiring soon',
        remainingDays: '{{count}} day(s)',
        remainingHours: '{{count}} hour(s)',
        expired: 'Plan expired',
        upgradePlan: 'Upgrade Plan',
      },
      rePassword: 'Repassword',
      newRePassword: 'Repeat new password',
      show: 'Show',
      oldPassword: 'Old password',
      newPassword: 'New password',
      price: 'Price',
      number: 'Number',
      save: 'Save',
      maxSendCount: 'Max Send Count',
      allRecords: 'All records:',
      amount: 'Amount',
      notValid: 'Is not valid.',
      validMobile: 'Valid mobile',
      notValidMobile: 'Not valid mobile',
      setting: 'Setting',
      privateNumber: 'Private number',
      privateNumbers: 'Private numbers',
      buyNumber: {
        title: 'Buy a private number',
        subtitle: 'Find and choose the right number for your business.',
        search: 'Search phone number',
        all: 'All numbers',
        available: 'Available to buy',
        compare: 'Compare',
        selected: 'Selected number',
        clear: 'Clear selection',
        price: 'Purchase price',
        renewal: 'Annual renewal',
        maintenance: 'Maintenance cost',
        pattern: 'Number pattern',
        digits: 'Digits',
        action: 'Reserve for 15 minutes',
        requestPrice: 'Request a quote',
        unavailablePrice: 'Price on request',
        noResults: 'No numbers match your search.',
        compareHint: 'Select up to 3 numbers to compare.',
        compareCount: 'of 3 selected',
        limitReached: 'You can compare up to 3 numbers.',
        badges: {
          lucky: 'Premium',
          link: 'Link',
          receive: 'Inbound',
          golden: 'Golden',
          nonLucky: 'Standard',
          ordinary: 'Regular',
        },
      },
      isAuthenticated: 'Is authenticated',
      isAuthenticatedMobile: 'Is authenticated mobile',
      organizationName: 'Organization name',
      isForeigner: 'Is foreigner',
      id: 'Id',
      warning: 'Warning',
      login: 'Login',
      lockOut: 'Block',
      unblock: 'Unblock ',
      sendSubType: 'Send subType',
      sendSubDateType: 'Send subdate type',
      loginToUserAccount: 'Login to user account',
      loginOrganization: 'Login to organization',
      loginToAccount: 'Login to account',
      loginWithIdentity: 'Login with identity',
      signUpWithIdentity: 'Signup with identity',
      rememberMe: 'Remember me',
      forgetPassword: 'Forget password',
      editPassword: 'Edit password',
      signUp: 'Signup',
      goToLogin: 'Go to login',
      account: 'Account',
      receivers: 'Receivers',
      fastSend: 'Fast send',
      testSend: 'Test send',
      tableSetting: 'Table Setting',
      defaultGroupPrice: 'Default group price',
      PhonebookRecipient: 'Phonebook recipient',
      startDate: 'Start date',
      endDate: 'End date',
      description: 'Description',
      minPrice: 'Min price',
      maxPrice: 'Max price',
      typeBank: 'Type bank',
      operation: 'Operation',
      createDate: 'Create date',
      pattern: 'Pattern',
      messageInformation: 'Message information',
      sendDateTimeType: 'Send settings',
      confirmSmartSmsRequest: 'Confirm smart SMS request',
      justSendToWhiteList: 'Just send to white list',
      isFlashSms: 'Send flash sms',
      scheduledMessageId: 'Scheduled message id',
      lastModifiedDate: 'Last modified date',
      expireDate: 'Expire date',
      expireTime: 'Expire time',
      authenticated: 'Authenticated',
      addSingle: 'Add single',
      addListNumber: 'Add list number',
      addFromFile: 'Add from file',
      authenticatedMobile: 'Authenticated mobile',
      deleteAllContact: 'Delete all contact',
      columns: 'Columns',
      key: 'Key',
      creditPayment: 'CreditPayment',
      onlinePayment: 'OnlinePayment',
      value: 'Value',
      customText: 'Custom text',
      searchFilter: 'Search filter',
      userInfo: 'User info',
      userId: 'User id',
      userManual: 'User manual',
      createTemplate: 'Create template',
      numberList: 'Numbers list',
      generalIndexes:
        'If you enter general indexing, the above indices are not taken into account',
      bulkSendDetail: 'Bulk send detail',
      merchantId: 'Merchant id',
      terminalId: 'Terminal id',
      androidPreview: 'Android Preview',
      iosPreview: 'Ios Preview',
      terminalKey: 'Terminal key',
      userPassword: 'User Password',
      shaKey: 'SHA key',
      loginAccount: 'Login account',
      merchantCode: 'Merchant code',
      privateKey: 'Private Key',
      activationDate: 'Activation Date',
      acceptorId: 'Acceptor id',
      passPhrase: 'Pass phrase',
      publicKey: 'Public key',
      sendPrice: 'Sending Cost',
      privateCode: 'Private code',
      merchantConfigurationId: 'Receiver configuration number',
      creditNotEnough: 'Your credit is not enough!',
      generalUse: 'General use',
      usingTheInvoice: 'Using the invoice',
      generalIndexing: 'General indexing',
      invoice: 'Invoice',
      orderId: 'Order id',
      resellerName: 'Reseller name',
      date: 'Date',
      hour: 'Hour',
      appVersion: 'Application version',
      minute: 'Minute',
      pishgamRayanDadehPajoohCo: 'Pishgam Data Research Company',
      esfahan: 'Esfahan',
      phoneNumberFax: 'Phone number / Fax',
      postalCode: 'Postal code',
      pishgamRayanAddress:
        'حد فاصل چهار راه آپادانا و سپهسالار، جنب بانک تجارت، ساختمان تندیس، طبقه ۴، واحد۴۱',
      organization: 'Organization',
      getterOrganization: 'Getter organization',
      getterUser: 'Getter user',
      currentOrganization: 'Current organization',
      organizations: 'Organizations',
      shortcuts: 'Shortcuts',
      operator: 'Operator',
      smsEncoding: 'SMS encoding',
      domainId: 'Domain id',
      domainName: 'Domain name',
      parentId: 'Parentid',
      parentOrganization: 'Parent organization',
      user: 'User',
      deleteSelectedFile: 'Delete selected file',
      users: 'Users',
      chosenPhonebooks: 'Selected phonebook',
      userList: 'User list',
      organizationList: 'Organization list',
      senderNumberId: 'Sender number id',
      characterCount: 'Character count',
      smsBody: 'SMS body',
      claimsCount: 'Claims count',
      menusCount: 'Menus count',
      selectedCount: 'Selected count',
      enamad: 'Enamad',
      domainHeader: 'Header',
      convertToPersianNumbers: 'Convert to persian numbers',
      realPerson: 'Real person',
      legalPerson: 'Legal person',
      sendHour: 'Send hour',
      sendDay: 'Send day',
      startDay: 'Start day',
      position: 'Position',
      permissions: 'Permissions',
      signaturePosition: 'Signature position',
      organizationSignaturePosition: 'Organization signature position',
      organizationHeaderPosition: '',
      headerPosition: '',
      startTime: 'Start time',
      trustMark: 'Trust Mark',
      startHour: 'Start hour',
      endDay: 'End day',
      endTime: 'End time',
      endHour: 'End hour',
      partCount: 'Part count',
      campaign: 'Campaign',
      campaignId: 'Campaign id',
      groupPriceCategory: 'Group price category',
      environmentInfo: 'Environment info',
      logInfo: 'Log info',
      hello: 'Hello',
      selectedTheme: 'Selected theme',
      selectedTemplate: 'Selected template',
      privateNumberList: 'Private Number List',
      from: 'From',
      to: 'To',
      groupDeletion: 'Group deletion',
      groupEdit: 'Group edit',
      new: 'New',
      clickToShow: 'Click to show',
      phonebook: 'Phonebook',
      phonebooks: 'Phonebooks',
      accountInformation: 'Account information',
      accountInformationCardNo: 'Account information card no',
      NumberOfRecords: 'Number of records',
      NumberOfViews: 'Number of views',
      page: 'Page',
      username: 'User name',
      loading: 'Loading',
      error: 'Error',
      info: 'Info',
      type: 'Type',
      ipAddress: 'Ip address',
      browser: 'Browser',
      device: 'Device',
      os: 'Os',
      refreshToken: 'Refresh token',
      refreshTokenExpiration: 'Refresh token expiration',
      isActive: 'Is active',
      deActive: 'De active',
      loginToPanel: 'Login to panel',
      fieldRequired: 'This field is required',
      removeRule: 'Reomve Rule',
      modules: 'Modules',
      personType: 'Person type',
      yourCredit: 'Your credit',
      isPublic: 'Is public',
      isActiveSend: 'Is active send',
      isDefault: 'Is default',
      contactsCount: 'Contacts count',
      changeDefault: 'Change default',
      myOrganizations: 'My organizations',
      senderNumber: 'Sender number',
      defaultOrganization: 'Default organization',
      activeOrganization: 'Active organization',
      currentOrganizations: 'Current organizations',
      detail: 'Detail',
      mediaDetail: 'Media Detail',
      male: 'Male',
      female: 'Female',
      mci: 'Mci',
      mtn: 'Mtn',
      rightel: 'Rightel',
      confirmSend: 'Confirm send',
      rejectSend: 'Reject send',
      organizationId: 'Organization id',
      currentStatus: 'Current status',
      changeStatusTo: 'Change status to',
      deliveryStatus: 'Delivery status',
      partLength: 'Part length',
      sendTo: 'Send to',
      unknown: 'Unknown',
      dynamicTemplate: 'Dynamic template',
      selectField: 'Select field',
      defineDynamicTemplate: 'Define dynamic template',
      customField: 'Custom field',
      customFields: 'Custom fields',
      showDetails: 'Show details',
      English: 'English',
      Persian: 'Persian',
      format: 'Format',
      increase: 'Additive',
      decrease: 'Decrease',
      paymentId: 'Payment id',
      typeTransaction: 'Transaction Type',
      whiteMessageId: 'Customers club id',
      delete: 'Delete',
      edit: 'Edit',
      transferNumber: 'Transfer number',
      maxDailySendCount: 'Max daily send count',
      authenticate: 'Authenticate',
      uploadDocuments: 'Upload documents',
      fromIndex: 'From index',
      aggregator: 'Aggregator',
      toIndex: 'To index',
      documentation: 'Documentation',
      textBody: 'Text body',
      editStatus: 'Edit status',
      editStatusAll: 'Edit status all',
      editStatusAllReceivers: 'Edit status all receivers',
      getNewDeliveryStatus: 'Get new delivery status',
      editReceiversStatus: 'Edit receivers status',
      editDeliveryStatus: 'Edit delivery status',
      editDeliveryStatusByExcelFile: 'Edit delivery status by excel file',
      fileUpload: 'File upload',
      yes: 'Yes',
      no: 'No',
      ok: 'Ok',
      payment: 'Payment',
      discountCode: 'DiscountCode',
      discount: 'Discount',
      success: 'Success',
      nonSuccess: 'Unsuccessful',
      total: 'Total',
      signature: 'Signature',
      header: 'Header',
      smsCp: 'SMS sender agent',
      privateNumberSignature: 'Private number signature',
      privateNumberHeader: 'Private number header',
      organizationSignature: 'Organization signature',
      organizationHeader: 'Organization header ',
      selectFile: 'Select file',
      userOrganizations: 'User organizations',
      cancel: 'Cancel',
      selectAll: 'Select all',
      all: 'All',
      allDayOfWeeK: 'All day of week',
      every: 'All',
      lat: 'Lat',
      lon: 'Lon',
      distance: 'Distance',
      importanceLevel: 'Importance Level',
      notificationType: 'Notification type',
      distanceOnKm: 'Distance(Kilometers)',
      size: 'Size',
      closeAll: 'Close all',
      nextStep: 'Next step',
      previousStep: 'Previous step',
      close: 'Close',
      roles: 'Roles',
      roleTemplate: 'Roles template',
      smsParts: 'SMS parts',
      smsText: 'SMS text',
      smsBodyText: 'SMS text',
      keyword: 'Keyword',
      resendSMS: 'Resend SMS',
      twoFactorEnabled: 'Two factor enabled',
      resendSMSByDeliverStatus: 'Resend SMS by deliver status',
      resendDetail: 'Resend detail',
      address: 'Address',
      zipCode: 'Zip code',
      myCredit: 'My credit',
      currentUserCredit: 'Current user credit',
      organizationCredit: 'Organization credit',
      updateCredit: 'Up date credit',
      status: 'Status',
      submit: 'Submit',
      confirm: 'Confirm',
      back: 'Back',
      up: 'Up',
      down: 'Down',
      sentDateTime: 'Sending Date',
      groupPriceList: 'Group price list',
      rangeList: 'Range list',
      endOfSmsBody: 'End of SMS body',
      startOfSmsBody: 'Start of SMS body',
      reporting: 'Reporting',
      reportBuilder: 'Report Builder',
      report: 'Report',
      search: 'Search',
      searchPlace: 'Social places',
      advancedSearch: 'Advance search',
      groupPrice: 'Group price',
      add: 'Add',
      privateNumberPurchaseRules: 'Private number purchase rules',
      currency: 'Rial',
      currencyWithParentheses: 'Rial',
      addUser: 'Add user',
      toman: 'Toman',
      nextLevel: 'Next level',
      sendAuthCode: 'Send authentication code',
      increaseCredit: 'Increase credit',
      decreaseCredit: 'Decrease credit',
      creditTransfer: 'Credit transfer',
      play: 'Play',
      pause: 'Pause',
      downloadFile: 'Download file',
      download: 'Download',
      downloadExcel: 'Download excel',
      downloadExcelWithMoreDetail: 'Download excel with more detail',
      generalDisplay: 'General display',
      groupPriceDetail: 'Group price detail',
      displayMode: 'Display mode',
      displayWithDetails: 'Display with details',
      udhLen: 'Persian character separator length status',
      print: 'Print',
      downloadAll: 'Download all',
      saveToCampaign: 'Save to campaign',
      authCode: 'Authentication code',
      clearAll: 'Clear all',
      clear: 'Clear',
      removeAll: 'Remove all',
      empty: 'Empty',
      confirmation: 'Confirmation',
      priority: 'Priority',
      notConfirmation: 'Not confirmation',
      clipBoard: 'Clipboard',
      onBackToPreviousAccount: 'On back to previous account',
      language: 'Language',
      darkMode: 'Dark mode',
      lightMode: 'Light mode',
      privateNumberId: 'Sender id',
      notifications: 'Notifications',
      logout: 'Logout',
      unreadMessages: 'Unread messages',
      allMessages: 'All messages',
      notificationPopup: {
        newNotification: 'New notification',
        now: 'Just now',
      },
      token: 'Token',
      resend: 'Resend',
      continuation: 'Continuation',
      sendSubmit: 'Send submit',
      quickLinks: 'Quick links',
      newQuickLink: 'New quick link',
      editQuickLink: 'Edit quick link',
      refresh: 'Refresh',
      refreshMenus: 'Refresh menus',
      menus: 'Menus',
      buy: 'Buy',
      claims: 'Claims',
      sendSms: 'Send SMS',
      editSendSms: 'Edit send SMS',
      cpType: 'sms Cp',
      specifications: 'Specifications',
      titleAndTextHelp: 'Title and Text',
      wordList: 'Word list',
      send: 'Send',
      changePassword: 'Change password',
      useType: 'Use type',
      changeOrganization: 'Change organization',
      country: 'Country',
      state: 'State',
      province: 'province',
      city: 'City',
      area: 'Area',
      mobilePrefix: 'Mobile prefix',
      bank: 'Bank',
      field: 'Field',
      owner: 'Owner',
      newFiled: 'New Field',
      defineNewField: 'Define New Field',
      SelectedPhonebooks: 'Selected phonebooks',
      clickForMoreInfo: 'Click for more info',
      help: 'Help',
      attachment: 'Attachment',
      example: 'Example',
      notFoundHelp: 'Not found help',
      mainClaim: 'Main claim',
      class: 'Class',
      minuteBetweenTries: 'Time between tries',
      transferPrivateNumber: 'Transfer private number',
      maxTryCount: 'Max try count',
      zero: 'Zero',
      parent: 'Parent',
      parentName: 'Parent name',
      database: 'Database',
      paymentAmount: 'Payment amount',
      chargeRateCredit: 'Charge rate credit',
      table: 'Table',
      recipientCount: 'Recipient count',
      apiAddress: 'Api address',
      finalConfirmation: 'Final confirmation',
      startDateSearch: 'Start date search',
      startTimeSearch: 'Start time search',
      cancellation: 'Cancel',
      cancellationRequest: 'Cancel request',
      stayRequest: 'I will wait',
      endDateSearch: 'End date search',
      endTimeSearch: 'End time search',
      dateExit: 'Date exit',
      totalSum: 'Total sum',
      currentPageTotalSum: 'Current page total sum',
      openDateFilter: 'Open date filter',
      deleteFilter: 'Delete filter',
      addRule: 'Add Rule',
      addField: 'Add Field',
      copyContent: 'Copy content',
      pasteContent: 'Paste content',
      copy: 'Copy',
      expandAll: 'Expand all',
      payable: 'Payable',
      collapseAll: 'Collapse all',
      paste: 'Paste',
      nameFa: 'Name fa',
      nameEn: 'Name en',
      transactions: 'Transactions',
      transactionKind: 'Transaction kind',
      sendType: 'Sending type',
      nowNo: 'Not now',
      succeed: 'Succeed',
      publicPlace: 'Public place',
      link: 'Link',
      fileLink: 'File link',
      shortLinkList: 'Short link list',
      smsTemplateList: 'Sms Template list',
      emoji: 'Emoji',
      optional: 'Optional',
      savePolygon: 'Save polygon',
      extraReceivers: 'Extra receivers',
      reseller: 'Reseller',
      addPublicPlace: 'Add Public Place',
      resetPassword: 'Reset password',
      isSignOut: 'Is signout',
      removeSelectedItems: 'Remove selected items',
      signInSignOut: 'SignIn/SignOut',
      emptyReceivers: 'The recipient list is empty.',
      emptyReceiversOrWrongIndex:
        'The recipient list is empty or the indexing is wrong',
      uploadFile: 'Upload file',
      uploadImage: 'Upload image',
      uploadBackground: 'Upload background',
      isConfirmed: 'Is confirmed',
      inboxGroup: 'Inbox group',
      saveNow: 'Save now',
      saveNowAfterSend: 'Save after sending',
      check: 'Check',
      myOrganizationPackages: 'My packages',
      getNewStatus: 'Get the latest status',
      guildName: 'Guild name',
      subGuildName: 'Subguild name',
      frontAudits: 'Front audits',
      pollParserInboxes: 'Poll parser inboxes',
      receiveDateTime: 'Receive DateTime',
      smsCount: 'SMS count',
      priceRial: 'Price (rial)',
      statistics: 'Statistics',
      pollParserLottery: 'Lottery',
      winnerList: 'Winner list',
      winnerCount: 'Winner count',
      addToQueue: 'Add to queue',
      ip: 'Ip',
      ipRange: 'Ip range',
      currentIp: 'Current Ip',
      appearanceSettings: 'Appearance Settings',
      formDetails: 'Form Details',
      useToCreateToken: 'Use to create token',
      useToLoginPanel: 'Use to login panel',
      running: 'Active',
      paused: 'Inactive',
      doDisable: 'Disable',
      doEnable: 'Enable',
      persianPrice: 'Persian price',
      startDateTime: 'Start date time',
      endDateTime: 'End date time',
      expireDateTime: 'Expire date time',
      englishPrice: 'English price',
      chosenSmartSmsDetail: 'Smart sms detail',
      numbersCount: 'Numbers count',
      statusDatetime: 'Status date time',
      lastUpdateDatetime: 'Last update date time',
      isNeedUserConfirmation: 'Is need user confirmation?',
      addNumbers: 'Add numbers',
      numbers: 'Numbers',
      deliveryStatusStats: 'Message delivery status statistics',
      messageDeliveryStatusStats: 'Message delivery status statistics',
      nextMonth: 'Next Month',
      previousMonth: 'Previous Month',
      groupConfirmation: 'Group confirmation',
      buyPlan: 'Buy plan',
      occasion: 'Occasion',
      calendar: 'Calendar',
      holiday: 'Holiday',
      organExpireDate: 'Organization expiration date',
      userExpireDate: ' days left until user expires ',
      chart: 'Chart',
      simType: 'Sim type',
      requestDetail: 'Request detail',
      isRandomSend: 'Is random send',
      smsPreview: 'Sms Preview',
      addToPublicPlace: 'Add to public place',
      balance: 'Balance',
      isCountTargetPassed: 'Count reached',
      isCreditTargetPassed: 'Credit reached',
      creditTargetValue: 'Final amount',
      countTargetValue: 'Number of SMS',
      times: 'Times',
      commission: 'Commission',
      partsCount: 'Number of parts',
      target: 'Target',
      encoding: 'Encoding',
      stats: 'Statistics',
      justCurrentOrganization: 'Just current organization',
      geometryType: 'Geometry type',
      grayList: 'Gray list',
      airports: 'Airports',
      requestType: 'Request Type',
      smsSendingNumber: 'Sms sending number',
      isRead: 'Is read',
      informationUsersSeen: 'Information users seen',
      receivedMessage: 'Received message',
      startTimeAtDay: 'Start time at day',
      endTimeAtDay: 'End time at day',
      update: 'Update',
      messageCount: 'Messages count',
      messageInConsumeCount: 'Message in consume count',
      regex: 'Regex',
      priceFa: 'Price(FA)',
      priceEn: 'Price(EN)',
      totalPriceFa: 'Total price(FA)',
      totalPriceEn: 'Total price(EN)',
      expandMap: 'Expand Map',
      collapseMap: 'Collapse Map',
      incomeRatePerSecond: 'Income rate per second',
      consumersCount: 'Consumers count',
      consumeRatePerSecond: 'Consume rate per second',
      duplicatedNumbersCount: 'Duplicated numbers count',
      archive: 'Archive',
      colorCode: 'Color code',
      smartSmsPercent: 'Smart sms percent',
      mtnSmartPercent: 'Mtn smart percent',
      rightelSmartPercent: 'Rightel smart percent',
      mciSmartPercent: 'Mci smart percent',
      smartSmsClubTitle: 'Smart sms club title',
      smartSmsCampaignTitle: 'Smart sms Campaign title',
      periodType: 'Period type',
      period: 'Period',
      periodValue: 'Period value',
      smartRequestType: 'Smart request type',
      grayListExpireHour: 'Gray list expire hour',
      cellList: 'Cell list',
      isSmartCountAsPercent: 'Is smart count as percent',
      smartSmsClubOperationType: 'Smart sms club operation type',
      downloadPDF: 'download PDF',
      downloadPowerPoint: 'download Powerpoint',
      downloadImage: 'download Image',
      smartRequestId: 'Request id',
      megabyte: 'Megabyte',
      kilobyte: 'Kilobyte',
      chooseTemplate: 'Choose Template',
      chooseTheme: 'Choose Theme',
      titleOfReport: 'Title of the report',
      logoUpload: 'Logo Uploader',
      imageUpload: 'Image uploader',
      campaignReport: 'Campaign Report',
      editTitleOfReport: 'Edit title of Report',
      createReport: 'Create Report',
      editBackground: 'Edit Background ',
      operators: 'Operators',
      sendStatus: 'Send status',
      readNotification: 'Read notification',
      percentage: 'Percentage',
      addTitle: 'Add title',
      showFile: 'Show files',
      addRow: 'Add row',
      socialMediaGroupPriceDetail: 'Social media group price detail',
      groupRejection: 'Group rejection',
      financialBalance: 'Financial balance',
      paymentImage: 'Payment image',
      passwordOrToken: 'Password or token',
      url: 'Url',
      aggregatorInquiry: 'Aggregator inquiry',
      blackListInquiry: 'Black lists inquiry',
      isBlackList: 'Is black list',
      isExternalBlackList: 'Is external black list',
      totalCount: 'Total count',
      getTotalCount: 'Get total count',
      startDatetime: 'Start date time',
      endDatetime: 'End date time',
      isCanSendVoice: 'Can send voice',
      activePeriodicSmartSmsRequests: 'Running campaigns',
      showMore: 'Show more...',
      isUseSeparator: 'Is use separator in number fields',
      scheduledMessagePartsCount: 'Scheduled message parts count',
      platform: 'Platform',
      endOfSessions: 'Finish the session',
      currentMeeting: 'Current session',
      numberType: 'Number type',
      sendToBlackList: 'Send to blacklist',
      deleteFilters: 'Delete filters',
      voiceMessageId: 'Voice message id',
      avanakVoiceMessageId: 'Avanak voice message id',
      isQuickSend: 'Is quick send',
      quickSendId: 'Quick send id',
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      reversePolygon: 'Reverse polygon',
      desiredPolygon: 'Coordinates of desired areas',
      checkCell: 'Check cell',
      checking: 'Checking',
      season: 'Season',
      cellsByName: 'Get cells by name',
      names: 'Names',
      stopSending: 'Stop sending',
      cellListIds: 'Cell list ids',
      isCanSendSmartWithoutConfirmation:
        'Is can send smart without confirmation',
      region: 'region',
      pricePerPart: 'Price per part',
      calculate: 'Calculate',
      smartSmsClubFileProgresses: 'Smart sms club file progress',
      downloadResellerExcel: 'Download reseller excel',
      isPercentageBenefitForInternational:
        'Is percentage benefit for international?',
      internationalBenefitValue: 'International benefit value',
      campaignStatusInGateway: 'Campaign status in gateway',
      clubStatusInGateway: 'club status in gateway',
      isCreated: 'Is created?',
      creationLocation: 'Creation location',
      startLocation: 'ُStart location',
      updateGroup: 'Update group',
      voiceGroup: 'Voice group',
      continueSendIfAnyOperatorHaveError:
        'Continue send if any operator have error',
      kibanaDashboard: 'Kibana dashboard',
      authorizationScheme: 'Authorization scheme',
      organizationsBlackListExceptions: 'Organizations black list exceptions',
      loginAudits: 'Login audits',
      alertSetting: 'Alert setting',
      htmlContent: 'HTML content',
      showDashboard: 'Show dashboard',
      smartSmsClubNumbers: 'Smart sms club numbers',
      strategies: 'Strategies',
      pointStrategies: 'Point strategies',
      pointStrategiesDetail: 'Point strategies detail',
      deviceNumbers: 'Device numbers',
      sendSmsHistory: 'SMS sending history',
      histories: 'Histories',
      strategyTitle: 'Strategy title',
      backgroundImage: 'Background image',
      form: 'Form',
      submitForm: 'Submit form',
      items: 'Items',
      newMobileNumber: 'New mobile number',
      showForm: 'Show form',
      zoomToFit: 'Zoom to fit',
      reload: 'Reload',
      if: 'If',
      then: 'Then :',
      singleDelete: 'Single delete',
      deleteWithChildren: 'Delete with children',
      ifValue: 'Value :',
      responses: 'Responses',
      userResponses: 'User responses',
      smsResponses: 'SMS responses',
      formManagementSmsResponses: 'Form management SMS responses',
      fieldType: 'Field type',
      answerResponse: 'Answer response',
      duplicationResponse: 'Duplication response',
      mobiles: 'Mobiles',
      emptyMobiles: 'Empty mobiles',
      addFromExistingFields: 'Add from existing fields',
      questionTitle: 'Question title',
      copyLink: 'Copy link',
      isPostPaid: 'Is post paid',
      word: 'Word',
      score: 'Score',
      rank: 'Rank',
      addMobile: 'Add mobile',
      notValidAnswersResponse: 'Not valid answers response',
      expiringOrganizationsCount: 'Number of expiring organizations',
      expiringUsersCount: 'Number of expiring users',
      expiringPrivateNumbersCount: 'Number of expiring lines',
      suspendedUsersCount: 'Number of suspended users',
      unAuthorizedUsersCount: 'Number of unauthenticated users',
      waitForConfirmApiTokensCount: 'Number of tokens being verified',
      notActiveLandingPagesCount: 'Not active landing pages count',
      notActiveShortLinksCount: 'Not active short links count',
      waitForConfirmOtpsCount: 'Number of otps being verified',
      waitForConfirmPaymentsCount: 'Number of offline payments being verified',
      waitForConfirmSafeIpsCount: 'Number of IPs being verified',
      waitForConfirmScheduledMessagesCount:
        'Number of messages awaiting confirmation',
      canceledNotResentLocalNetworkOutboxMessageCount:
        'Registered messages with number 999999',
      totalRecipients: 'Total recipients',
      suggestedStrategies: 'Suggested strategies',
      marketingAchievement: 'Marketing achievement',
      requestBody: 'Request Body',
      apiResponse: 'Responses',
      parameters: 'Parameters',
      location: 'Location',
      chequeImage: 'Cheque image',
      logoUploader: 'Upload logo',
      completeOperation: 'Complete operation',
      recordVoice: 'Record voice',
      delayType: 'Send delay type',
      delayValue: 'Send delay amount',
      showsForChildrenOrganizations: 'Shows for children organizations',
      organizationIdsForHide: 'Valid children organization ids',
      googleSheetsSettings: 'Google sheets settings',
      spreadSheetId: 'Spread sheet id',
      crmAccessKey: 'Crm access key',
      crmUserName: 'Crm user name',
      enableSaveResponseInCrm: 'Saving responses in CRM',
      crmField: 'CRM field',
      lostUsersPercent: 'Lost users percent',
      totalUsersCount: 'Total users count',
      usersStatistics: 'Users statistics',
      strategiesStatistics: 'Strategies statistics',
      customerCount: 'Customer count',
      person: 'Person',
      buttonTitle: 'Button title',
      firstPartOfGradualOrPeriodic: 'First part of gradual or periodic',
      userNotificationSettings: 'User notification settings',
      organizationNotificationSettings: 'Organization notification settings',
      notificationSetting: 'Notification setting',
      notificationSettingDescription:
        'Manage how you receive notifications; click an item to edit its settings',
      enableSmsNotification: 'Enable sms notification',
      enablePanelNotification: 'Enable panel notification',
      mobilesForReceiveSmsNotification: 'Mobiles for receive sms notification',
      senderPrivateNumber: 'Sender private number',
      botId: 'Bot id',
      isSendBulk2: 'Is send bulk2',
      isSendBulk: 'Is send bulk',
      fuzzyMatch: 'Fuzzy match',
      forPreProcess: 'For pre process',
      semanticMatch: 'Semantic match',
      newChat: 'New chat',
      chatList: 'Chat list',
      newConversation: 'New conversation',
      changeTitle: 'Change title',
      newChatDescription: 'What would you like to learn more about?',
      enterMessage: 'Enter your message...',
      daysAgo: '{{day}} days ago',
      today: 'Today',
      functionality: 'Functionality',
      assignStatusToUser: 'Assign status to user',
      isHaveCells: 'Is have cells',
      isValidArea: 'Is valid area',
      ussdCode: 'Ussd code',
      showChat: 'Show chat',
      shortLinkReceivers: 'Short link receivers',
      shortLink: 'Short link',
      toNumber: 'To number',
      chooseDate: 'Choose date',
      regenerateApiTokenSecretKey: 'Regenerate api token secret key',
      shortLinkCampaignPublicReport: 'Short link campaign public report',
      isGatewayCredit: 'Is gateway credit',
      validate: 'validate',
      landingPageShortUrl: 'Landing page short url',
      shortLinkStats: 'Short link stats',
      map: 'Map',
      newVersion: 'New version',
      oldVersion: 'Old version',
      enableCampaign: 'Enable Campaign',
      disableCampaign: 'Disable Campaign',
      serverResponses: 'Server responses',
      sendDetail: 'Send detail',
      sendSmartSms: 'Smart send',
      card: 'Card',
      cardDisplay: 'Card display',
      imagePath: 'Image path',
      redirectLink: 'Redirect link',
      videoPath: 'Video path',
      confirmationStatus: 'Confirmation status',
      processTextResultStatus: 'Process text result status',
      processTextResults: 'Process text results',
      aiAssistant: 'AI Assistant',
      aiExperimental: 'Experimental',
      aiGenerate: 'Generate with AI',
      aiRewrite: 'Rewrite with AI',
      aiTone: 'Message Tone',
      aiLength: 'Message Length',
      aiFidelity: 'Rewrite Fidelity',
      aiGenerateAction: 'Generate',
      aiRewriteAction: 'Rewrite',
      aiResult: 'Generated Text',
      aiCharacterCount: 'Characters',
      aiCopy: 'Copy text',
      aiCopied: 'Copied',
      aiUseResult: 'Use This Text',
      aiDescription: 'Text Description',
      aiDescriptionPlaceholder:
        'Enter the topic or description of your desired message...',
      aiAssistantDescription:
        'Create a message or rewrite it while preserving its meaning',
      aiGenerateDescription:
        'Describe the topic, goal, or key points of your message',
      aiRewriteDescription:
        'Enter your current text to receive a clearer version',
      aiRewritePlaceholder: 'Enter the message you want to rewrite...',
      aiOptional: 'Optional',
      aiSelect: 'Select',
      aiNone: 'None',
      aiFidelityCreativeDescription:
        'More freedom to change the structure and wording',
      aiFidelityBalancedDescription:
        'Balances fresh wording with the original meaning',
      aiFidelityFaithfulDescription:
        'Stays closest to the original text and meaning',
      addEmoji: 'Add emoji',
      aiEmojiDescription: 'Use emoji in the message when appropriate',
      aiOptionsLoading: 'Preparing message options...',
      aiOptionsUnavailable:
        'Some options could not load; you can still continue.',
      aiProcessing: 'The AI assistant is preparing your message',
      aiTryAgain: 'Try Again',
      aiGenerateAgain: 'Generate Again',
      aiRewriteAgain: 'Rewrite Again',
      aiBusinessCategory: 'Business Category',
      aiBusinessCategoryPlaceholder:
        'For example: clothing, travel, or education',
      aiBusinessCategoryDescription:
        'Your business category helps create a more relevant message.',
      aiFeedbackTitle: 'How useful was this suggestion?',
      aiFeedbackDescription: 'Your feedback helps improve future suggestions.',
      aiFeedbackScore: 'Feedback score',
      aiFeedbackScoreValue: 'Score {{score}} out of 5',
      aiFeedbackTerrible: 'Terrible',
      aiFeedbackBad: 'Bad',
      aiFeedbackNotBad: 'Not bad',
      aiFeedbackGood: 'Good',
      aiFeedbackExcellent: 'Excellent',
      aiFeedbackPlaceholder:
        'Add more details about this suggestion (optional)...',
      aiFeedbackSubmit: 'Submit Feedback',
      aiFeedbackThanks: 'Your feedback was submitted',
      aiFeedbackSubmitted:
        'Your displayed daily limit has increased to 6 requests.',
      aiFeedbackError: 'Feedback could not be submitted. Please try again.',
      aiTodayRemainingRequests: 'Requests remaining today:',
      aiTodayUsedRequests: 'Today’s usage: {{used}} of {{total}} requests',
      aiDailyLimit: 'Usage limit: 5 requests per day',
      aiDailyLimitWithFeedback: 'Usage limit: 6 requests per day',
      aiDailyLimitDescription:
        'Submitting at least one feedback increases the daily limit from {{currentLimit}} to {{increasedLimit}}.',
      upgradeLevel: 'Upgrade Level',
      authorizationLevel: {
        confirmedByShahkar: 'Confirmed by Shahkar',
        shahkarAdditionalInfoCompleted: 'Shahkar Additional Info Completed',
        documentsConfirmed: 'Documents Confirmed',
        enterprise: 'Enterprise',
      },
      organizationWhichCanUse: 'Allowed organizations to use',
    },
    messages: {
      dashboardCard: {
        bannerHint:
          'If both a video link and an image path are provided, the image will be used as the video poster.',
        defaultHint:
          'In this mode, the default project card is displayed, containing information about the logged-in user and organization.',
        noneHint: 'In this mode, the card will not be displayed.',
      },
      clipboard: {
        message: 'Click to copy',
        copied: 'Copied',
        copy: 'Copy',
        copyCardNo: 'Copy card number',
        copyIban: 'Copy IBAN',
        copyAccountNo: 'Copy account number',
        copyAmount: 'Copy amount',
      },
      htmlStatus: {
        code400: 'Invalid request',
        code401: 'Inaccessibility',
        code403: 'Inaccessibility',
        code404: '404',
        code405: 'Error',
        code500: 'Server error',
        code400Msg: 'Your request has encountered a problem',
        code401Msg: 'To continue the process, you need to log in first',
        code403Msg:
          'Dear user, you do not have permission to access this section',
        code405Msg: 'Sending error',
        code500Msg: 'There was a problem communicating with the server.',
      },
      validationError: {
        minLength:
          '<b>{{title}}</b> must be at least <b>{{minLength}}</b> characters',
        maxLength:
          '<b>{{title}}</b> must be at most <b>{{maxLength}}</b> characters',
        min: 'The value of <b>{{title}}</b> must not be less than <b>{{min}}</b>',
        max: 'The value of <b>{{title}}</b> must not exceed <b>{{max}}</b>',
        invalid: 'The mobile number is invalid',
        fieldIsInvalid: '<b>{{title}}</b> is invalid',
        required: 'Filling the <b>{{title}}</b> field is mandatory',
        globalRequired: 'Filling the field is mandatory',
        invalidEmail: 'The email address is not valid',
        maxFileSizeInMb:
          'The maximum file size allowed for uploading is {{size}} megabytes',
        maxFileSizeInKb:
          'The maximum file size allowed for uploading is {{size}} kilobytes',
        allowedFilTypes: 'Files with {{types}} extensions are allowed',
        confirmPassword: 'The repeated password does not match the password',
        allowedFilTypesTip: 'Allowed formats',
        fileMaxLengthInKB: 'File max length in kb',
        fileMaxLengthInGB: 'File max length in gb',
        validFileTypes: 'Valid file types',
        fileMaxLength: 'File max length',
        maxFileCount: 'Max file count is {{ count }}.',
        addAtLeastOneOption: 'Add at least one option',
        endDateShouldBiggerThanStartDate:
          'End date should be bigger than start date',
      },
      timeoutError: 'Timeout error',
      sendMessageHelp:
        '<p class="mt-3 mb-1">⁃ If you need an HTML tag, write it in parentheses. For example: (p)</p><p class="my-1">⁃ To preview the final SMS content, click on the <b>Preview SMS</b> button.</p><p class="my-1">⁃ An SMS template is a predefined structure for sending messages. To view, edit, or add new templates, use the <b>SMS Templates</b> list.</p><p class="my-1">⁃ To quickly and accurately insert a link into the SMS text, use the <b>Short Links</b> list.</p><p class="my-1">⁃ The SMS headline is the text displayed at the beginning of the message; to add it, use the <b>SMS Headline</b> option.</p><p class="my-1">⁃ The SMS signature is a fixed text displayed at the end of the message; to insert it, use the <b>SMS Signature</b> option.</p>',
      selectedFilters: 'Selected filters',
      selectedLoginPageTemplate:
        'Please select the login page template you want :',
      fewMinutesAgoWithMin: '{{min}} minutes ago',
      hoursAndMinutesAgo: '{{hours}} hours and {{minutes}} minutes ago',
      hoursAgo: '{{hours}} hours ago',
      daysAndHoursAndMinutesAgo: '{{days}} days and {{hours}} hours ago',
      daysAgo: '{{days}} days ago',
      monthsAgo: '{{month}} months ago',
      yearsAgo: '{{year}} years ago',
      momentsAgo: 'Moments ago',
      fewMinutesAgo: 'A few minutes ago',
      allowedFileTypesMsg:
        'Allowed file formats are: png, jpg, jpeg, mp3, wav.',
      isCanSendVoiceMessage:
        'The agent of transmissions with <i class="mdi mdi-volume-high text-blue-500 dark:text-blue-400mdi-22px"></i> displayed next to them is the voice transmission line.',
      markReadAllNotifications: 'Mark read all notifications',
      sendTicketToSupport: 'Send ticket to support',
      statisticsDoughnutChartText: 'Total number of text messages sent.',
      statisticsBarChartText:
        'The number of text messages sent based on the time of sending.',
      clipBoardAndFileUploadWarning:
        'Note that it is not possible to use <b>file upload</b> and <b>clipboard</b> modes in combination. <br> <br> Information is recorded in <b class="text-red-500 dark:text-red-400">{{modeWithDataTitle}}</b> mode. By going to <b class="text-red-500 dark:text-red-400">{{modeTitle} mode }</b> This information will be deleted. However, you are safe to go into <b class="text-red-500 dark:text-red-400">{{modeTitle}}</b> mode',
      minlengthValidationError:
        '{{title}} length should not be less than {{minLength}} digits.',
      maxlengthValidationError:
        '{{title}} must not exceed {{maxLength}} digits.',
      minValidationError: '{{title}} must not be less than {{min}}.',
      maxValidationError: '{{title}} must not exceed {{max}}.',
      minNumberValidationError: '{{title}} must not be less than {{min}}.',
      maxNumberValidationError: '{{title}} must not exceed {{max}}.',
      maxMobileNumbers:
        'You can register a maximum of .{{maxMobileNumbers}}mobile numbers',
      maxMobileNumbersInManualMode:
        'In manual mode, you can register a maximum of {{maxMobileNumbersInManualMode}} mobile numbers.',
      maxMobileNumbersInClipBoardMode:
        'In clip board mode, you can register a maximum of {{maxMobileNumbersInClipBoardMode}} mobile numbers.',
      deleteMessage: 'Are you sure you want to delete this item?',
      deleteMenuMessage: 'Are you sure you want to delete this menu?',
      deleteEndPointMessage: 'Are you sure you want to delete this endpoint?',
      confirmByWritingTextMessage:
        'By deleting this item, all subcategories and associated saved data will be deleted',
      confirmByWritingTextMessageForStopSending: 'Sending will stop',
      directLineTargets:
        'In this section, you can specify which of the following items should use the system line for sending messages.',
      cellListMessage:
        'The following operators are supported in the selected area, if the operator you want is not in the list below, it is suggested to change or enlarge your coordinates.',
      confirmText: 'Confirm text',
      confirmPayment: 'Confirm payment',
      rejectPayment: 'Reject payment',
      cancelProformaInvoice: 'Are you sure to cancel this proforma invoice?',
      rejectSend: 'Are you sure to reject this send?',
      allExcelReport: 'All excel report',
      pageExcelReport: 'Page excel report',
      pageTxtReport: 'Page text report',
      allTxtReport: 'All text report',
      changePasswordMsg:
        'Dear user, you need to change your password to keep your account safe',
      verificationCodeIsInvalid: 'The verification code is invalid',
      textMaxLength: 'Text max length',
      textMaxLengthInManualMode: 'Text max length in manual mode',
      textMaxCorrectMobileNumberCountInManualMode:
        'Text max correct mobile number count in manual mode',
      validMediaTypes: 'Valid media file types',
      successfulOperation: 'Successful operation',
      periodDateTimeErrorMsg:
        'When the start date and end date are equal, the start time cannot be greater than the end time.',
      failedOperation: 'Failed operation',
      OptimalSearch: 'Optimal search',
      currencyAlert: 'Currency alert',
      contentIsInvalid: 'Content is invalid',
      searchInOrganizations: 'Search in organizations',
      searchInRoles: 'Search in roles',
      insertMobile: 'Insert mobile',
      searchAggregator: 'Please enter the mobile number and then click search',
      isValidNumber: 'Please enter the mobile number and then click confirm',
      searchInUsers: 'Search in users',
      searchInPrivateNumbers: 'Search in private numbers',
      searchInPhonebooks: 'Search in the phone book',
      searchInContacts: 'Search contacts',
      searchInTargetPrivateNumbers: 'Search target private numbers',
      searchText: 'Search Text',
      enterSocialnetworkIdPlaceHolder: 'Enter Id',
      showSearch: 'Show search',
      isAddSignature: 'Is add signature',
      quitMsg: 'Do you want to log out of your account?',
      logoutConfirmMsg: 'Are you sure you want to logout?',
      hideSearch: 'Close the filters',
      imageNotUploaded: 'Image not uploaded',
      fileNotUploaded: 'File not uploaded',
      fileIsInvalid: 'File is invalid',
      maxIpTotalCount: '*You can choose a maximum of 15 IPs',
      noExistOrganization: 'No exist organization',
      filterByGroup: 'Filter by group',
      updateCreditMessage: 'Click to update credit',
      separateByEnter: 'Separator with enter key',
      separateByCommaAndEnter: 'Delimiter with comma or enter key',
      removeContactFromAllPhonebook: 'Removed from all groups',
      chipListPlaceholder: 'Delimiter with comma or enter key',
      confirmPassword: 'Password and repassword doesnt match!',
      invalidDateErrorMsg: 'This service has expired.',
      invalidDateErrorMsgInSend:
        'Dear user, the registered date or time of sending has expired. To send SMS, reset the date and time of sending.',
      invalidMinDate:
        'The date must be greater than the current date or equal to the previously selected date',
      maxOpenTab: 'Max open tab',
      unblockUserMessage: 'Are you sure to unblock this user?',
      noConnectionToServer: 'No connection to server',
      accountDeactivatedTitle: 'Your account has been deactivated',
      accountDeactivatedDescription:
        'Your account has been deactivated because your identity verification was not approved. Please contact support for follow-up and assistance.',
      planExpiredTitle: 'Your plan has expired',
      planExpiredDescription:
        'Your plan has expired and your access to the panel is now limited. To continue using our services, please purchase a new plan.',
      accessRestricted: 'Your access has been limited',
      planExpiringSoonTitle: 'Your current plan is about to expire',
      planExpiringSoonMessage:
        'To avoid any interruption in our services, we recommend purchasing your new plan before the current one expires.',
      planRemainingDays: 'Only {{count}} days remain until your plan expires.',
      planRemainingHours:
        'Only {{count}} hours remain until your plan expires.',
      notOrganization: 'Not organization',
      expired: 'Expired',
      expiredAccountMessage: 'Dear user, your account has expired.',
      notActiveOrganization: 'Not active organization',
      expireOrganization: 'Expired organization',
      globalConfirmationMessage: 'Are you sure about this operation?',
      archiveConfirmationMessage: 'Are you sure to archive this item?',
      notAuthenticated: 'Not authenticated',
      fullTextDisplay: 'Full text display',
      clickToSeeDetails: 'Click to see details',
      resendMessageConfirmation: 'Resend message confirmation',
      groupDeletionConfirmation: 'Group deletion confirmation',
      deleteAllContactConfirmation: 'Delete all Contact confirmation',
      apiTokenconfirmation: 'Are you sure to approve this token?',
      apiTokenUndoconfirmation: 'Are you sure that this token is not approved?',
      selectItems: 'Select items',
      eventTitle: 'There is no explanation for this occasion',
      mapHelp:
        '<b>map tools</b> </br> Zoom in (enlarge the map)</br> zoom out (shrink the map) </br> register coordinates (register the selected area) </br> polygon tool ( The tool for selecting the range on the map, which requires at least 3 points to be selected to determine the range) </br> delete (delete the selected range) </br> To edit, click on the selected range and limit it by the points that appear. edit the </br> You can also add more areas (points) to your area by selecting the middle points',
      excelColListError: 'Excel col list error',
      notRegistered: 'Not registered',
      loginToYourAccount: 'Sign in to your account',
      loginPageWelcome: 'Professional messaging on one platform',
      secureLogin: 'Secure login',
      fastAccess: 'Fast access',
      notLoggedIn: 'Not logged in',
      isValidIfConditionType: 'Is valid if condition type',
      isInvalidNumber: 'Invalid number',
      forgetPassword: 'Forget password',
      passwordRole: 'Password role',
      minLength:
        'The length of {{formFieldName}} must not be less than {{minLength}} characters.',
      selectFileFromFileManager: 'Please select a file',
      loginImage: 'Uploading login page images:',
      emptyWordList: 'The word list is empty',
      notSelectAnyOrganization: 'No organization selected',
      ifNumberIsNotServiceSmsWillNotBeSentToBlackList:
        'If number is not service SMS will not be sent to blacklist',
      deActiveAuthentication:
        'If you continue to edit, {{userName}} authentication will be disabled and the administrator must confirm {{userName}} account again. are you sure?',
      selectPrivateNumberForPhonebooks: 'Select private number for phonebooks',
      selectPrivateNumberForAllNotificationSettings:
        'Select the sender private number for all notification settings.',
      selectPrivateNumberForNotificationSetting:
        'Select the sender private number for this notification setting.',
      selectOrganizationForRoles: 'Select the organization to view the roles.',
      contactImportFromExcelMaxLength:
        'The maximum number of users allowed to register is {{maxLength}}.',
      inGroup: 'In group',
      requiredUserIds: 'User id is required',
      requiredPrivateNumbers: 'Required private numbers',
      requiredMsg: 'At least one selection is required.',
      deleteFromPhonebooks:
        'Please note that if the entered mobile number exists in another group, if you select that group, the number being registered will not be added to the current group.',
      sendingSms: 'Sending SMS',
      creatingCampaign: 'Creating campaign',
      generateRandomPassword: 'Generate Random Password',
      calcSmsPrice: 'Calculating sending cost',
      pleaseWaiting: 'Please wait...',
      err404Msg: 'sorry,we couldn`T find this page !',
      enterYourText: 'Enter your text',
      isExistFilePatch:
        '<p>Click on the play button to complete the text to audio conversion process.</p> <p>The audio file is required.</p>',
      maxReceiversMsg: 'You can add a maximum of {{number}} numbers.',
      statusListMsg: 'The situations that include this option are',
      onlyJpegAndPngAreAllowed:
        'Only files with the extension jpeg, jpg, png are allowed',
      maxSizeIs1mb: 'The maximum size of each file should not exceed 1 MB',
      receiversExcel: 'Please enter the title of the Excel file',
      successfulPurchase: 'Your purchase was successful',
      successfulDiscount: 'The discount code has been applied successfully',
      notEnoughCredit: 'Your credit is not enough',
      ruleConfirmation:
        'While carefully studying and being aware of the terms and conditions, I made the purchase and accepted the terms',
      privateNumberPurchaseRulesTitr:
        'The content of text messages must comply with the following principles and rules',
      organizationInfo: 'Organization Info',
      userInfo: 'User Info',
      planInfo: 'Plan Info',
      daysLeftUntilExpires: 'Days left until expires',
      hoursLeftUntilExpires: 'Hours left until expires',
      buyPlanUserInfoNotice:
        'Dear user, in order to buy a plan, you must be registered on the site. If you have already registered, log in to your account.',
      enterAuthCode: 'Enter the verification code',
      cancelRequest:
        '<span>Your request is being processed,<br>It may take some time.</span>',
      noTextForShow: 'There is no text for display!',
      sendersListAlert:
        '<span><p>● Dear user, to view the senders, you can enter your desired option first.</br>● If you have not selected any option, the list of all senders will be displayed.</p></span>',
      lotteryAlert:
        '<span> Dear user, you can choose the option you want for the lottery, so that the lottery will take place among the people who have chosen this option.</span>',
      lotteryNotStart:
        'In order to do the lottery, specify the number of winners, then click on the lottery button.',
      addToQueue: 'Are you sure to add this message to queue?',
      getCurrentIpHelp1: '* You can use',
      getCurrentIpHelp2: 'To get the current IP',
      wrongIndex: 'Wrong index',
      rangeDetail:
        'Be careful to choose a digit larger than the last digit of the IP address for the IP range',
      selectPolygon: 'Please select a polygon.',
      disableMapInSmartSms:
        'In this type of smart sending request, selecting the range from the map is disabled',
      disableMapInSmartSmsDetail:
        'In this type of smart sending request, the map is disabled',
      smartPeriodicMessage:
        'Dear user, please note that if you select more than one region, the number of submissions you enter in the relevant field will be considered separately for each region.',
      socialMediaSizeRangeMessage: 'File size based on Kilobytes',
      dragFile: 'Drag or choose a file',
      pasteInfinite: 'Click on the button to insert infinity.',
      mapOfTheCampaignLocation: 'Map of the campaign location',
      TheNumberOfSMSSentByOperator: 'The number of SMS sent by operator',
      theNumberOfSMSSentByStatus: 'The number of SMS sent by status',
      smsBodyContainsHeaderOrSignature: 'Sms body contains header or signature',
      clickToShowFile: 'Click to show full file',
      forbiddenCharacters:
        'Using {{forbiddenCharacters}} characters are forbidden in sms text',
      activePeriodicSmartSmsRequestsDescription:
        'The following table displays the list of the latest active campaigns running by the user',
      isUseSeparatorChangeMessage:
        'By changing this option, the page will be reloaded',
      reversePolygonAlert:
        'If you do not need the current coordinate on map please delete it and then use the reverse polygon',
      noCellMessage: 'No cell in the area with selected operator',
      wrongCellList: 'Cell list is wrong',
      emptyMobileNumbers: 'Mobile numbers list is empty',
      periodicPatterns:
        'The list of templates is provided below, you can choose the template of the desired day.',
      changePeriodicPatterns:
        'Note that all selected days will be deleted if the pattern is changed.',
      choosePeriodicPattern: 'Choose periodic pattern',
      showCalender:
        'Click on the calendar display button to select the template and sending days.',
      chooseDaysFromCalender:
        'In order to display and select the sending days, click on the calendar display button.',
      defaultDaysOfWeekIsSelected:
        'By default, all days of the week of the selected period are considered',
      rejectUserSafeIp: 'Are you sure to reject ip? ',
      confirmUserSafeIp: 'Are you sure to confirm ip?',
      useTag:
        'If you want to use an HTML tag, write it in parentheses. For example: (p)',
      searchInModels: 'Search in models are case sensitive.',
      isForceSearch: 'To get result in this menu, please search items first.',
      selectNumberFirst: 'Select number first',
      patternFieldHint:
        'Please use regex without / in this field. For example: ^d+$',
      bulkRecipientsLimitation: 'Selected areas should lower than {{count}}.',
      changeThenConditionTypeMessage: 'changeThenConditionTypeMessage',
      smartSignatureMessage: 'Smart signature message',
      messageTemplateGuide:
        'To select an SMS template, please choose an SMS group first.',
      forbiddenVoiceAndSocialSend: 'Forbidden voice and social send',
      clipBoardAndManualCells: 'clipBoardAndManualCells ',
      namesRegistered: 'names registered',
      outboxAdvancedSearchHelp: 'Outbox advanced search help',
      selectRowFirst: 'Select row first',
      editEndpointMsg: 'Click on an endpoint to view details or edit it.',
      groups: 'groups',
      menu: 'menu',
      noMobileErrMsg: 'No mobile err msg',
      quickLinksMsg:
        'To save a tab with filters, simply copy its address and save it with a name of your choice. Note that clearing your browser cache will also delete this information.',
      formBuilderDescription:
        'Please review the form below carefully and enter the requested information.',
      chooseThemeAndLogo:
        'Please choose a theme color and upload your desired logo.',
      formBuilderReload: 'Reload form page',
      formBuilderReloadAfterFinish: 'Reload the form page after it finishes',
      mobileNumberRequired: 'Entering a mobile number is required',
      dynamicSmsBodyGuide:
        'To set the text of the SMS, you can select the desired column by clicking it from the column list. Also, to move the columns in the blue box, grab the column and move it. It should be noted that to add the desired text, you can type your desired text into the desired text field and add your text to the SMS by pressing the Add button.',
      redirectToOnlineGateway: 'Redirect to online gateway.Please wait...',
      webhookDescription:
        'The webhook method must be GET, and the parameters To, From, and Text should be passed via Query String.',
      chatBotLoadingMessages: {
        msg1: 'Preparing response 📝',
        msg2: 'Processing ...⚡',
        msg3: 'Checking ... 🚀',
        msg4: 'Checking information ... ⏳',
        msg5: 'Analyzing your request 🔍',
      },
      confirmChatBotSwitch:
        'The chat is currently receiving responses. This process will be stopped by entering another chat. Are you sure?',
      prefixHint: 'Prefix hint',
      enterDates: 'Enter end date and time',
    },
    components: {
      mobilesAnalysis: {
        addTitle: 'Add to blacklist',
        wrongMobileNumbers: 'Wrong mobile numbers',
        listOfMobileNumbers: 'List of mobile numbers',
        alertPart1: 'Maximum show count is {{ size }}, for show more numbers',
        alertPart2: 'Click',
        downloadText: 'Download text file',
        downloadExcel: 'Download excel file',
        correctNumbers: 'Correct numbers',
        wrongNumbers: 'Wrong numbers',
        manualAddDescription:
          '<p class="mt-3 mb-1">⁃ To manually add mobile numbers, please enter the desired numbers in the field below.</p><p class="my-1">⁃ The system intelligently detects and saves valid numbers. Invalid or incorrectly entered numbers will be shown in the “Incorrect Numbers” section.</p><p class="my-1 text-red-500 dark:text-red-400 font-medium">⁃ Duplicate numbers are automatically removed and do not require manual action.</p><p class="my-1">⁃ Please note that in manual entry mode, a maximum of <b>{{number}}</b> mobile numbers can be registered.</p><p class="my-1">⁃ If youre entering a large quantity of numbers, it is recommended to use the <span class="text-blue-500 dark:text-blue-400 font-medium">{{clipBoard}}</span> section for easier pasting.</p>',
        uploadAddDescription:
          '<p class="mt-3 mb-1">⁃Only files with the extension(s) <b>{{fileTypes}}</b> are allowed for upload.</p><p class="my-1">⁃The maximum file size allowed for upload is <b>{{maxFileSize}} MB</b>.</p><p class="my-1 text-red-500 dark:text-red-400 font-medium">⁃Please note that the first row of the Excel file will not be processed; it is recommended to use it solely for column headers.</p><p class="my-1">⁃When preparing the file, make sure to enter the recipients phone numbers <b>only</b> in the first column.</p><p class="my-1">⁃Column headers must be of type text and written in English letters.</p><p class="my-1">⁃To download the sample file, please <a class="font-bold cursor-pointer" href="/assets/media/sample/sample.xlsx" download="sampleMobiles.xlsx" id="linkIdSampleMobiles">click here</a>.</p><p class="my-1 text-red-500 dark:text-red-400 font-medium">⁃Duplicate mobile numbers will be automatically removed.</p><p class="my-1">⁃Please note that the maximum number of mobile numbers you can submit is <b>{{maxMobileNumbers}}</b>.</p>',
        clipBoardAddDescription:
          '<p class="my-1">⁃ To add mobile numbers, you can paste the numbers from your clipboard into the field below.</p><p class="my-1">⁃ The system will intelligently detect and save valid numbers. Invalid or incorrectly formatted numbers will be shown in the “Invalid Numbers” section.</p><p class="my-1 text-red-500 dark:text-red-400 font-medium">⁃ Duplicate numbers will be automatically removed, so manual action is not required.</p><p class="my-1">⁃ Please note that in clipboard mode, you can register up to <b>{{maxMobileNumbers}}</b> mobile numbers.</p>',
        pasteNumber:
          'Paste your numbers here by pressing <span class="text-primary text-[13px] font-semibold"> (Ctrl + V) </span> or clicking on the key <i class="mdi mdi-clipboard-arrow-down-outline text-primary mdi-18px mt-1"></i>.',
        numberRegistered:
          '<span class="text-green-500 dark:text-green-400"><b class="text-[14px] font-black">{{mobileNumbersCountInClipboardMode}}</b> number registered .</span>To view <span class="font-medium">{{downloadFile}}<i class="mdi mdi-tray-arrow-down mdi-18px text-gray"></i></span> click on download file.',
      },
      dynamicGrid: {
        props: {
          fromIndex: 'From index',
          sendCount: 'Send count',
          Count: 'Count',
          age: 'Age',
        },
        smartSendConfirmation: {
          sendProperties: 'Send properties',
          price: ' The amount of each SMS ',
          irr: 'Rial',
          polygonCalculatedPrice: 'Shopping cost range  ',
          sendTotalPrice: 'Total cost',
          sendTotalPriceDesc: 'The cost is estimated based on a text message',
          NextStep: 'Send SMS ',
        },
        domainForm: {
          imageUploaderHelpForLoginWithCarousel:
            '<p class="mt-3 mb-1 text-base"> ⁃ The uploaded image must be in <b>jpg ، png and jpeg </b> format .</p> <p class="my-3 text-base"> ⁃ It is recommended that the image size be <b>4006px * 2116px</b></p> <p class="my-3 text-base"> ⁃The margins of the image should be <b>378px</b> from the top and bottom, and <b>756px</b> from the right and left .</p><p class="my-3 text-base">⁃ The maximum file size for the image is <b>1MB</b>.</p>',
          imageUploaderHelpForRightOrCenterLogin:
            '<p class="mt-3 mb-1 text-base"> ⁃ The uploaded image must be in <b>jpg ، png and jpeg </b> format .</p> <p class="my-3 text-base"> ⁃ It is recommended that the image size be <b>1133px * 604px</b> </p><p class="my-3 text-base">⁃ The maximum file size for the image is <b>1MB</b>.</p>',
        },
      },
    },
    shared: {
      components: {
        smsTemplateModal: {
          chooseTemplate:
            'By pressing the <span class="text-blue-500 dark:text-blue-400 font-bold">Select</span> key, you can select a template as the text of the message.',
        },
      },
    },
  },
};
